webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHdpZHRoPSI0OCI+PHBhdGggZD0iTTE4LjkgMzUuOTVRMTguNDUgMzUuOTUgMTguMDI1IDM1Ljc3NVExNy42IDM1LjYgMTcuMjUgMzUuMjVMOC4yIDI2LjJRNy41IDI1LjUgNy41IDI0LjVRNy41IDIzLjUgOC4yIDIyLjhROC45IDIyLjEgOS44NzUgMjIuMVExMC44NSAyMi4xIDExLjYgMjIuOEwxOC45IDMwLjFMMzYuNCAxMi42NVEzNy4xIDExLjk1IDM4LjA3NSAxMS45MjVRMzkuMDUgMTEuOSAzOS43NSAxMi42NVE0MC40NSAxMy4zNSA0MC40NSAxNC4zNVE0MC40NSAxNS4zNSAzOS43NSAxNi4wNUwyMC41NSAzNS4yNVEyMC4yIDM1LjYgMTkuNzc1IDM1Ljc3NVExOS4zNSAzNS45NSAxOC45IDM1Ljk1WiIvPjwvc3ZnPg=="

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2 */,
/* 3 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDcuMS1jMDAwIDc5LmVkYTJiM2ZhYywgMjAyMS8xMS8xNy0xNzoyMzoxOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIzLjEgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QjkwOENDREJBODFEMTFFQzg0QTI5OEU4NzIxNDcxRDMiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QjkwOENDRENBODFEMTFFQzg0QTI5OEU4NzIxNDcxRDMiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpCOTA4Q0NEOUE4MUQxMUVDODRBMjk4RTg3MjE0NzFEMyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpCOTA4Q0NEQUE4MUQxMUVDODRBMjk4RTg3MjE0NzFEMyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PqyfLTAAAAAQSURBVHjaYvj//z8DQIABAAj8Av7bok0WAAAAAElFTkSuQmCC"

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4FpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NDkxMSwgMjAxMy8xMC8yOS0xMTo0NzoxNiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo5MTgzNGFhNS05OTJkLTRhODgtODljYy02MjczNWMzNTc2MjAiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MTAwMTIwMTk3NzdFMTFFN0JDODFBMDYwRTgzRUI1MjAiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MTAwMTIwMTg3NzdFMTFFN0JDODFBMDYwRTgzRUI1MjAiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChNYWNpbnRvc2gpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6ZjBlZDkwMzEtMzMwOC00ODEwLThkMGUtMGFjYjlmYzJmMmJlIiBzdFJlZjpkb2N1bWVudElEPSJhZG9iZTpkb2NpZDpwaG90b3Nob3A6NTAzMzUzOWYtOWFlZC0xMTdhLTk4OWEtYjk4MjMzMTA3YWVmIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+4s5aqQAAAP9JREFUeNqsVLsRwjAMDZ8BwgSECfAIGSEjZISMkBEYwSNkhIzgkjJ0lKajA+dO4R5CkR1Ad+/8k2T9V1mc8gBD+z77A7mAB6GJMa8TFB6ZtSptlLcyoAV3RzrQeg64L3HzBG5K8PRhElkQqpmi8a2Dc1RpDcqMkJRK4FPjOgg/53Q2jLeTMr8lgYbWfcCNFDiywAv1V9F9BrKeYv8WE0Q344VRklWulRgsvf9IBEetKHQzpVRwxqTMMUNsSg1aJthTTHP43KfUYgGMFqyeMLWiS7EOs+jBfVQ4wL5PDM3LUqv0cfvtLCyEXv5pHg6R86J5ONElYEfr2FpXjfkpwAAop3R97aX1WQAAAABJRU5ErkJggg=="

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAqCAYAAAAu9HJYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0MGQyNjJhNy05ZDIwLTRhYmQtYWIwYi04MDI5NDc0YWU0YTkiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RUIyRUNGRjA4MDQyMTFFNzkwNzRGRERCQTNENUM5Q0EiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RUIyRUNGRUY4MDQyMTFFNzkwNzRGRERCQTNENUM5Q0EiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo5MzlmYmViYi1mYTUwLTQ5MWQtOTg2Yy1mNThhYWYwMjYzNWUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NDBkMjYyYTctOWQyMC00YWJkLWFiMGItODAyOTQ3NGFlNGE5Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+I2DLJgAAAO5JREFUeNrsmYEJwjAQRS9O4AYdwY7gCN3AjOIIjnBu0BEcRTfoBudFo0gqEksgP3oPjkCg9PVCmuuVqAAistVguRPGnpB4kUthdEEM0bjEOXBNyVHy4VqS38I1JE/wonrDQZbBaLvbRE3URE30g6hLz+OCrgeNzYLrjs45/+7Je41JcOBZJnXyrENHWDwzuopVNJpgYKdu+5ukxppw8Q9JZLpQyKBLUguZvOjmGYPkBCzJ7byC4sQQUoso2Nax+HeVkAmaoAn+gKCH/+BqpWHVROuviSYqfjs6c3fXFcwQxRBMlp5jg6H4z6arAAMA63ePYPWUfZQAAAAASUVORK5CYII="

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/productCockroach-sectionGel-product.6103aa5.png";

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/about-section1-m.75822f2.jpg";

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/aeon.18ba629.jpg";

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/all_pharmacy.ffe55a8.jpg";

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/apita.79e6b21.jpg";

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bamboos.78abb22.png";

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAwCAYAAAC4wJK5AAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxNDAgNzkuMTYwNDUxLCAyMDE3LzA1LzA2LTAxOjA4OjIxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+LUNEtwAAAhRJREFUaIHV2Wt5gzAYBeADBlYHw8GQUAmTkDmYlEnoHEwCc4CESqiDsx8llDQXcvva7PxsS7680ORJCBAISUXyzGsuJE8kD6FrSkNyJPnDW2aSx8Dvg42d6M4sBVkAF09dlYQIAMQgOwAvxImIAFSHRAKcEAuRAKgGSQRYEAORASiGZAIMyIooAGRDCgErhCRA8r2wIZ1oCOsAdIYegEr6D/jzBmDag5AcAUwAXirVVT2AmlNlECIAAIBjX7ExHSdECAAAk15aSGQdI6w7Bu4z6LtUOjv5MpM8Ug5wnZ02j1sKIhW19Nv8c/H/QNSmz/YoYfsQdddf93BnuxDl6Kt/3mJ7EAuwi2gM4gREIRqBeAHRiCdDgoAkxJMgu4BkxIMhUYAsxIMg0YASxCgIODN9h4ikpThvy2mpvCJiY5Udyi6n75Oy1W0SkASJQjwJEA3h3pig3JYyNlEvH7yIBgA6uxAnoiGAThBiIRoE6HghBqJhgI4TsiL+AUDHgvSAOOBXoE0TQnKg4HuhpYbke62DZAG1vXWCdT57AIPA4/7ouu60/aDrOgXgW6DWKPFC2QLoSEF6AHPF9rwAHQHIBJIH3g7cS6JSKrPOGJm5ObMrXakmASpBZl4fgNFgLiQLUAjZnn1YDaZCigCZEGOPYSESIVUAiRBrk+REREKqAiIhzl2eF7F8OSwXPgSwqfvlqBk6kcUfMPdE1sVeQm8AAAAASUVORK5CYII="

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hktvMall.1804a1e.jpg";

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/homeplus.e4a0bf4.jpg";

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBjbGFzcz0iaWNvbiBpY29uLWFycm93IGljb24tcm90YXRlLTE4MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDYwIDYwIiB4bWw6c3BhY2U9InByZXNlcnZlIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJ4TWlkWU1pZCBtZWV0IiBkYXRhLWdhLWxhYmVsPSJCYWNrIHRvIFJlc3VsdHMgWzFdIj4KICAgICAgICAgICAgICAgIDxwYXRoIGNsYXNzPSJpY29uLXBhdGgiIGQ9Ik0xNC4yLDUyLjVjLTEuOCwxLjgtMS44LDQuNywwLDYuNWMxLjgsMS44LDQuNiwxLjgsNi40LDBsMjUuMy0yNS44YzEuOC0xLjgsMS44LTQuNywwLTYuNUwyMC42LDFjLTEuOC0xLjgtNC42LTEuOC02LjQsMGMtMS44LDEuOC0xLjgsNC43LDAsNi41TDM0LjksMzBMMTQuMiw1Mi41eiIgZGF0YS1nYS1sYWJlbD0iQmFjayB0byBSZXN1bHRzIFsxXSI+PC9wYXRoPgogICAgICAgICAgICAgIDwvc3ZnPg=="

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/overlay-method2.2a7c5cc.png";

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/overlay-method2@2x.30c77b4.png";

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/overlay-method3.0a3c136.png";

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/overlay-method3@2x.bce24d0.png";

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/overlay-method5.731ff90.png";

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/overlay-method5@2x.0bd9794.png";

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/overlay-method6.a25c2d5.png";

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/overlay-method6@2x.fc3aaa8.png";

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pandamart.f528962.jpg";

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/parkinShop.cf08aba.png";

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/productCock-overlay-works-m3.11ffcc3.png";

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/productCock-overlay-works-m3@2x.c578a0e.png";

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/welcome.ea68c29.jpg";

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/yata.c08ca3f.jpg";

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ztore.c378c38.jpg";

/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ant-suggest.eceed40.png";

/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA6CAYAAADlTpoVAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxNDAgNzkuMTYwNDUxLCAyMDE3LzA1LzA2LTAxOjA4OjIxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+LUNEtwAAAdhJREFUaIHd2tttwkAQheHfbgBKoINQgjuBEighJVAC6SDpgBJcQkrAFZw82JBEYDDs7MzKR/KLJXv201rshYWMkdRI+tRvjpK2xjXuXtkiaavxHAzr+AMf4EyR7sCJODOkK/BJnAnSDShp9QIuGfkIWNsR2SY8u0ntybFYAlOTBVkSEDIgLYGt0Xuyfa7JUT9TscphYk3XYWIpqfVEugIjkO5Ab2QI0BMZBvRChgI9kOHA3MgigDmRxQBzIYsCRiBD4omszgWBPbCJIZvkgxtr0jOwBd6cG5QjV8ha/T7lHHDQf4GHvzdq0rYaSsw/ZGkreqtsgHeYLxBgB/MGLoBmzkBg3j0I0M4Z+AWc5grsGIa/Grv9zFLSAQ1wAqgkreiRi7g2meWMu3RaXVXV93CzC2mSXa5wMEy24bKiaIC1U4N22H01N3FhGdZvVjlJWo+tB2eNcwd641yBOXDDe+OBuXBFAHPiwoG5caFAD1wY0AsXAvTEuQMl7T1xrkClHeV6CTcFWMpRrr/pgKaqKpOJc2krelMclAU0x4Et8JjwbBacefTaUa7JPygjNV2HiWf/2EzCDTXdB/qpyGTcUC9kqvYIaYIbaoVNtpe6PW07qt+qtKpz9/oBmdgLdFqKcocAAAAASUVORK5CYII="

/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4FpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NDkxMSwgMjAxMy8xMC8yOS0xMTo0NzoxNiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo5MTgzNGFhNS05OTJkLTRhODgtODljYy02MjczNWMzNTc2MjAiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OEFGMzFFN0I3N0E0MTFFN0JDODFBMDYwRTgzRUI1MjAiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OEFGMzFFN0E3N0E0MTFFN0JDODFBMDYwRTgzRUI1MjAiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChNYWNpbnRvc2gpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6YTk0YjdjNDUtNThlYy00NDU4LWJiN2QtMzRiMDc4MDQ2NTg1IiBzdFJlZjpkb2N1bWVudElEPSJhZG9iZTpkb2NpZDpwaG90b3Nob3A6NTAzMzUzOWYtOWFlZC0xMTdhLTk4OWEtYjk4MjMzMTA3YWVmIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+geeerQAAARBJREFUeNq0loERgyAMRTkmcAQ3qCM4ghuUETpCR+gIcYOO4AhuUDtB3YDGO2hRgiao/+6fd0B4SjCgrbWKcJlo33JBtWs1l0EP6Be6QxeKrwf6gx7dPH8FRGNj9am3WxiIWOP71wBcEKzEGg8p7LZSIGDE1jpaP1oXIkeAvjJimwnyZCY2BHEBk3rJZ3uNgrEQJl4KYgOWkCNBEM6rMncMG5CC7AEBNZ/K/MnYAKp27VGVrHUHLxdZGc5IfAQ6awvPQDqjFklL0A8iAbyloAlSCwAtunRPLshoF8QFmOCYbtlb2yVnzPzROBul9IOrFRBknO/R8bsGAuZViHWRCEHgYHfhneuGHtAdugn7vgIMAH+J/FtlizFBAAAAAElFTkSuQmCC"

/***/ }),
/* 50 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAdCAYAAACqhkzFAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4ZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo5MTgzNGFhNS05OTJkLTRhODgtODljYy02MjczNWMzNTc2MjAiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6Nzc3MUU3OTA5QTlEMTFFNzg0MEM4M0UxQjZCQTMxNjkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6Nzc3MUU3OEY5QTlEMTFFNzg0MEM4M0UxQjZCQTMxNjkiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpkNjZhMjNlMC1hZWY5LTQ1MTMtOGI0Ni0yZTNiYTc4ZWRkOWYiIHN0UmVmOmRvY3VtZW50SUQ9ImFkb2JlOmRvY2lkOnBob3Rvc2hvcDo1MDMzNTM5Zi05YWVkLTExN2EtOTg5YS1iOTgyMzMxMDdhZWYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5U9WQJAAABCUlEQVR42qxViw2DIBAVJ2CD2g0YwREcwREYwREcwREcgRG6QekGbEDPhDbG3h0H5SUXFOT54H6qyyDGaGDQ6TUopR5dKYBkANvAQvxFSGuDlGyJcqw5si2WY2uhjFSqPncGw5MQ/gLb0/MEdiO+u4PDfO6oFjnJnD064U3L3DVGGr5xhix6QTR4ZJ/pT0F7hhNE2I7M6b5rjIMwIPOjYO/E3UepUyzplIqwsVzYSAPbna4iH9h/5DGdz6lk1cK0rDaO8/ZYQTjmUso1UVepcpK2AYlKT6Uehk3w36W08/lSdTnCmSGcq0oRofIoJJorXxywvrtCzoZahfrSXhdOXQmxIfP1grcAAwC3fL51y+5ZhQAAAABJRU5ErkJggg=="

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAA7CAYAAAAJvMhYAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxNDAgNzkuMTYwNDUxLCAyMDE3LzA1LzA2LTAxOjA4OjIxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+LUNEtwAAAwlJREFUaIHFms21mzAQha+czcvOqSB0EHfwSAVxCZTgElwCJZAOyC67kA7sZXa4A14FNwvJPhiEmBHI3HO8eCBGH6OfmRHPYCWR3AM4AOiMMRfFc8H7JhImA3AEkDuorxNNrwAuAGpjTB0DqAUrSF4Yp45k5V7uCTD0k4LlJNtIMJ9K2imxDJDk3hlLoY72xeMAHVzscGpUqAFfCHdXNQX4yQcHoAHwTTZDV9EBwA12xT9ptM2QbAC8p2fy6juscx7a9f8gecJ2cABQA9j3LzyG2A1tDeAt0vgVwD/YofoSaecNwGcAv0d33ETVqqFdhXuPvYx2i+oi7Gbsr2LaVatRRzsdZuVsN0r7j1V9N3JSwh20Y0fdCHVDQM2el2vhepAaTx5Jqoe3jIVzgBnlc7IkiR3sJinVIkBjTAugEjY/AFAB/nIdLFUlbPcOWMDRFjEhcZYcksu2P6Ttd/NNHmrUNNOSvmymAdxCKsBsxY6l06rRAKo3Z59ow6I4ldsB6IRtj1FE8XbsQqKtC6QqltJRXnw17IU66e7e0pO5KOA0Mf/UB9QEcm8BLoA7KBxBupTr/nCmeJAkayo8SRv4NXA1h1Wdu6hRy5k5SfviMYnwo142PWM5gD+qcbO6wZYKFwCtu5bDbks/Iuz9dc8DGFR13Laiu+upshsC5ojz4lq6YhAQniKJMaaBdfFWGuWbvlBXpefw6ubrewRojKlc41fr7Ls4lSx4GyeU13vABOAGXqymboTSrUUFkkIfob5CgBUUtcMClQikfJOAxpgO6b0Y9B4wXzSVSOvFGjMJcxDQebFaEWio82IL1KdiUlXO/irfSWJSpjllawKu7cW6Zzv4E5Wd7kzmp+x1RFp/d6Cu+gupGdhdPsQ9Y9qjXJ/ylIBLvTg6NJoDVB0erZDQpo/vtCVkjNoJe+sNcc+o9Piir+KVgIUSbjLeJgF0hjVePG8BKPVix8AxSUrAPWXnLecZO2kAnfHzEu8lB3QdTGU6om96c4BR/9jj6aSAPdq9e+sCoJR8+Jnz0n/oi3LDSTlKWgAAAABJRU5ErkJggg=="

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.0c3c7e8.png";

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/menu-faq@2x.fd5483c.png";

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/menu-insecticideguide@2x.9d2663f.png";

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/menu-pest_ant@2x.a21a710.png";

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/menu-pest_cockroach@2x.84d9bbf.png";

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/menu-petsafety@2x.1ca302c.png";

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/menu-product_ant@2x.981ec28.png";

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/menu-product_cockroach@2x.63c16cd.png";

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/menu-ptips@2x.c61c184.png";

/***/ }),
/* 61 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/overlay-method1@2x.3a53624.png";

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/productAnt-section2-icon2@2x.2aaa23f.png";

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/productAnt-section2-icon3@2x.55f201f.png";

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/productAnt-section2-icon4@2x.068db6a.png";

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/productAnt-section2.ae9ff66.png";

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/productCockroach-section2-1.e3d92e7.png";

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/productCockroach-section2.35c315c.png";

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/productCockroach-section3-product-1.636119a.png";

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/productCockroach-section3-product.cbde193.png";

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tips-section2.3ae05ea.jpg";

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/uselect.573dc6a.png";

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/vanguard.808a888.jpg";

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_head__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_head___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_head__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_scrollto__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Home__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_About__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_About__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_ProductAnt__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_ProductAnt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_ProductAnt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_ProductCockroach__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_ProductCockroach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_ProductCockroach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_PTipsTips__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_PTipsTips___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_PTipsTips__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_PTipsTipsRoach__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_PTipsTipsRoach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_PTipsTipsRoach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_PTipsTipsAnt__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_PTipsTipsAnt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__pages_PTipsTipsAnt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_PTipsTipsGeneral__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_PTipsTipsGeneral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__pages_PTipsTipsGeneral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_PTipsInsecticideGuide__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_PTipsInsecticideGuide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__pages_PTipsInsecticideGuide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_PTipsPetSafety__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_PTipsPetSafety___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__pages_PTipsPetSafety__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_PTipsFAQ__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_PTipsFAQ___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__pages_PTipsFAQ__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_Shoplist__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_Shoplist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__pages_Shoplist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_PICockroach__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_PICockroach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__pages_PICockroach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_PIAnt__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_PIAnt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__pages_PIAnt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_Terms__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_Terms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__pages_Terms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_Privacy__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_Privacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__pages_Privacy__);





















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_head___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_scrollto___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_Home___default.a
  }, {
    path: '/about',
    name: 'About',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_About___default.a
  }, {
    path: '/product/ant',
    name: 'ProductAnt',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_ProductAnt___default.a
  }, {
    path: '/product/cockroach',
    name: 'ProductCockroach',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_ProductCockroach___default.a
  }, {
    path: '/preventiontips/tips',
    name: 'PTipsTips',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_PTipsTips___default.a
  }, {
    path: '/preventiontips/tips/roach',
    name: 'PTipsTipsRoach',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_PTipsTipsRoach___default.a
  }, {
    path: '/preventiontips/tips/ant',
    name: 'PTipsTipsAnt',
    component: __WEBPACK_IMPORTED_MODULE_10__pages_PTipsTipsAnt___default.a
  }, {
    path: '/preventiontips/tips/general',
    name: 'PTipsTipsGeneral',
    component: __WEBPACK_IMPORTED_MODULE_11__pages_PTipsTipsGeneral___default.a
  }, {
    path: '/preventiontips/insecticideguide',
    name: 'PTipsInsecticideGuide',
    component: __WEBPACK_IMPORTED_MODULE_12__pages_PTipsInsecticideGuide___default.a
  }, {
    path: '/preventiontips/petsafety',
    name: 'PTipsPetSafety',
    component: __WEBPACK_IMPORTED_MODULE_13__pages_PTipsPetSafety___default.a
  }, {
    path: '/preventiontips/faq',
    name: 'PTipsFAQ',
    component: __WEBPACK_IMPORTED_MODULE_14__pages_PTipsFAQ___default.a
  }, {
    path: '/shoplist',
    name: 'shoplist',
    component: __WEBPACK_IMPORTED_MODULE_15__pages_Shoplist___default.a
  }, {
    path: '/pestidentification/cockroach',
    name: 'PICockroach',
    component: __WEBPACK_IMPORTED_MODULE_16__pages_PICockroach___default.a
  }, {
    path: '/pestidentification/ant',
    name: 'PIAnt',
    component: __WEBPACK_IMPORTED_MODULE_17__pages_PIAnt___default.a
  }, {
    path: '/terms',
    name: 'terms',
    component: __WEBPACK_IMPORTED_MODULE_18__pages_Terms___default.a
  }, {
    path: '/privacy',
    name: 'privacy',
    component: __WEBPACK_IMPORTED_MODULE_19__pages_Privacy___default.a
  }]
}));

/***/ }),
/* 76 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 77 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 78 */,
/* 79 */,
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(123)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(88),
  /* template */
  __webpack_require__(240),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(112)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(230),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1ce7e4d8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(109)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(90),
  /* template */
  __webpack_require__(228),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(132)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(91),
  /* template */
  __webpack_require__(248),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c4268662",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(128)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(244),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-83e75fbe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 85 */,
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_topMenu_TopMenu__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_topMenu_TopMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_topMenu_TopMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_footer_Footer__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_footer_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_footer_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_footer_Contact__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_footer_Contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_footer_Contact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_isotopeGrid_isotopeGrid__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_isotopeGrid_isotopeGrid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_isotopeGrid_isotopeGrid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_animate_css__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_animate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_animate_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_fullpage_vue_src_fullpage_css__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_fullpage_vue_src_fullpage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_fullpage_vue_src_fullpage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_scrollto__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_fullpage_vue__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_fullpage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_fullpage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vueisotope__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vueisotope___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vueisotope__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_carousel__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_carousel__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('top-menu', __WEBPACK_IMPORTED_MODULE_3__components_topMenu_TopMenu___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('henkel-footer', __WEBPACK_IMPORTED_MODULE_4__components_footer_Footer___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('contact', __WEBPACK_IMPORTED_MODULE_5__components_footer_Contact___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('isotopegrid', __WEBPACK_IMPORTED_MODULE_6__components_isotopeGrid_isotopeGrid___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('isotope', __WEBPACK_IMPORTED_MODULE_11_vueisotope___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_fullpage_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_scrollto___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12_vue_carousel___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: { switchCockroach: -1, switchCockroachTarget: 0 },
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    window.onscroll = function (ev) {
      var bArrow = document.getElementById('bottomArrow');

      if (!bArrow) {
        return;
      }

      if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
        bArrow.classList.remove('icon-rotate-down');
        bArrow.classList.add('icon-rotate-up');
      } else {
        bArrow.classList.remove('icon-rotate-up');
        bArrow.classList.add('icon-rotate-down');
      }
    };
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      ls2x: __webpack_require__(164),
      ts2x: __webpack_require__(207),
      fs2x: __webpack_require__(148)
    };
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      hk2x: __webpack_require__(153)
    };
  }
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'isotopegrid',
  props: ['isotopeProps'],
  methods: {
    sort: function sort(key) {
      this.$refs.ist.sort(key);
    },
    filter: function filter(key) {
      this.$refs.ist.filter(key);
      this.isotopeProps.filterOption = key;
    },
    changeLayout: function changeLayout(key) {
      this.$refs.ist.layout(key);
    },
    showPopup: function showPopup(contentsHtml) {
      this.togglePopup();
      this.isotopeProps.popupContents = contentsHtml;
    },
    togglePopup: function togglePopup() {
      if (this.isotopeProps.openPopup) {
        this.isotopeProps.openPopup = false;
      } else {
        this.isotopeProps.openPopup = true;
      }
    }
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  watch: {
    '$route': function $route(to, from) {
      this.activeTab = '/' + to.path.split('/')[1];
      this.closeMobileMenu();
    }
  },
  mounted: function mounted() {
    var route = this.$route.matched[0].path;
    this.activeTab = '/' + route.split('/')[1];
  },
  data: function data() {
    return {
      mMenuToggle: false,
      activeTab: null,
      menuTab: [{
        name: '關於威滅',
        route: '/about',
        path: '/about'
      }, {
        name: '產品',
        path: '/product',
        subTab: [{
          name: '曱甴',
          img: __webpack_require__(59),
          srcset: __webpack_require__(59),
          route: '/product/cockroach'
        }, {
          name: '螞蟻',
          img: __webpack_require__(58),
          srcset: __webpack_require__(58),
          route: '/product/ant'
        }]
      }, {
        name: '防治方案與貼士',
        path: '/preventiontips',
        subTab: [{
          name: '預防小貼士',
          img: __webpack_require__(60),
          srcset: __webpack_require__(60),
          route: '/preventiontips/tips'
        }, {
          name: '殺蟲藥指引',
          img: __webpack_require__(54),
          srcset: __webpack_require__(54),
          route: '/preventiontips/insecticideguide'
        }, {
          name: '寵物家居安全',
          img: __webpack_require__(57),
          srcset: __webpack_require__(57),
          route: '/preventiontips/petsafety'
        }, {
          name: '常見問題',
          img: __webpack_require__(53),
          srcset: __webpack_require__(53),
          route: '/preventiontips/faq'
        }]
      }, {
        name: '害蟲種類及資訊',
        path: '/pestidentification',
        subTab: [{
          name: '曱甴小常識',
          img: __webpack_require__(56),
          srcset: __webpack_require__(56),
          route: '/pestidentification/cockroach'
        }, {
          name: '螞蟻小常識',
          img: __webpack_require__(55),
          srcset: __webpack_require__(55),
          route: '/pestidentification/ant'
        }]
      }, {
        name: '銷售地點',
        route: '/shoplist',
        path: '/shoplist'
      }]
    };
  },

  methods: {
    openMobileMenu: function openMobileMenu() {
      this.mMenuToggle = !this.mMenuToggle;
      this.fixHtmlScroll();
    },
    closeMobileMenu: function closeMobileMenu() {
      if (this.mMenuToggle) {
        this.mMenuToggle = false;
        this.fixHtmlScroll();
      }
    },
    clickTab: function clickTab(tab) {
      this.activeTab = tab;
      this.closeMobileMenu();
    },
    fixHtmlScroll: function fixHtmlScroll() {
      var html = document.getElementsByTagName('html')[0];
      if (this.mMenuToggle) {
        html.style.overflowY = 'hidden';
      } else {
        html.style.overflowY = 'auto';
      }
    }
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  head: {
    meta: [{ name: 'application-name', content: 'combat about' }]
  },
  data: function data() {
    var _this = this;

    return {
      tabIndex: 1,
      curProduct: 0,
      opts: {
        start: 0,
        overflow: '',
        dir: 'v',
        duration: 500,
        beforeChange: function beforeChange(obj, prev, next) {
          _this.curProduct = next;
        },
        afterChange: function afterChange(obj, prev, next) {}
      }
    };
  },
  created: function created() {
    window.document.title = '威滅Combat 速效藥餌';
    window.scrollTo(0, 0);
  },
  mounted: function mounted() {
    var _this2 = this;

    window.onresize = function () {
      var vw = document.documentElement.clientWidth;
      if (vw >= 780 && !_this2.openOverlay) {
        location.reload();
      }
    };
  },

  methods: {
    movePrevPage: function movePrevPage() {
      this.$refs.fullpage.$fullpage.movePrev();
    },
    moveNextPage: function moveNextPage() {
      this.$refs.fullpage.$fullpage.moveNext();
    },
    scrollToProduct: function scrollToProduct(index) {
      this.curProduct = index;
      this.$refs.fullpage.$fullpage.moveTo(index);
    }
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bottomArrow_js__ = __webpack_require__(87);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bottomArrow_js__["a" /* default */]],
  data: function data() {
    var _this = this;

    return {
      msg: 'This is home',
      visual: 0,
      totalSlide: 2,
      imageTimeout: null,
      curProduct: 0,
      opts: {
        start: 0,
        overflow: '',
        dir: 'v',
        duration: 500,
        beforeChange: function beforeChange(obj, prev, next) {
          _this.curProduct = next;
        },
        afterChange: function afterChange(obj, prev, next) {}
      }
    };
  },

  head: {
    meta: [{ name: 'application-name', content: 'combat hk' }]
  },
  created: function created() {
    window.document.title = '威滅Combat 速效藥餌';
    window.scrollTo(0, 0);
  },
  destroyed: function destroyed() {
    window.onresize = function (e) {
      e.preventDefault();
    };
    clearTimeout(this.imageTimeout);
  },

  methods: {
    jumpToCockroach: function jumpToCockroach(target) {
      this.$root.switchCockroach = 1;
      this.$root.switchCockroachTarget = target;
      this.$router.push({ path: 'product/cockroach' });
    },
    resetContentSize: function resetContentSize() {
      var vh = window.innerHeight;
      var vw = document.documentElement.clientWidth;
      var content = this.$refs.content;
      content.style.height = 'auto';
      var contentHeight = content.clientHeight;

      if (contentHeight >= vh && vw >= 768) {
        content.style.height = vh + 'px';
      } else {
        content.style.height = 'auto';
      }
    },
    scrollToProduct: function scrollToProduct(index) {
      this.curProduct = index;
      this.$refs.fullpage.$fullpage.moveTo(index);
    },
    scrollToBottom: function scrollToBottom() {
      if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
        this.$scrollTo('body', 0.4);
        return;
      }

      this.$scrollTo('.footer', 0.4);
    },
    movePrevPage: function movePrevPage() {
      this.$refs.fullpage.$fullpage.movePrev();
    },
    moveNextPage: function moveNextPage() {
      this.$refs.fullpage.$fullpage.moveNext();
    },
    changeImage: function changeImage(index) {
      this.visual = index;
      this.startImageTimeout();
    },
    slideTransition: function slideTransition() {
      this.visual = ++this.visual % this.totalSlide;
      this.startImageTimeout();
    },
    startImageTimeout: function startImageTimeout() {
      var _this2 = this;

      if (this.imageTimeout) {
        clearTimeout(this.imageTimeout);
      }
      this.imageTimeout = window.setTimeout(function () {
        _this2.slideTransition();
      }, 5000);
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    var time = 500;
    var originalvw = document.documentElement.clientWidth;
    if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
      time = 1000;
    }

    window.setTimeout(function () {
      _this3.resetContentSize();
      _this3.startImageTimeout();
    }, time);

    window.onresize = function () {
      var vw = document.documentElement.clientWidth;
      if (vw >= 768 || vw !== originalvw) {
        location.reload();
      }
    };
  }
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    window.document.title = '威滅Combat 速效藥餌';
    window.scrollTo(0, 0);
  },
  data: function data() {
    return {
      isotopeProps: {
        title: '螞蟻小常識',
        desc: '害蟲種類及資訊',
        cardname: '螞蟻小常識',
        showTag: false,
        popup: true,
        popupContents: null,
        openPopup: false,
        list: [{
          name: '小黃家蟻',
          id: 0,
          imgpath: '',
          tag: '',
          cardname: '種類',
          html: '\n            <h1 class="hdr">\u5C0F\u9EC3\u5BB6\u87FB</h1>\n            <p>\u5E38\u898B\u7684\u879E\u87FB\u6709\u5C0F\u9EC3\u5BB6\u87FB (\u53C8\u540D\u201C\u6CD5\u8001\u87FB\u201D)\u548C\u9ED1\u87FB\u3002</p>\n            <h1>\u5916\u8868</h1>\n            <p>\u5C0F\u9EC3\u5BB6\u87FB\u8EAB\u578B\u5F88\u5C0F\uFF0C\u9AD4\u9577\u70BA1.5\u6BEB\u7C73\uFF0C\u5448\u6DE1\u9EC3\u8910\u8272\u3002</p>\n          '
        }, {
          name: '黑蟻',
          id: 1,
          imgpath: '',
          tag: '',
          cardname: '種類',
          html: '\n            <h1 class="hdr">\u9ED1\u87FB</h1>\n            <p>\u5E38\u898B\u7684\u879E\u87FB\u6709\u5C0F\u9EC3\u5BB6\u87FB (\u53C8\u540D\u201C\u6CD5\u8001\u87FB\u201D)\u548C\u9ED1\u87FB\u3002</p>\n            <h1>\u5916\u8868</h1>\n            <p>\u9ED1\u87FB\u8EAB\u578B\u4E2D\u7B49\uFF0C\u9AD4\u9577\u70BA2.5-3\u6BEB\u7C73\uFF0C\u5448\u6709\u5149\u6FA4\u7684\u9ED1\u8272\u3002</p>\n          '
        }, {
          name: '螞蟻的食糧',
          id: 2,
          imgpath: '',
          tag: '',
          html: '\n            <h1 class="hdr">\u879E\u87FB\u7684\u98DF\u7CE7</h1>\n            <p>\u5B83\u5011\u559C\u6B61\u5403\u751C\u7684\uFF0C\u6709\u8102\u80AA\u548C\u86CB\u767D\u8CEA\u7684\u98DF\u7269\u3002\u53EF\u662F\u5B83\u5011\u5C0D\u98DF\u7269\u7684\u9078\u64C7\u7D93\u5E38\u6539\u8B8A\u4E0D\u5B9A\u3002</p>\n          '
        }, {
          name: '防止螞蟻入侵的方法',
          id: 3,
          imgpath: '',
          tag: '',
          html: '\n            <h1 class="hdr">\u9632\u6B62\u879E\u87FB\u5165\u4FB5\u7684\u65B9\u6CD5</h1>\n            <p>\u5C0F\u9EC3\u5BB6\u87FB\u96E3\u4EE5\u63A7\u5236\uFF0C\u56E0\u70BA\u87FB\u7FA4\u6709\u53EF\u80FD\u5728\u96E3\u4EE5\u89F8\u53CA\u7684\u5730\u65B9\u5EFA\u7BC9\u591A\u500B\u5DE2\u7A74\u3002\u5207\u52FF\u4F7F\u7528\u6BBA\u87F2\u5674\u9727\u5291\u4F86\u5C0D\u4ED8\u9019\u4E9B\u879E\u87FB\uFF0C\u56E0\u70BA\u9019\u4E9B\u6BBA\u87F2\u5674\u9727\u5291\u7684\u9A45\u87F2\u4F5C\u7528\u6703\u5C0E\u81F4\u87FB\u7FA4\u5206\u6563\u4E26\u52A0\u91CD\u798D\u60A3\u3002\u6B64\u5916\uFF0C\u5C0F\u9EC3\u5BB6\u87FB\u5F88\u5FEB\u5F9E\u4E00\u500B\u98DF\u7269\u4F86\u6E90\u8F49\u79FB\u5230\u53E6\u4E00\u500B\u98DF\u7269\u4F86\u6E90\uFF0C\u6240\u4EE5\u6700\u597D\u540C\u6642\u9593\u4F7F\u7528\u6578\u500B\u6BBA\u87FB\u85E5\u990C\u9632\u6B62\u5B83\u5011\u5165\u4FB5\u3002</p>\n            <p>\u628A\u5916\u7246\u88C2\u7E2B\u5BC6\u5C01\u80FD\u5920\u9632\u6B62\u9ED1\u87FB\u9032\u5165\u5BA4\u5167\uFF0C\u4EA6\u61C9\u8A72\u4FEE\u7406\u6F0F\u6C34\u60C5\u6CC1\uFF0C\u4E0D\u61C9\u904E\u5206\u704C\u6E89\u690D\u7269\uFF0C\u6E05\u7406\u597D\u5269\u9918\u7684\u98DF\u7269\uFF0C\u4E26\u628A\u98DF\u7269\u5B58\u653E\u5728\u5BC6\u5C01\u7684\u5BB9\u5668\u4E2D\u3002</p>\n          '
        }, {
          name: '築巢地點',
          id: 4,
          imgpath: '',
          tag: '',
          html: '\n            <h1 class="hdr">\u7BC9\u5DE2\u5730\u9EDE</h1>\n            <h1>\u5C0F\u9EC3\u5BB6\u87FB</h1>\n            <p>\u6703\u5728\u6236\u5916\u6216\u5BA4\u5167\u5EFA\u7BC9\u879E\u87FB\u5DE2\u3002 \u5B83\u5011\u559C\u6B61\u5728\u5145\u8DB3\u6EAB\u6696\u548C\u6FD5\u5EA6\u7684\u74B0\u5883\uFF0C\u4E26\u5728\u96E3\u4EE5\u89F8\u53CA\u7684\u5730\u65B9\u4E0B\u7BC9\u5DE2\uFF0C\u5982\u7246\u5167\u7A7A\u9699\u3001\u5EDA\u623F\u6216\u6D74\u5BA4\u5E95\u677F\u5F8C\u9762\u3002</p>\n            <h1>\u9ED1\u87FB</h1>\n            <p>\u6703\u5728\u6750\u6599\u5806\u4E2D\u5EFA\u7BC9\u879E\u87FB\u5DE2\uFF0C\u5982\u6728\u6750\uFF0C\u77F3\u982D\u6216\u7D19\u677F\u7B49\u3002\u5982\u5728\u5BA4\u5167\u7BC9\u5DE2\u6642\uFF0C\u5B83\u5011\u901A\u5E38\u6703\u9078\u64C7\u65BC\u6C34\u6E90\u9644\u8FD1; \u4F8B\u5982\uFF0C\u5728\u5EDA\u623F\u548C\u6D74\u5BA4\u3002</p>\n          '
        }, {
          name: '如何消滅它們',
          id: 5,
          imgpath: '',
          tag: '',
          html: '\n            <h1 class="hdr">\u5982\u4F55\u6D88\u6EC5\u5B83\u5011</h1>\n            <p>\u8981\u5FB9\u5E95\u6D88\u6EC5\u879E\u87FB\uFF0C\u95DC\u9375\u662F\u6D88\u6EC5\u6574\u500B\u879E\u87FB\u5DE2\u7A74\u3002 \u5982\u679C\u53EA\u662F\u6BBA\u6B7B\u773C\u524D\u7684\u879E\u87FB\uFF0C\u5176\u9918\u7684\u879E\u87FB\u6703\u7E7C\u7E8C\u51FA\u672B\u5C0B\u627E\u98DF\u7269\u548C\u6C34\u6E90\uFF0C\u4EE5\u4FBF\u5949\u7D66\u87FB\u540E\u548C\u8207\u5176\u4ED6\u540C\u4F34\u5206\u4EAB\u3002</p>\n            <p>\u5A01\u6EC5\u901F\u6548\u6BBA\u87FB\u85E5\u990C\u53EF\u4EE5\u5C07\u5DE2\u7A74\u5167\u7684\u879E\u87FB\u4E00\u7DB2\u6253\u76E1\u3002\u60F3\u4E86\u89E3\u66F4\u591A\u6709\u95DC\u5A01\u6EC5\u4E00\u7DB2\u6253\u76E1\u7684\u539F\u7406\uFF0C<a href="#/preventiontips/insecticideguide">\u8ACB\u6309\u9019\u88E1</a>\u3002</p>\n          '
        }],
        selected: null,
        sortOption: null,
        filterOption: null,
        filterText: '',
        option: {
          getSortData: {
            id: 'id'
          },
          sortBy: 'id',
          getFilterData: {
            '顯示全部': function _() {
              return true;
            },
            '螞蟻': function _(el) {
              return el.tag.match(/螞蟻$/);
            },
            '曱甴': function _(el) {
              return el.tag.match(/曱甴$/);
            }
          }
        }
      }
    };
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    window.document.title = '威滅Combat 速效藥餌';
    window.scrollTo(0, 0);
  },
  data: function data() {
    return {
      isotopeProps: {
        title: '曱甴小常識',
        desc: '害蟲種類及資訊',
        cardname: '曱甴小常識',
        showTag: false,
        popup: true,
        popupContents: null,
        openPopup: false,
        list: [{
          name: '美洲曱甴',
          id: 0,
          imgpath: '',
          _imgpath: __webpack_require__(181),
          tag: '',
          cardname: '種類',
          html: '\n            <h1 class="hdr">\u7F8E\u6D32\u66F1\u7534</h1>\n            <h1>\u5C45\u4F4F\u5730</h1>\n            <p>\u7F8E\u6D32\u66F1\u7534\u70BA\u9999\u6E2F\u5E38\u898B\u7684\u66F1\u7534\uFF0C\u4E00\u822C\u51FA\u73FE\u5728\u4E0B\u6C34\u9053\u3001\u6E20\u9053\u7B49\u6F6E\u6FD5\u7684\u5730\u65B9\u3002</p>\n            <h1>\u5916\u8868</h1>\n            <p>\u7F8E\u6D32\u66F1\u7534\u662F\u6700\u5927\u7684\u5BB6\u5C45\u66F1\u7534\u3002\u6210\u5E74\u7684\u7F8E\u6D32\u66F1\u7534\u9577\u7D043.8\u5398\u7C73\u81F35\u5398\u7C73\uFF0C\u6709\u7D05\u68D5\u8272\u7FC5\u8180\uFF0C\u5728\u6DFA\u8272\u80CC\u4E0A\u6709\u6DF1\u8272\u6A19\u8A18\u3002\u5B83\u5011\u53EF\u4EE5\u64E0\u9032\u53EA\u67093mm\u539A\u7684\u7A7A\u9593\u3002</p>\n            <h1>\u95DC\u65BC\u7F8E\u6D32\u66F1\u7534\uFF1A</h1>\n            <ul>\n              <li>\u7F8E\u6D32\u66F1\u7534\u53EF\u4EE5\u98DB\u884C\u3002</li>\n              <li>\u96CC\u6027\u7F8E\u6D32\u66F1\u7534\u6BCF\u5E74\u53EF\u4EE5\u7E41\u6B96\u591A\u9054150\u500B\u5F8C\u4EE3\u3002</li>\n              <li>\u5B83\u5011\u7684\u884C\u52D5\u901F\u5EA6\u5F88\u5FEB\uFF0C\u6BCF\u79D2\u53EF\u4EE5\u884C\u8D70\u7D0450\u500B\u8EAB\u9AD4\u9577\u5EA6\uFF08\u76F8\u7576\u65BC\u4EBA\u985E\u6BCF\u5C0F\u6642\u8DD1330\u516C\u91CC)\u3002</li>\n              <li>\u5B83\u5011\u4E00\u822C\u5728\u591C\u9593\u6642\u4EFD\u6BD4\u8F03\u6D3B\u8E8D\u3002</li>\n              <li>\u5B83\u5011\u4EC0\u9EBC\u90FD\u5403\uFF0C\u5305\u62EC\u7D19\uFF0C\u982D\u9AEE\uFF0C\u5E03\u548C\u87F2\u985E\u5C4D\u9AD4\u3002</li>\n            </ul>\n          '
        }, {
          name: '德國曱甴',
          id: 1,
          imgpath: '',
          _imgpath: __webpack_require__(183),
          tag: '',
          cardname: '種類',
          html: '\n            <h1 class="hdr">\u5FB7\u570B\u66F1\u7534</h1>\n            <h1>\u5C45\u4F4F\u5730</h1>\n            <p>\u5FB7\u570B\u66F1\u7534\u4E00\u822C\u5728\u5BB6\u5C45\u548C\u5546\u696D\u5834\u6240\u751F\u6D3B\u548C\u7E41\u6B96\u3002</p>\n            <h1>\u5916\u8868</h1>\n            <p>\u5FB7\u570B\u66F1\u7534\u662F\u5C0F\u66F1\u7534\uFF0C\u6210\u5E74\u5FB7\u570B\u66F1\u7534\u53EA\u9577\u7D041.2\u5398\u7C73\u3002  \u5B83\u5011\u5448\u9EC3\u68D5\u8272/\u68D5\u8272\uFF0C\u982D\u90E8\u7684\u80CC\u4E0A\u6709\u5169\u689D\u7E31\u5411\u7684\u9ED1\u8272\u689D\u7D0B\u3002</p>\n            <h1>\u95DC\u65BC\u5FB7\u570B\u66F1\u7534:</h1>\n            <ul>\n              <li>\u96D6\u7136\u5FB7\u570B\u66F1\u7534\u6709\u7FC5\u8180\uFF0C\u4F46\u5B83\u5011\u4E0D\u6703\u98DB\u884C\u3002</li>\n              <li>\u4E00\u96BB\u96CC\u6027\u5FB7\u570B\u66F1\u7534\u4E00\u5E74\u53EF\u4EE5\u7E41\u6B96\u591A\u905410\u842C\u500B\u5F8C\u4EE3\uFF0C\u662F\u6240\u6709\u5BB3\u87F2\u7A2E\u985E\u4E2D\u6700\u5FEB\u7684\u3002</li>\n              <li>\u65B0\u751F\u7684\u5FB7\u570B\u66F1\u7534\u572836\u5929\u5167\u6703\u6210\u70BA\u6210\u5E74\u66F1\u7534\u3002</li>\n              <li>\u5B83\u5011\u666E\u904D\u6703\u5403\u751C\u98DF\uFF0C\u6CB9\u8102\uFF0C\u8089\u548C\u5783\u573E\u3002</li>\n            </ul>\n          '
        }, {
          name: '棕帶曱甴',
          id: 2,
          imgpath: '',
          _imgpath: __webpack_require__(182),
          tag: '',
          cardname: '種類',
          html: '\n            <h1 class="hdr">\u68D5\u5E36\u66F1\u7534</h1>\n            <h1>\u5C45\u4F4F\u5730</h1>\n            <p>\u68D5\u5E36\u66F1\u7534\u4E00\u822C\u51FA\u73FE\u5728\u5BB6\u5C45\uFF0C\u516C\u5BD3\uFF0C\u9152\u5E97\u548C\u8FA6\u516C\u5BA4\u3002</p>\n            <h1>\u5916\u8868</h1>\n            <p>\u68D5\u5E36\u66F1\u7534\u6BD4\u8F03\u7D30\u5C0F\uFF0C\u6210\u5E74\u7684\u9577\u7D041.2\u5398\u7C73\u3002\u5B83\u5011\u7684\u80CC\u90E8\u6709\u5169\u689D\u90E8\u4EFD/\u5B8C\u5168\u88AB\u7FC5\u8180\u906E\u84CB\u7684\u6DFA\u9EC3\u8272\u689D\u7D0B\u3002</p>\n            <h1>\u95DC\u65BC\u68D5\u5E36\u66F1\u7534:</h1>\n            <ul>\n              <li>\u5B83\u5011\u6703\u5728\u6EAB\u6696\u3001\u4E7E\u71E5\u7684\u6C23\u5019\u4E2D\u66F4\u5E38\u898B\u3002</li>\n              <li>\u64DA\u5831\u5C0E\uFF0C\u68D5\u5E36\u66F1\u7534\u80FD\u50B3\u64AD\u81F3\u5C1133\u7A2E\u7D30\u83CC\u30016\u7A2E\u5BC4\u751F\u87F2\u548C\u81F3\u5C117\u7A2E\u4EBA\u985E\u75C5\u539F\u9AD4\u3002</li>\n              <li>\u5B83\u5011\u4E00\u822C\u5728\u591C\u9593\u6642\u4EFD\u6BD4\u8F03\u6D3B\u8E8D\u3002</li>\n              <li>\u5B83\u5011\u6703\u5403\u5BB6\u5EAD\u7528\u54C1\uFF0C\u5982\u66F8\u7C4D\uFF0C\u4FE1\u5C01\uFF0C\u90F5\u7968\uFF0C\u58C1\u7D19\u548C\u5E03\u3002</li>\n            </ul>\n          '
        }, {
          name: '防止曱甴入侵的方法',
          id: 3,
          imgpath: '',
          tag: '',
          html: '\n            <h1 class="hdr">\u9632\u6B62\u66F1\u7534\u5165\u4FB5\u7684\u65B9\u6CD5</h1>\n            <p>\u5835\u585E\u5916\u7246\u4E0A\u7684\u88C2\u7E2B\uFF0C\u4E26\u5728\u4E0B\u6C34\u9053\u4E2D\u5B89\u88DD\u7BE9\u7DB2\uFF0C\u6709\u52A9\u9650\u5236\u66F1\u7534\u7684\u6D3B\u52D5\u3002</p>\n            <p>\u6539\u5584\u885B\u751F\u3001\u6E1B\u5C11\u96DC\u4E82\u3001\u6E05\u9664\u7A4D\u6C34\u662F\u9632\u6B62\u66F1\u7534\u5165\u4FB5\u7684\u6709\u6548\u65B9\u6CD5\u3002</p>\n            <p>\u6E05\u9664\u67AF\u840E\u7684\u690D\u7269\u548C\u6E1B\u5C11\u6F6E\u6FD5\u7684\u74B0\u5883\uFF0C\u4EE5\u9632\u6B62\u66F1\u7534\u7E41\u6B96\u548C\u7BC9\u5DE2\u3002\u96A8\u8457\u5DE2\u7A74\u6E1B\u5C11\uFF0C\u66F1\u7534\u6578\u91CF\u4EA6\u5C07\u6703\u7E2E\u5C11\u3002</p>\n          '
        }, {
          name: '築巢地點',
          id: 4,
          imgpath: '',
          tag: '',
          html: '\n            <h1 class="hdr">\u7BC9\u5DE2\u5730\u9EDE</h1>\n            <h1>\u7F8E\u6D32\u66F1\u7534</h1>\n            <p>\u4E00\u822C\u5728\u6236\u5916\u751F\u6D3B\u548C\u7E41\u6B96\uFF0C\u9032\u5165\u5BB6\u88E1\u5C0B\u627E\u98DF\u7269\u548C\u6C34\u6E90\u3002 \u5B83\u5011\u559C\u6B61\u6EAB\u6696\u548C\u6F6E\u6FD5\u74B0\u5883\uFF0C\u53EF\u4EE5\u901A\u904E\u6392\u6C34\u7BA1\u548C\u6392\u6C61\u7BA1\u9032\u5165\u5BB6\u4E2D\u3002</p>\n            <h1>\u5FB7\u570B\u66F1\u7534</h1>\n            <p>\u7E41\u6B96\u8FC5\u901F\uFF0C\u5B83\u5011\u559C\u6B61\u9670\u6697\u96B1\u853D\u7684\u5730\u65B9\uFF0C\u5982\u6AE5\u6AC3\u5E95\u90E8\u548C\u51B0\u7BB1\u5F8C\u9762\u3002\u5728\u5546\u696D\u5927\u5EC8\u4E2D\uFF0C\u5FB7\u570B\u66F1\u7534\u7D93\u5E38\u51FA\u73FE\u5728\u7D19\u7BB1\uFF0C\u6728\u7BB1\u6216\u6258\u76E4\u4E0B\u9762\u3002</p>\n            <h1>\u68D5\u5E36\u66F1\u7534</h1>\n            <p>\u559C\u6B61\u8F03\u9AD8\u7684\u4F4D\u7F6E\uFF0C\u5982\u5929\u82B1\u677F\uFF0C\u9AD8\u8EAB\u7246\u58C1\u548C\u76F8\u6846\u5F8C\u9762\u3002 \u5B83\u5011\u76F8\u5C0D\u9700\u8981\u8F03\u5C11\u7684\u6C34\u5206\uFF0C\u6240\u4EE5\u901A\u5E38\u4E0D\u5728\u5EDA\u623F\u548C\u6D74\u5BA4\u51FA\u672B\uFF0C\u4F46\u559C\u6B61\u5728\u96EA\u6AC3\u6216\u5176\u4ED6\u96FB\u5668\u3001\u5BB6\u5177\u5167\u7BC9\u5DE2\u3002</p>\n          '
        }, {
          name: '如何消滅它們',
          id: 5,
          imgpath: '',
          tag: '',
          html: '\n            <h1 class="hdr">\u5982\u4F55\u6D88\u6EC5\u5B83\u5011</h1>\n            <p>\u8981\u5FB9\u5E95\u6D88\u6EC5\u5BB6\u4E2D\u7684\u7532\u7534\uFF0C\u95DC\u9375\u662F\u6D88\u6EC5\u6574\u500B\u66F1\u7534\u5DE2\u5167\u7684\u66F1\u7534\u3002 \u5982\u679C\u53EA\u662F\u6BBA\u6B7B\u773C\u524D\u7684\u66F1\u7534\uFF0C\u5176\u9918\u7684\u6703\u7E7C\u7E8C\u5728\u5BB6\u4E2D\u51FA\u672B\u8993\u98DF\uFF0C\u5C0B\u627E\u98DF\u7269\u548C\u6C34\u6E90\u3002\u5B83\u5011\u6703\u7E7C\u7E8C\u7E41\u6B96\uFF0C\u8B8A\u5F97\u6108\u4F86\u6108\u591A\uFF0C\u5DE2\u7A74\u6703\u6108\u4F86\u6108\u5927\u3002</p>\n            <p>\u5A01\u6EC5\u901F\u6548\u66F1\u7534\u85E5\u990C\u53EF\u4EE5\u5C07\u5DE2\u7A74\u5167\u7684\u66F1\u7534\u4E00\u7DB2\u6253\u76E1\u3002\u60F3\u4E86\u89E3\u66F4\u591A\u6709\u95DC\u5A01\u6EC5\u4E00\u7DB2\u6253\u76E1\u7684\u539F\u7406\uFF0C<a href="#/preventiontips/insecticideguide">\u8ACB\u6309\u9019\u88E1</a>\u3002</p>\n          '
        }],
        selected: null,
        sortOption: null,
        filterOption: null,
        filterText: '',
        option: {
          getSortData: {
            id: 'id'
          },
          sortBy: 'id',
          getFilterData: {
            '顯示全部': function _() {
              return true;
            },
            '螞蟻': function _(el) {
              return el.tag.match(/螞蟻$/);
            },
            '曱甴': function _(el) {
              return el.tag.match(/曱甴$/);
            }
          }
        }
      }
    };
  }
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    window.document.title = '威滅Combat 速效藥餌';
    window.scrollTo(0, 0);
  },
  data: function data() {
    return {
      isotopeProps: {
        title: '常見問題',
        desc: '一切由根源入手',
        cardname: 'Q&A',
        showTag: false,
        popup: true,
        popupContents: null,
        openPopup: false,
        list: [{
          name: '購買威滅速效藥餌已一段時間，但至今仍未曾打開包裝紙盒，藥餌是否仍然有效?',
          id: 0,
          imgpath: '',
          link: '/preventiontips/faq/01',
          tag: '',
          html: '\n            <h1 class="hdr">\u8CFC\u8CB7\u5A01\u6EC5\u901F\u6548\u85E5\u990C\u5DF2\u4E00\u6BB5\u6642\u9593\uFF0C\u4F46\u81F3\u4ECA\u4ECD\u672A\u66FE\u6253\u958B\u5305\u88DD\u7D19\u76D2\uFF0C\u85E5\u990C\u662F\u5426\u4ECD\u7136\u6709\u6548?</h1>\n            <p>\u8ACB\u7559\u610F\u5916\u5305\u88DD\u4E0A\u6240\u6A19\u793A\u7684\u6709\u6548\u65E5\u671F\uFF0C\u4E26\u65BC\u6709\u6548\u671F\u524D\u4F7F\u7528\u3002<br/>\u4E00\u822C\u7684\u990C\u76D2\u4EFD\u91CF\u8DB3\u5920\u7DAD\u630190\u65E5\uFF0C\u6545\u6211\u5011\u5EFA\u8B70\u6BCF3\u500B\u6708\u61C9\u66F4\u63DB\u990C\u76D2\u3002\u7576\u7136\u5982\u679C\u5BB3\u87F2\u5927\u6279\u51FA\u6C92\uFF0C\u5247\u53EF\u80FD\u6709\u9700\u8981\u66F4\u63DB\u5F97\u8F03\u70BA\u983B\u7E41\u3002</p>\n          '
        }, {
          name: '長期使用藥餌，產品的功效會受影響嗎？曱甴/螞蟻會否對藥餌「免疫」?',
          id: 1,
          imgpath: '',
          link: '/preventiontips/faq/02',
          tag: '',
          html: '\n            <h1 class="hdr">\u9577\u671F\u4F7F\u7528\u85E5\u990C\uFF0C\u7522\u54C1\u7684\u529F\u6548\u6703\u53D7\u5F71\u97FF\u55CE\uFF1F\u66F1\u7534/\u879E\u87FB\u6703\u5426\u5C0D\u85E5\u990C\u300C\u514D\u75AB\u300D?</h1>\n            <p>\u76F4\u81F3\u76EE\u524D\u70BA\u6B62\uFF0C\u4ECD\u672A\u6709\u76F8\u95DC\u7684\u6E2C\u8A66\u7814\u7A76\u6307\u51FA\u66F1\u7534/\u879E\u87FB\u5C0D\u85E5\u990C\u6709\u514D\u75AB\u529B\u3002<br/>\u82E5\u9577\u671F\u4F7F\u7528\u7522\u54C1\u5F8C\uFF0C\u8A8D\u70BA\u6BBA\u6EC5\u6548\u679C\u53D7\u5F71\u97FF\uFF0C\u5EFA\u8B70\u5148\u6AA2\u67E5\u6240\u653E\u7F6E\u7684\u990C\u76D2\u662F\u5426\u5DF2\u7D93\u653E\u7F6E\u8D85\u904E\u4E09\u500B\u6708\u3002\u82E5\u5DF2\u7D93\u8D85\u904E\u4E09\u500B\u6708\uFF0C\u8ACB\u99AC\u4E0A\u66F4\u63DB\u65B0\u7684\u85E5\u990C\u3002</p>\n          '
        }, {
          name: '威滅藥餌應如何使用？需要把餌盒剪開？',
          id: 2,
          imgpath: '',
          link: '/preventiontips/faq/03',
          tag: '',
          html: '\n            <h1 class="hdr">\u5A01\u6EC5\u85E5\u990C\u61C9\u5982\u4F55\u4F7F\u7528\uFF1F\u9700\u8981\u628A\u990C\u76D2\u526A\u958B\uFF1F</h1>\n            <p>\u7522\u54C1\u5167\u9644\u7684\u990C\u76D2\u5747\u4EE5\u7D44\u5408\u5F62\u5F0F\uFF0C\u8ACB\u5148\u6CBF\u81A0\u76D2\u5E95\u4E4B\u865B\u7DDA\u5206\u958B\u3002\u4E26\u5C07\u990C\u76D2\u80CC\u5F8C\u9644\u6709\u7684\u9ECF\u8CBC\u7D19\u6495\u958B\uFF0C\u8CBC\u65BC\u76F8\u61C9\u7684\u5730\u65B9\u5373\u53EF\u3002\u8ACB\u7559\u610F\uFF0C\u4E26\u4E0D\u9700\u8981\u628A\u990C\u76D2\u523B\u610F\u526A\u958B\uFF0C\u7522\u54C1\u6709\u4F9D\u64DA\u66F1\u7534/\u879E\u87FB\u7684\u7FD2\u6027\u800C\u8A2D\u8A08\uFF0C\u523B\u610F\u7684\u7834\u58DE\u53CD\u800C\u6703\u5F71\u97FF\u7522\u54C1\u6BBA\u6EC5\u6548\u679C\u3002</p>\n          '
        }, {
          name: '威滅是如何發揮功效的?會否經空氣蒸發而發揮藥效?',
          id: 3,
          imgpath: '',
          link: '/preventiontips/faq/04',
          tag: '',
          html: '\n            <h1 class="hdr">\u5A01\u6EC5\u662F\u5982\u4F55\u767C\u63EE\u529F\u6548\u7684?\u6703\u5426\u7D93\u7A7A\u6C23\u84B8\u767C\u800C\u767C\u63EE\u85E5\u6548?</h1>\n            <p>\u5A01\u6EC5\u6240\u4F7F\u7528\u7684\u5FEB\u500D\u9686\u5C6C\u65BC\u56FA\u9AD4\u990C\u5291\uFF0C\u4E0D\u662F\u7D93\u63A5\u89F8\u6216\u7A7A\u6C23\u63EE\u767C\u800C\u6709\u6548\u3002\u990C\u5291\u7684\u6BD2\u6027\u9700\u8981\u7D93\u66F1\u7534/\u879E\u87FB\u9032\u98DF\u6D88\u5316\u800C\u7522\u751F\uFF0C\u800C\u990C\u76D2\u8A2D\u8A08\u53EA\u6709\u7D30\u5C0F\u7684\u6606\u87F2\u80FD\u9032\u5165\uFF0C\u4E26\u4E14\u7121\u7159\u3001\u7121\u81ED\u53CA\u7121\u5473\uFF0C\u7D55\u5C0D\u5B89\u5168\u6709\u6548\u3002</p>\n          '
        }, {
          name: '如果餌盒濕了會有何影響?',
          id: 4,
          imgpath: '',
          link: '/preventiontips/faq/05',
          tag: '',
          html: '\n            <h1 class="hdr">\u5982\u679C\u990C\u76D2\u6FD5\u4E86\u6703\u6709\u4F55\u5F71\u97FF?</h1>\n            <p>\u7F6E\u65BC\u5A01\u6EC5\u990C\u76D2\u5167\u7684\u85E5\u990C\u662F\u7D93\u6E2C\u8A66\u4E0D\u6EB6\u65BC\u6C34\u7684\u3002\u85E5\u990C\u4E0D\u6703\u56E0\u800C\u55AA\u5931\u5176\u6548\u80FD\u53CA\u91CB\u51FA\u7570\u5473\u3002\u4F46\u5982\u679C\u85E5\u990C\u5438\u6C34\u5F8C\u904E\u5EA6\u98FD\u548C\uFF0C\u5DF2\u8B8A\u8CEA\u7684\u85E5\u990C\u5C0D\u66F1\u7534/\u879E\u87FB\u4E4B\u5438\u5F15\u529B\u6703\u6E1B\u9000\uFF0C\u7522\u54C1\u7684\u529F\u6548\u6703\u53D7\u5F71\u97FF\uFF0C\u66F4\u6709\u53EF\u80FD\u6703\u6EF2\u51FA\u990C\u76D2\u5916\u3002</p>\n          '
        }, {
          name: '威滅是否可以擺放在任何地方?',
          id: 5,
          imgpath: '',
          link: '/preventiontips/faq/06',
          tag: '',
          html: '\n            <h1 class="hdr">\u5A01\u6EC5\u662F\u5426\u53EF\u4EE5\u64FA\u653E\u5728\u4EFB\u4F55\u5730\u65B9?</h1>\n            <p>\u8981\u9039\u81F4\u5A01\u6EC5\u7684\u6700\u5927\u6548\u7528\uFF0C\u6211\u5011\u5EFA\u8B70\u6309\u5305\u88DD\u4E0A\u7684\u8AAA\u660E\u64FA\u653E\u3002\u4F46\u5A01\u6EC5\u7684\u990C\u76D2\u8A2D\u8A08\u5B89\u5168\uFF0C\u53EF\u4EE5\u65BC\u5EE3\u6CDB\u7BC4\u570D\u4F7F\u7528\u4E26\u4E0D\u6C61\u67D3\u5730\u65B9\u3002</p>\n          '
        }, {
          name: '家有寵物，可以使用威滅藥餌嗎？如果寵物不小心接觸/誤服了，會有何影響？',
          id: 6,
          imgpath: '',
          link: '/preventiontips/faq/07',
          tag: '',
          html: '\n            <h1 class="hdr">\u5BB6\u6709\u5BF5\u7269\uFF0C\u53EF\u4EE5\u4F7F\u7528\u5A01\u6EC5\u85E5\u990C\u55CE\uFF1F\u5982\u679C\u5BF5\u7269\u4E0D\u5C0F\u5FC3\u63A5\u89F8/\u8AA4\u670D\u4E86\uFF0C\u6703\u6709\u4F55\u5F71\u97FF\uFF1F</h1>\n            <p>\u53EF\u4EE5\u4F7F\u7528\uFF0C\u4F46\u8ACB\u5118\u91CF\u653E\u7F6E\u65BC\u5BF5\u7269\u8F03\u5C11\u63A5\u89F8\u7684\u5730\u65B9\u3002<br/>\u4E0D\u904E\uFF0C\u5A01\u6EC5\u6240\u4F7F\u7528\u7684\u6709\u6548\u6210\u4EFD\u53EA\u5C0D\u6606\u87F2\u6709\u5BB3\uFF0C\u800C\u4E14\u6BCF\u500B\u85E5\u990C\u6240\u5167\u542B\u7684\u4EFD\u91CF\u5F88\u5C0F\uFF0C\u4E0D\u8DB3\u4EE5\u5F71\u97FF\u4E00\u822C\u5BB6\u5C45\u5BF5\u7269\u3002\u7576\u7136\uFF0C\u82E5\u679C\u5BF5\u7269\u8AA4\u670D\u5F8C\u6709\u7570\u5E38\uFF0C\u8ACB\u99AC\u4E0A\u651C\u540C\u7522\u54C1\u6A19\u7C64\u5EF6\u91AB\u51B6\u7406\u3002</p>\n          '
        }, {
          name: '怎樣處理已使用之藥餌?',
          id: 7,
          imgpath: '',
          link: '/preventiontips/faq/08',
          tag: '',
          html: '\n            <h1 class="hdr">\u600E\u6A23\u8655\u7406\u5DF2\u4F7F\u7528\u4E4B\u85E5\u990C?</h1>\n            <p>\u6309\u5305\u88DD\u4E0A\u4E4B\u6307\u793A\uFF0C\u53EF\u4EE5\u7528\u7D19\u6216\u81A0\u888B\u628A\u5DF2\u4F7F\u7528\u4E4B\u990C\u76D2\u5305\u597D\uFF0C\u518D\u653E\u7F6E\u5728\u5EE2\u7269\u7BB1\u5167\u3002</p>\n          '
        }, {
          name: '威滅速效曱甴/殺蟻藥餌能否殺滅其他害蟲?',
          id: 8,
          imgpath: '',
          link: '/preventiontips/faq/09',
          tag: '',
          html: '\n            <h1 class="hdr">\u5A01\u6EC5\u901F\u6548\u66F1\u7534/\u6BBA\u87FB\u85E5\u990C\u80FD\u5426\u6BBA\u6EC5\u5176\u4ED6\u5BB3\u87F2?</h1>\n            <p>\u5A01\u6EC5\u901F\u6548\u85E5\u990C\u662F\u5C08\u70BA\u66F1\u7534/\u879E\u87FB\u800C\u88FD\u9020\uFF0C\u56E0\u6B64\u4E0D\u80FD\u4FDD\u8B49\u5A01\u6EC5\u901F\u6548\u85E5\u990C\u5C0D\u5176\u4ED6\u5BB3\u87F2\u6709\u6548\u3002</p>\n          '
        }, {
          name: '可以在什麼地方購買威滅產品?',
          id: 9,
          imgpath: '',
          link: '/preventiontips/faq/10',
          tag: '',
          html: '\n            <h1 class="hdr">\u53EF\u4EE5\u5728\u4EC0\u9EBC\u5730\u65B9\u8CFC\u8CB7\u5A01\u6EC5\u7522\u54C1?</h1>\n            <p>\u5927\u90E8\u4EFD\u5A01\u6EC5\u7522\u54C1\u65BC\u4E0B\u5217\u5546\u6236\u6709\u552E: \u60E0\u5EB7\u3001\u767E\u4F73\u3001\u4E00\u7530\u3001AEON\u3001UNY / APITA\u3001HKTVMALL\u53CA\u6E2F\u6FB3\u5404\u85E5\u623F\u85E5\u884C\u3002\u6B32\u77E5\u9053\u66F4\u591A\u7522\u54C1\u92B7\u552E\u5730\u9EDE\uFF0C\u8ACB\u700F\u89BD\u672C\u7DB2\u9801\u7522\u54C1\u8A73\u7D30\u8CC7\u6599\u3002</p>\n          '
        }, {
          name: '威滅速效殺蟻藥餌能否殺滅白蟻/紅火蟻嗎?',
          id: 10,
          imgpath: '',
          link: '/preventiontips/faq/11',
          tag: '',
          html: '\n            <h1 class="hdr">\u5A01\u6EC5\u901F\u6548\u6BBA\u87FB\u85E5\u990C\u80FD\u5426\u6BBA\u6EC5\u767D\u87FB/\u7D05\u706B\u87FB\u55CE?</h1>\n            <p>\u5A01\u6EC5\u901F\u6548\u6BBA\u87FB\u85E5\u990C\u66AB\u6642\u53EA\u80FD\u6BBA\u6EC5\u5BB6\u4E2D\u5E38\u898B\u7684\u879E\u87FB\uFF0C\u4E0D\u80FD\u5920\u6BBA\u6EC5\u5176\u4ED6\u879E\u87FB\u54C1\u7A2E\uFF0C\u5982\u767D\u87FB/\u7D05\u706B\u87FB\u3002</p>\n          '
        }, {
          name: '為什麼於置威滅速效殺蟻藥餌巳有3星期 , 仍發現蟻群數目没有減少?',
          id: 11,
          imgpath: '',
          link: '/preventiontips/faq/12',
          tag: '',
          html: '\n            <h1 class="hdr">\u70BA\u4EC0\u9EBC\u65BC\u7F6E\u5A01\u6EC5\u901F\u6548\u6BBA\u87FB\u85E5\u990C\u5DF3\u67093\u661F\u671F , \u4ECD\u767C\u73FE\u87FB\u7FA4\u6578\u76EE\u6CA1\u6709\u6E1B\u5C11?</h1>\n            <p>\u5A01\u6EC5\u901F\u6548\u6BBA\u87FB\u85E5\u990C\u662F\u7D93\u904E\u5BE6\u9A57\u5BA4\u7684\u4E00\u9023\u4E32\u6E2C\u8A66, \u56E0\u6B64\u7522\u54C1\u6709\u4E00\u5B9A\u7684\u6548\u679C\u3002\u4F46\u4EA6\u53EF\u4EE5\u53C3\u8003\u4EE5\u4E0B\u879E\u87FB\u6C92\u6709\u6E1B\u5C11\u7684\u539F\u56E0\u3002</p>\n            <ol>\n              <li>\u879E\u87FB\u70BA\u7FA4\u5C45\u6027\u7684\u6606\u87F2\uFF0C\u879E\u87FB\u6B7B\u5F8C\uFF0C\u540C\u4F34\u6703\u5C07\u85E5\u990C\u9023\u5E36\u5C4D\u9AD4\u5E36\u56DE\u87FB\u5DE2\uFF0C\u87FB\u5DE2\u53EF\u96B1\u85CF\u65BC\u4E0D\u540C\u5730\u65B9\uFF0C\u4E0D\u5BB9\u6613\u88AB\u767C\u73FE\u3002</li>\n              <li>\u5916\u5728\u74B0\u5883\u56E0\u7D20\u662F\u6211\u5011\u4E0D\u80FD\u63A7\u5236\u7684. \u5982\u679C\u5728\u5A01\u6EC5\u6BBA\u87FB\u85E5\u990C\u9644\u8FD1\u7684\u74B0\u5883\u4E0D\u6F54\u6DE8, \u87FB\u7FA4\u4E26\u4E0D\u6613\u65BC\u9032\u5165\u990C\u76D2.</li>\n              <li>\u5982\u679C\u662F\u6BD4\u8F03\u708E\u71B1\u6216\u6F6E\u6FD5\u7684\u5929\u6C23, \u87FB\u7FA4\u6703\u4EE5\u9A5A\u4EBA\u7684\u901F\u5EA6\u5927\u91CF\u7E41\u6B96, \u5728\u6B64\u60C5\u6CC1\u4E0B, \u5373\u4F7F\u4E4B\u524D\u653E\u7F6E\u7684\u85E5\u990C\u990C\u5DF3\u767C\u63EE\u529F\u6548, \u4ECD\u672A\u80FD\u628A\u6574\u500B\u87FB\u7FA4\u6D88\u6EC5.</li>\n            </ol>\n          '
        }],
        selected: null,
        sortOption: null,
        filterOption: null,
        filterText: '',
        option: {
          getSortData: {
            id: 'id'
          },
          sortBy: 'id',
          getFilterData: {
            '顯示全部': function _() {
              return true;
            },
            '螞蟻': function _(el) {
              return el.tag.match(/螞蟻$/);
            },
            '曱甴': function _(el) {
              return el.tag.match(/曱甴$/);
            }
          }
        }
      }
    };
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    window.document.title = '威滅Combat 速效藥餌';
    window.scrollTo(0, 0);
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    window.document.title = '威滅Combat 速效藥餌';
    window.scrollTo(0, 0);
  }
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    window.document.title = '威滅Combat 速效藥餌';
    window.scrollTo(0, 0);
  },
  data: function data() {
    return {
      isotopeProps: {
        title: '預防小貼士',
        desc: '了解預防小貼士',
        cardname: '預防小貼士',
        showTag: true,
        list: [{
          name: '預防曱甴',
          id: 0,
          imgpath: __webpack_require__(151),
          link: '/preventiontips/tips/roach',
          tag: '曱甴'
        }, {
          name: '預防螞蟻',
          id: 1,
          imgpath: __webpack_require__(149),
          link: '/preventiontips/tips/ant',
          tag: '螞蟻'
        }, {
          name: '預防一般昆蟲',
          id: 2,
          imgpath: __webpack_require__(150),
          link: '/preventiontips/tips/general',
          tag: ''
        }],
        selected: null,
        sortOption: null,
        filterOption: null,
        filterText: '',
        option: {
          getSortData: {
            id: 'id'
          },
          sortBy: 'id',
          getFilterData: {
            '顯示全部': function _() {
              return true;
            },
            '螞蟻': function _(el) {
              return el.tag.match(/螞蟻$/);
            },
            '曱甴': function _(el) {
              return el.tag.match(/曱甴$/);
            }
          }
        }
      }
    };
  }
});

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    window.document.title = '威滅Combat 速效藥餌';
    window.scrollTo(0, 0);
  }
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    window.document.title = '威滅Combat 速效藥餌';
    window.scrollTo(0, 0);
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    window.document.title = '威滅Combat 速效藥餌';
    window.scrollTo(0, 0);
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  head: {
    meta: [{ name: 'application-name', content: 'combat about' }]
  },
  data: function data() {
    return {};
  },
  created: function created() {
    window.document.title = '威滅Combat 速效藥餌';
    window.scrollTo(0, 0);
  }
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    var _this = this;

    window.document.title = '威滅Combat 速效藥餌';
    window.scrollTo(0, 0);

    window.onresize = function () {
      var vw = document.documentElement.clientWidth;
      if (vw >= 780 && !_this.openOverlay) {
        location.reload();
      }
    };
  },
  data: function data() {
    var _this2 = this;

    return {
      openOverlay: false,
      tabIndex: 1,
      curProduct: 0,
      locationIcon: __webpack_require__(50),
      locationIcon2x: __webpack_require__(51),
      crossBtn: __webpack_require__(20),
      arrowBtn: __webpack_require__(47),
      opts: {
        start: 0,
        overflow: '',
        dir: 'v',
        duration: 500,
        beforeChange: function beforeChange(obj, prev, next) {
          _this2.curProduct = next;
        },
        afterChange: function afterChange(obj, prev, next) {
          // console.log('after', prev)
        }
      },
      overlayWorks: [{
        src: __webpack_require__(174),
        srcset: __webpack_require__(175),
        text: '螞蟻被誘進餌盒進食藥餌'
      }, {
        src: __webpack_require__(176),
        srcset: __webpack_require__(177),
        text: '螞蟻吃過藥餌後爬出，將藥餌帶回巢穴'
      }, {
        src: __webpack_require__(178),
        srcset: __webpack_require__(179),
        text: '回巢後死亡，迅速將藥餌傳播給同類，將巢穴內的螞蟻一網打盡'
      }],
      overlayMenu: [{

        img: __webpack_require__(5),
        srcset: __webpack_require__(5),
        name: '銷售地點'
      }, {
        img: __webpack_require__(10),
        srcset: __webpack_require__(63),
        name: '產品詳細資料'
      }, {
        img: __webpack_require__(11),
        srcset: __webpack_require__(64),
        name: '使用方法'
      }, {
        img: __webpack_require__(12),
        srcset: __webpack_require__(65),
        name: '連環殺滅功能'
      }],
      overlayMethod: [{
        src: __webpack_require__(61),
        srcset: __webpack_require__(62),
        index: 1,
        text: '將餌盒背後的黏貼紙撕開'
      }, {
        src: __webpack_require__(25),
        srcset: __webpack_require__(26),
        index: 2,
        text: '把整個餌盒貼於螞蟻經常出沒的地方，如廚房牆邊、窗邊、垃圾桶周圍及露台盆栽、花槽側。'
      }, {
        src: __webpack_require__(27),
        srcset: __webpack_require__(28),
        index: 3,
        text: '妥善放置餌盒，儘量使其穩固於牆壁、地面、角落。'
      }, {
        src: __webpack_require__(167),
        srcset: __webpack_require__(168),
        index: 4,
        text: '欲獲得最佳效果，應同時使用整盒 6 個餌盒。'
      }, {
        src: __webpack_require__(29),
        srcset: __webpack_require__(30),
        index: 5,
        text: '請勿把噴霧殺蟲劑直接噴在餌盒上或其附近。'
      }, {
        src: __webpack_require__(31),
        srcset: __webpack_require__(32),
        index: 6,
        text: '定時每隔三個月更換一次餌盒，以達致長期最佳後果。'
      }, {
        src: __webpack_require__(169),
        srcset: __webpack_require__(170),
        index: 7,
        text: '請勿騷擾正在取食藥餌的螞蟻，以免減低效能。'
      }, {
        src: __webpack_require__(171),
        srcset: __webpack_require__(172),
        index: 8,
        text: '藥餌初用時會吸引螞蟻聚集，故附近螞蟻數量會暫時增加，一週內會明顯減少。'
      }]
    };
  },

  methods: {
    toggleOverlay: function toggleOverlay(index) {
      if (index === undefined) {
        this.openOverlay = false;
        return;
      }

      this.openOverlay = !this.openOverlay;
      this.tabIndex = index;
    },
    scrollToProduct: function scrollToProduct(index) {
      this.curProduct = index;
      this.$refs.fullpage.$fullpage.moveTo(index);
    },
    moveNextPage: function moveNextPage() {
      this.$refs.fullpage.$fullpage.moveNext();
    },
    nextOverlayTab: function nextOverlayTab() {
      if (this.tabIndex === this.overlayMenu.length - 1) {
        this.tabIndex = 0;
        return;
      }
      this.tabIndex += 1;
    },
    previousOverlay: function previousOverlay() {
      if (this.tabIndex === 0) {
        this.tabIndex = this.overlayMenu.length - 1;
        return;
      }

      this.tabIndex -= 1;
    }
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  head: {
    meta: [{ name: 'application-name', content: 'combat about' }]
  },
  data: function data() {
    var _this = this;

    return {
      openOverlay: false,
      tabIndex: 1,
      curProduct: 0,
      locationIcon: __webpack_require__(50),
      locationIcon2x: __webpack_require__(51),
      crossBtn: __webpack_require__(20),
      arrowBtn: __webpack_require__(47),
      opts: {
        start: 0,
        overflow: '',
        dir: 'v',
        duration: 500,
        beforeChange: function beforeChange(obj, prev, next) {
          // console.log('prev:' + prev + ':' + next + ':' + a + ':' + b)
          _this.curProduct = next;
        },
        afterChange: function afterChange(obj, prev, next) {
          // console.log('after:' + prev + ':' + next + ':' + a + ':' + b)
        }
      },
      overlayWorksGel: [{
        src: __webpack_require__(201),
        srcset: __webpack_require__(202),
        text: '曱甴被誘進餌盒進食藥餌'
      }, {
        src: __webpack_require__(203),
        srcset: __webpack_require__(204),
        text: '曱甴吃過藥餌後，將藥餌帶回巢穴'
      }, {
        src: __webpack_require__(35),
        srcset: __webpack_require__(36),
        text: '回巢後死亡，並成為其他曱甴的食物，迅速將藥餌傳播給同類，將巢穴內的曱甴一網打盡'
      }],
      overlayWorks: [{
        src: __webpack_require__(191),
        srcset: __webpack_require__(192),
        text: '曱甴被誘進餌盒進食藥餌'
      }, {
        src: __webpack_require__(193),
        srcset: __webpack_require__(194),
        text: '曱甴吃過藥餌後爬出，將藥餌帶回巢穴'
      }, {
        src: __webpack_require__(35),
        srcset: __webpack_require__(36),
        text: '回巢後死亡，並成為其他曱甴的食物，迅速將藥餌傳播給同類，將巢穴內的曱甴一網打盡'
      }],
      overlayWorks2: [{
        src: __webpack_require__(196),
        srcset: __webpack_require__(197),
        text: '曱甴被誘進餌盒進食藥餌'
      }, {
        src: __webpack_require__(198),
        srcset: __webpack_require__(199),
        text: '曱甴吃過藥餌後爬出，將藥餌帶回巢穴'
      }, {
        src: __webpack_require__(35),
        srcset: __webpack_require__(36),
        text: '回巢後死亡，並成為其他曱甴的食物，迅速將藥餌傳播給同類，將巢穴內的曱甴一網打盡'
      }],
      overlayMenu: [{
        img: __webpack_require__(5),
        srcset: __webpack_require__(5),
        name: '銷售地點'
      }, {
        img: __webpack_require__(10),
        srcset: __webpack_require__(63),
        name: '產品詳細資料'
      }, {
        img: __webpack_require__(11),
        srcset: __webpack_require__(64),
        name: '使用方法'
      }, {
        img: __webpack_require__(12),
        srcset: __webpack_require__(65),
        name: '連環殺滅功能'
      }],
      overlayMethodGel: [{
        src: __webpack_require__(3),
        srcset: __webpack_require__(3),
        index: 1,
        text: '轉開餌劑蓋子'
      }, {
        src: __webpack_require__(3),
        srcset: __webpack_require__(3),
        index: 2,
        text: '任何罅隙、裂縫及陰暗位置「點」一下「專業強效曱甴凝膠餌劑」，(點狀或條狀皆可), 包括:<br><ul><li>窗邊</li><li>廚櫃罅隙</li><li>雪櫃底</li><li>鋅盤底的罅隙</li><li>渠位附近</li><li>排水位附近</li><li>餐桌底暗角</li></ul>'
      }, {
        src: __webpack_require__(3),
        srcset: __webpack_require__(3),
        index: 3,
        text: '每平方公尺建議使用0.25克-0.5克。使用完記緊扭實蓋子。'
      }, {
        src: __webpack_require__(3),
        srcset: __webpack_require__(3),
        index: 4,
        text: '如發現凝膠餌劑體積變小，請酌量補加，以維持良好的滅蟲效果。'
      }, {
        src: __webpack_require__(3),
        srcset: __webpack_require__(3),
        index: 5,
        text: '請勿把噴霧殺蟲劑直接噴在藥餌上或其附近。'
      }, {
        src: __webpack_require__(3),
        srcset: __webpack_require__(3),
        index: 6,
        text: '定時每隔三個月更換一次藥餌，以達致長期最佳後果。'
      }],
      overlayMethod: [{
        src: __webpack_require__(187),
        srcset: __webpack_require__(188),
        index: 1,
        text: '將餌盒背後的黏貼紙撕開'
      }, {
        src: __webpack_require__(25),
        srcset: __webpack_require__(26),
        index: 2,
        text: '把整個餌盒貼於曱甴經常出沒的地方，如廚房爐灶、洗碗糟、冰箱、垃圾桶及洗手間水渠口、廁所背後周圍。'
      }, {
        src: __webpack_require__(27),
        srcset: __webpack_require__(28),
        index: 3,
        text: '妥善放置餌盒，儘量使其穩固於牆壁、地面、角落。'
      }, {
        src: __webpack_require__(189),
        srcset: __webpack_require__(190),
        index: 4,
        text: '欲獲得最佳效果，應同時使用整盒 6 個餌盒。'
      }, {
        src: __webpack_require__(29),
        srcset: __webpack_require__(30),
        index: 5,
        text: '請勿把噴霧殺蟲劑直接噴在餌盒上或其附近。'
      }, {
        src: __webpack_require__(31),
        srcset: __webpack_require__(32),
        index: 6,
        text: '定時每隔三個月更換一次餌盒，以達致長期最佳後果。'
      }],
      overlayMethodTwo: [{
        src: __webpack_require__(61),
        srcset: __webpack_require__(62),
        index: 1,
        text: '將餌盒背後的黏貼紙撕開'
      }, {
        src: __webpack_require__(25),
        srcset: __webpack_require__(26),
        index: 2,
        text: '把整個餌盒貼於曱甴經常出沒的地方，如廚房爐灶、洗碗糟、冰箱、垃圾桶及洗手間水渠口、廁所背後周圍。'
      }, {
        src: __webpack_require__(27),
        srcset: __webpack_require__(28),
        index: 3,
        text: '妥善放置餌盒，儘量使其穩固於牆壁、地面、角落。'
      }, {
        src: __webpack_require__(165),
        srcset: __webpack_require__(166),
        index: 4,
        text: '欲獲得最佳效果，應同時使用整盒 9 個餌盒。'
      }, {
        src: __webpack_require__(29),
        srcset: __webpack_require__(30),
        index: 5,
        text: '請勿把噴霧殺蟲劑直接噴在餌盒上或其附近。'
      }, {
        src: __webpack_require__(31),
        srcset: __webpack_require__(32),
        index: 6,
        text: '定時每隔三個月更換一次餌盒，以達致長期最佳後果。'
      }]
    };
  },
  created: function created() {
    window.document.title = '威滅Combat 速效藥餌';
    window.scrollTo(0, 0);
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.$root.switchCockroach > -1) {
      var _self = this;
      var vw = document.documentElement.clientWidth;
      var targetname = null;

      switch (this.$root.switchCockroachTarget) {
        case 0:
          targetname = 'cockroach_1';
          break;
        case 1:
          targetname = 'cockroach_2';
          break;
        case 2:
          targetname = 'cockroach_gel';
          break;
      }

      if (vw >= 780) {
        setTimeout(function () {
          _self.scrollToProduct(_self.$root.switchCockroachTarget);
        }, 100);
      } else {
        setTimeout(function () {
          _self.scrollMeTo(targetname);
        }, 200);
      }

      this.$root.switchCockroach = -1;
    }
    window.onresize = function () {
      var vw = document.documentElement.clientWidth;
      if (vw >= 780 && !_this2.openOverlay) {
        location.reload();
      }
    };
  },

  methods: {
    scrollMeTo: function scrollMeTo(refName) {
      var element = this.$refs[refName];
      var top = element.offsetTop - 52;

      window.scrollTo(0, top);
    },
    movePrevPage: function movePrevPage() {
      this.$refs.fullpage.$fullpage.movePrev();
    },
    moveNextPage: function moveNextPage() {
      this.$refs.fullpage.$fullpage.moveNext();
    },
    scrollToProduct: function scrollToProduct(index) {
      this.curProduct = index;
      this.$refs.fullpage.$fullpage.moveTo(index);
    },
    toggleOverlay: function toggleOverlay(index, productIndex) {
      console.log('curProduct:' + this.curProduct);

      if (index === undefined) {
        this.openOverlay = false;
        return;
      }

      if (!productIndex) {
        this.curProduct = 0;
      } else {
        this.curProduct = productIndex;
      }

      this.openOverlay = !this.openOverlay;
      this.tabIndex = index;
      console.log('openOverlay', this.openOverlay);
    },
    fixHtmlScroll: function fixHtmlScroll() {
      var html = document.getElementsByTagName('html')[0];
      var body = document.getElementsByTagName('body')[0];
      if (this.openOverlay) {
        html.style.overflowY = 'hidden';
        body.style.position = 'fixed';
      } else {
        html.style.overflowY = 'auto';
        body.style.position = 'relative';
      }
    },
    nextOverlayTab: function nextOverlayTab() {
      if (this.tabIndex === this.overlayMenu.length - 1) {
        this.tabIndex = 0;
        return;
      }
      this.tabIndex += 1;
    },
    previousOverlay: function previousOverlay() {
      if (this.tabIndex === 0) {
        this.tabIndex = this.overlayMenu.length - 1;
        return;
      }

      this.tabIndex -= 1;
    }
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    window.document.title = '威滅Combat 速效藥餌';
    window.scrollTo(0, 0);
  },

  methods: {
    jumpToCockroach: function jumpToCockroach(target) {
      this.$root.switchCockroach = 1;
      this.$root.switchCockroachTarget = target;
      this.$router.push({ path: 'product/cockroach' });
    }
  }
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  head: {
    meta: [{ name: 'application-name', content: 'combat about' }]
  },
  data: function data() {
    return {};
  },
  created: function created() {
    window.document.title = '威滅Combat 速效藥餌';
    window.scrollTo(0, 0);
  }
});

/***/ }),
/* 109 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 110 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 111 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 113 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 114 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 116 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 117 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 118 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 119 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 120 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 121 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 122 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 123 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 124 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 125 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 126 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 127 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 128 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 129 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 130 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 131 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 132 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/about-section1.108757a.jpg";

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/about-section2-m.cdd344f.png";

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/about-section2.bbc0128.png";

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 148 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/grid-ptips-ant.3e09c83.jpg";

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/grid-ptips-general.e85da68.jpg";

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/grid-ptips-roach.2139690.jpg";

/***/ }),
/* 152 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFsAAAAzCAMAAADPT4ScAAAAdVBMVEUAAADrKhzrKhzrKhzrKhzrKhzrKhzrKhzrKhzrKhzrKhzrKhzrKhzrKhzrKhzrKhzrKhzrKhzrKhzrKhzrKhzrKhzrKhzrKhzrKhzrKhzrKhzrKhzrKhzrKhzrKhzrKhzrKhzrKhzrKhzrKhzrKhzrKhzrKhzFqYdMAAAAJnRSTlMA4lBAHwnQBtrB7JBgn/ryLq8PazxySiW3hFs2FntXf8immZWLZcj7+9wAAAL4SURBVFjDzZjZmqIwEIUDdCCA7KuioqLn/R9xqiKC42C33cLXcy5Yi59wklQSxG/KqcrsHNQHI4rAiiLjUAfnzPpw3sHKPAvsEM8U2kHWyJ8UN2/dsGeo+rQuNqZlxXFsWeamWJ9qdbtZ7xrnW+Ay8MAykl355Nudj3KXGGB5J+tVfNx5mhtstl/GbjeBofHn6oUi7w8gqXUsXlW8ViDV5hfkFYd5fg9+He/zp9qf0Usm26uf1L1c2fxsLqb1kVzf/VOZTA8m6+gSAcZevKO9AXj/ImQChGsp3pNch8DJefDDBlQj3lejgMNfvlQGcJRiDskjoD7uSk3onZhLO4IPJU8VkIn5lAH2zYQEKMgXy+oNl5Zlfd7dfd+f7uOt7xOkIIeF1goIOB4weosAfN7MKcASUzKAFe0CYK8d8aDkzGyp4DGzBXIxM1vkunE4HhIxN5vr0HOECeTP2E1Xu8csZePatq0c0+8u6R27MU1TZ8HaTYp0YPcFL8WJiNNsp4OWEV8vFTZIXj6wyxDYCLGGlteMbH3UCRvBwA5tLXVlt4Qtq4K2UrOh2o5oxo3dRLpbZIQ1qyyEl96zA9giQnFjj2L2ljilDsJFs5XUIFRXduUBrRAyura3Mxg0sgtEFLYZy+1qHZjNzT5KSYRLNDtj35mq2ZxPz5y16XhLYRvAvWfTObOn/T5jkDFW78AminJ09hgUPbDZk2l2d/fQBHsVsSVck6MePOG6nGav+bzXBNva8yVmEKTXQ10+b4NsZMqGJsllii1ORK2ERcecrq0kKR7a4PO+Iz3QbSFtYDPJlgpQqWPopOe4QPbYd573eS64nVD0wZlkizjkJmTRVnGYLR/6/JirMtftk+6W2iFfyg8geb4cLwnax7etWNHeFE2t67tjA4+uW95y1ZBjp5XGeeWIUa+G6Rw7jA3zSo8N45g2p3hMW3IsXnAOsfTcZ/k5G79uxrnmcnPkBef2y61JlltLLbcGXG7t+utr7u//K/iP/nHM8W/mDz4zixj2Qrf+AAAAAElFTkSuQmCC"

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/henkel@2x.678a9d1.png";

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home_bg.12047fa.jpg";

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home_bg_2.afdff7a.jpg";

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home_bg_2_m.4147f6c.jpg";

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home_bg_2_tagline.411d588.jpg";

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home_bg_m.956f587.jpg";

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home_cartoon_m_2_2022.533e94c.png";

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home_cartoon_main_2022.7c07d4f.png";

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home_slogan2.bbe10ec.png";

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home_slogan_m.1c07f7a.png";

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/locationSymbol@2x.2d0fb10.png";

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/overlay-method4-9baits.cac0d23.png";

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/overlay-method4-9baits@2x.b277a55.png";

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/overlay-method4.a4ff0c5.png";

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/overlay-method4@2x.0d79280.png";

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/overlay-method7.83d04fb.png";

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/overlay-method7@2x.87a8588.png";

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/overlay-method8.6503853.png";

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/overlay-method8@2x.c91ff82.png";

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/overlay-work.958b9a5.png";

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/overlay-work1.dc73b9a.png";

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/overlay-work1@2x.6074620.png";

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/overlay-work2.9de204a.png";

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/overlay-work2@2x.3b5dd13.png";

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/overlay-work3.7eda4ae.png";

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/overlay-work3@2x.7652f35.png";

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pets.24cb14b.png";

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pi-roach-cover-american.9469fe1.jpg";

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pi-roach-cover-brownbanded.64813ae.jpg";

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pi-roach-cover-german.9d6cfcb.jpg";

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/productAnt-section1-m.4e5a4ac.jpg";

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/productAnt-section2-overlay-nobadge.3b3939a.png";

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/productAnt-section2-overlay.55e86a6.png";

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/productCock-overlay-method1.fbb216b.png";

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/productCock-overlay-method1@2x.e9d5fc9.png";

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/productCock-overlay-method4.77ea782.png";

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/productCock-overlay-method4@2x.a82e437.png";

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/productCock-overlay-works-m1.83a7d38.png";

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/productCock-overlay-works-m1@2x.15d62b4.png";

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/productCock-overlay-works-m2.d2fe55b.png";

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/productCock-overlay-works-m2@2x.33484c7.png";

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/productCock-overlay-works.d395470.png";

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/productCock-overlay-works2-m1.63bb59f.png";

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/productCock-overlay-works2-m1@2x.38aedc8.png";

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/productCock-overlay-works2-m2.35b2228.png";

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/productCock-overlay-works2-m2@2x.37ef07c.png";

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/productCock-overlay-works2.01ee61b.png";

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/productCock-overlay-worksgel-m1.459c781.png";

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/productCock-overlay-worksgel-m1@2x.1cd47e1.png";

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/productCock-overlay-worksgel-m2.6f4db40.png";

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/productCock-overlay-worksgel-m2@2x.32c9719.png";

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/productCock-overlay-worksgel.ede7eb4.png";

/***/ }),
/* 206 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4ZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo5MTgzNGFhNS05OTJkLTRhODgtODljYy02MjczNWMzNTc2MjAiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QTg5QUE4RjA5REUxMTFFN0I4RDhFRUZGNTI4NEU1QzIiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QTg5QUE4RUY5REUxMTFFN0I4RDhFRUZGNTI4NEU1QzIiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDozMDE2MTRkNi0yZjBhLTQ3NjMtOGY5NS00MWUzMTEwMmUzYWYiIHN0UmVmOmRvY3VtZW50SUQ9ImFkb2JlOmRvY2lkOnBob3Rvc2hvcDowMGM5Njg3Ni1jZjUxLTExN2EtOTMxMy04MjQzYTIwNjYzYWYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5EGX5gAAAI8klEQVR42uxdCWwVRRj+e1AKtAVqUYoiUECKXB4YSoCmNWkgloAC4awFpVQDJCoexCNFa4yaGDDRGqTlasVCBBQDAjHhlMhRE7kPKSAeqGApbYG2tNT53s6D56Ovu/ve7rx5u/slX0Lpbmfm/3auf/6ZCWvYH0+SoxPjQMZ+jEmM3Rk7MyYwIvOtGGP4szWMNxgrGC8x/sV4jvEM41HGQ4wXZS5spIR56sU4knEY5/063nUL05Gxp49nzjPu4dzKeFqmwodJUkOSGbMYJ3FBRAKCrGH8gvGEnQVBwlO5EEMk+UD3cWG+5M2eLQTpwziPMZsxWtKmvJaxmHEh40mRCYcLTOsB/vUdY8yVWAziecvleV3F824ZQTAaKuCjnGmCPwIj7DOV572AlyVkBQljnMn4C+NsSUd0ekajs3lZcnjZQkoQzBW2MRYxdiDrAGUp5GXrHiqCYNR0kDGNrIs0XsYsmQVpzb+eEsY4sj7ieFkLedmlEgSujN28fbUbcnjZE2URpD+fUD1G9gXKvpfbIqiCpDDuIn3+Jqvifm6LlGAJksr4PSmOPAcKOnKbpIoWBL6nTXTbu+rgNmCTjeSnf84fQQaQ4rZ2xPCNWG6jAWYL0oXxO8b2js1V0Z7b6j6zBIliXK83AZsDtlrLbWe4IAUkz7pFKAE2+8xoQbJsOukzCjNJo5tFywJVd1L8NnGOXQNCFeMgUoIu/K4hcDMvc8QwBLDhclJx3YdrqGrpji0NQ5pa099Sk3UX4ylSghEcGIfLjL0Z/9VbQ95xxDAFcK/k660hWNTHOnKkYz9T0EBKJOYp71/4MvgCkWKc/LWB9h2uo6qaJtfP08e0pdi24VYWBLZ9m5QACtUagripYyQgOuTT1TW0eG09nTj///+fMTqCivIs7525yWvJCbU+5GURYqTPukwvLrxTDGDFxkbasP2a1QWBjeepdeoJZMLCvTfeK6qm3QebWnxmVn4tVV+7aXVRssgr1stbEIR3tjG7v1iw5IbqcxVXiVZ+a/laAltPb0mQWWbn4I1PqjU/iybtwqVGq4uS40uQR0nZFmBq7diwq0nXOwtLrlpdkGRu+zsEmWh2ykXr9TdBi0obqOx4ndVFmdicIOPMTnXznga/3nt/qeX7knHegmD7l+k7l5ob4moBmjmL15JeXINbgowyO8VADWqDWjLKU5DhsudW72AgBDHcU5BhZqfWp1urgN5fltfaNoJgH3hXs1MLxFkIMbJHt7O6IIhQ6QQrDRSV4thUfRuP4pkG6z6MtoMYbjwEQfoJEyQtSpcYu1fE0dj0tmQj9IVfPklUahkp2Nxap0mM8k0drL4m0hySUOIeolJLTIjQ1Gy9MK2VHcW4JUgXkSlmZ6qPlkq33CCbIhGCJIhM8fEh0a4mSW1Gb4MFqubgGmUJ3baMpmj6GPXl+jcLau0oSHsIEiE61Zxx6iMn1BKsudsMkRAkVnSqfbpFaurc8z+3xQKVJ2KCNpR5faZ6LcEy7twPqmxVRSBIdTASHty3tSvcRw1wKtqo6aqBIEFrE96dHaM64gKwtm6TUVcDBKkM2qCbTRQL87Qdm4WwIKzJWxxXIMilYOYAvqqXpqgPg9GfjJhRZXVRLkKQP4Odi7znYmjEoDDNovi7+rj9wHVXfyRxAN4FCHI22LnAZHHxW7Ga+hOIkjL9qu4+5dVFVZQx57qrP+qZWSmrMGchyBkZcoK5Cdzt8RqXPsbPr6Wc/CuajArxEE7kKapbmOKNUsV9lUOQY7LkBqJo7eQBBGUPza5ssQnD7yCer9r2bH4d9Z9Q4WrOJMBxbEfAEu4/Mn0m+KJ9GdEXMKfBMBojNzcwAECfU6GxEsB7gAkr5khBQmf3/pDfSLITGvwRBcCIze0r0yOGJz6eF0VzJws/yuV3xq5uQUoZJ8vWw/krihHAqG97odCTp1YzTnH7sn6QcQyIOcrele00d/RGQm3/ignA5QC34rK2yDowR3uO0Vey9c+s2+wpSDmnlMDo68fiDrrDiAKqnQLT8rS/p/t9vcyfDyaP6z7q6OpwReCRZKE7wte5/+EpyJpQqNcY/aBfMbsJm5DRRmSxvmpOkJ9IggtNtPYrR9bGu2qLGR0+5jRoJgUB12GUNScIUBRKvSBqCwLqIIxRNQbzmEWvCF3VLvT8wfvgAIQEYVtNGwpBwP2xanO9y6WiF6hpcNsIDl2Fvwaf0iVfggBLSMBuXDMBh+PX267T8g31qvMJ1KznJ0QF6zgP1I7clmqIK4+kHDxjiVhOiFN2tI6OljfSz6ca6XLVTUq6N4K6JYZTxtBokX2FN+CmxtHkx9UEAXAp1hRyYCbgrtJ0+AzgHM9kLhp47bjjwjFfzdIp3pc4MK/vaPb2N7Uj/nDnknPYvrFAlA+2Qes+4g8vzHfsZzhe8yWGmiDuieIOx4aGYYfa5FtNEAzinyHlEGAHgaGK27IpEEGAc4xzHHsGjLmkcqq1VkEAXJm61LGp34DtSrQ8qGc2jlqy37GtbpTpaWH0CILgp/GkREc40AbY6inSshfcD0HcCTzBeMWxtSqucFvp+oD9cSAeJuUooRrH5j5Rw210WO+L/np0cYlipiOKTzEyuY1IlCAALlHMoCBu+JEQldwmu/z9A4GueeArwCWK5x0tXDZI9bdmGCWIu0/BdaMHbCwGyj7Unz7DDEGAC/zrsOPkcSkvuyE70YxcpkVUNE5pfprs4ftCGbN5mQ2LCDdj3RxulocZd1pYjJ28jCVG/2GzAhmwTQ6XieVabBRWycuUTiZtBTQzsgRuZixV4gIs3HQZyvuZG3gZevMymbZXQUSoD4LA4FzDoj6iWULpUhDktZTnfQ4J2NMvMvYKi/rTGB8kJYBC5gOxankecUDoVPIRkGAGtFy9ahY6eYxSkiURAsHmWGItZrwYjAwEUxBPDGacxPgkCbgUwAunGb8hZTtGWbANIYsgnoAgI0k5/nwEGb87+A9SfE3Y07eVCyINZBTEG3eTcvo2OtYenPeQEqmPmDFsqXLvEsEm6HpSrjdFB/w3KUeHgEcYD5Fke/K98Z8AAwC6oV2KeeSUjQAAAABJRU5ErkJggg=="

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/telSymbol@2x.ae404ce.png";

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tips-section1-m.211f1e6.jpg";

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tips-section1.3d5ab93.jpg";

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tips-section2bb.6848df3.jpg";

/***/ }),
/* 211 */,
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(117)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(93),
  /* template */
  __webpack_require__(235),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(113)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(94),
  /* template */
  __webpack_require__(231),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(120)
  __webpack_require__(119)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(237),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-43064b5c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(125)
  __webpack_require__(124)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(96),
  /* template */
  __webpack_require__(241),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-63866b00",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(111)
  __webpack_require__(110)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(97),
  /* template */
  __webpack_require__(229),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0e4968da",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(121)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(238),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4911f660",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(131)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(99),
  /* template */
  __webpack_require__(247),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b6ef37d6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(115)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(100),
  /* template */
  __webpack_require__(233),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-348175b8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(126)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(242),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-66cd6a5a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(127)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(102),
  /* template */
  __webpack_require__(243),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-80633158",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(129)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(103),
  /* template */
  __webpack_require__(245),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8f58bfd6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(114)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(232),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(122)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(105),
  /* template */
  __webpack_require__(239),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(118)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(106),
  /* template */
  __webpack_require__(236),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3f73ba52",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(116)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(234),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3c865c40",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(130)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(108),
  /* template */
  __webpack_require__(246),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "henkel"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(152),
      "srcset": _vm.hk2x + ' 2x'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('div', [_c('router-link', {
    attrs: {
      "to": "/terms"
    }
  }, [_vm._v("\n        使用條款\n      ")])], 1), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": "/privacy"
    }
  }, [_vm._v("\n        私隱權守則\n      ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_vm._v("\n    © 2018 - 2022 Henkel\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 229 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "generalPage"
  }, [_c('isotopegrid', {
    attrs: {
      "isotopeProps": _vm.isotopeProps
    }
  }), _vm._v(" "), _c('contact'), _vm._v(" "), _c('henkel-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-container"
  }, [_c('div', {
    staticClass: "contact"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "contact__items row text-center justify-content-center"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-2"
  }, [_c('a', {
    attrs: {
      "href": "https://www.google.com.hk/maps/place/SOUTHMARK/@22.249049,114.1643218,19z/data=!4m5!3m4!1s0x34040018d827732b:0xbba21061bdcde893!8m2!3d22.249044!4d114.164869?hl=zh",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "symbol"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(163),
      "srcset": _vm.ls2x + ' 2x'
    }
  })]), _vm._v(" "), _c('p', [_vm._v("\n            香港黃竹坑業興街 11 號南匯廣場 A 座 23 樓\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-2"
  }, [_c('a', {
    attrs: {
      "href": "tel:+852 28959515"
    }
  }, [_c('div', {
    staticClass: "symbol"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(206),
      "srcset": _vm.ts2x + ' 2x'
    }
  })]), _vm._v(" "), _c('p', [_vm._v("\n            查詢熱線\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            2895 9515\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-2"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/Combat.HK/",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "symbol"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(147),
      "srcset": _vm.fs2x + ' 2x'
    }
  })]), _vm._v(" "), _c('p', [_vm._v("\n            Facebook\n          ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact__title row text-center"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._v("\n        聯絡我們\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact__subtitle row text-center"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._v("\n        DKSH Hong Kong Limited\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._v("\n        大昌華嘉香港有限公司\n      ")])])
}]}

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('div', {
    ref: "content",
    staticClass: "content"
  }, [_c('div', {
    staticClass: "fullpage-container hidden-sm-down"
  }, [_c('div', {
    directives: [{
      name: "fullpage",
      rawName: "v-fullpage",
      value: (_vm.opts),
      expression: "opts"
    }],
    ref: "fullpage",
    staticClass: "fullpage-wp"
  }, [_c('div', {
    staticClass: "page-1 page"
  }, [_c('div', {
    staticClass: "bg_wrapper"
  }, [_c('div', {
    staticClass: "polygon"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg_container",
    class: ['active' + _vm.visual]
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "slogan"
  }, [_c('div', {
    staticClass: "artwork_wrapper"
  }, [_c('div', {
    staticClass: "link_wrapper"
  }, [_c('router-link', {
    staticClass: "cockroach_1",
    attrs: {
      "to": "/product/cockroach"
    }
  }, [_c('span')]), _vm._v(" "), _c('a', {
    staticClass: "cockroach_2",
    on: {
      "click": function($event) {
        _vm.jumpToCockroach(1)
      }
    }
  }, [_c('span')]), _vm._v(" "), _c('a', {
    staticClass: "cockroach_gel",
    on: {
      "click": function($event) {
        _vm.jumpToCockroach(2)
      }
    }
  }, [_c('span')]), _vm._v(" "), _c('router-link', {
    staticClass: "ant_1",
    attrs: {
      "to": "/product/ant"
    }
  }, [_c('span')])], 1), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(161)
    }
  })])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "visual_switch"
  }, [_c('div', {
    staticClass: "switch",
    class: {
      active: _vm.visual == 0
    },
    on: {
      "click": function($event) {
        _vm.changeImage(0)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "switch",
    class: {
      active: _vm.visual == 1
    },
    on: {
      "click": function($event) {
        _vm.changeImage(1)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pageControl"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.scrollToProduct(1)
      }
    }
  }, [_c('span', {
    staticClass: "item item-half item-icon white"
  }, [_c('svg', {
    staticClass: "icon icon-arrow icon-rotate-down",
    attrs: {
      "id": "bottomArrow",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 60 60",
      "xml:space": "preserve",
      "preserveAspectRatio": "xMidYMid meet"
    }
  }, [_c('path', {
    staticClass: "icon-path",
    attrs: {
      "d": "M14.2,52.5c-1.8,1.8-1.8,4.7,0,6.5c1.8,1.8,4.6,1.8,6.4,0l25.3-25.8c1.8-1.8,1.8-4.7,0-6.5L20.6,1c-1.8-1.8-4.6-1.8-6.4,0c-1.8,1.8-1.8,4.7,0,6.5L34.9,30L14.2,52.5z"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  })]), _vm._v(" "), _c('div', {
    staticClass: "page-2 page"
  }, [_c('div', {
    staticClass: "pageControl"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.scrollToProduct(0)
      }
    }
  }, [_c('span', {
    staticClass: "item item-half item-icon white"
  }, [_c('svg', {
    staticClass: "icon icon-arrow icon-rotate-up",
    attrs: {
      "id": "bottomArrow",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 60 60",
      "xml:space": "preserve",
      "preserveAspectRatio": "xMidYMid meet"
    }
  }, [_c('path', {
    staticClass: "icon-path",
    attrs: {
      "d": "M14.2,52.5c-1.8,1.8-1.8,4.7,0,6.5c1.8,1.8,4.6,1.8,6.4,0l25.3-25.8c1.8-1.8,1.8-4.7,0-6.5L20.6,1c-1.8-1.8-4.6-1.8-6.4,0c-1.8,1.8-1.8,4.7,0,6.5L34.9,30L14.2,52.5z"
    }
  })])])])]), _vm._v(" "), _c('contact'), _vm._v(" "), _c('henkel-footer')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "mobile hidden-md-up"
  }, [_c('div', {
    staticClass: "bg_container",
    class: ['active' + _vm.visual]
  }, [_vm._m(3), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "cartoon_container"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "cartoon_main"
  }, [_c('div', {
    staticClass: "artwork_wrapper"
  }, [_c('div', {
    staticClass: "link_wrapper"
  }, [_c('a', {
    staticClass: "cockroach_2",
    on: {
      "click": function($event) {
        _vm.jumpToCockroach(1)
      }
    }
  }, [_c('span')]), _vm._v(" "), _c('router-link', {
    staticClass: "ant_1",
    attrs: {
      "to": "/product/ant"
    }
  }, [_c('span')]), _vm._v(" "), _c('router-link', {
    staticClass: "cockroach_1",
    attrs: {
      "to": "/product/cockroach"
    }
  }, [_c('span')])], 1), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(160)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cartoon"
  }, [_c('div', {
    staticClass: "artwork_wrapper"
  }, [_c('div', {
    staticClass: "link_wrapper"
  }, [_c('a', {
    staticClass: "cockroach_gel",
    on: {
      "click": function($event) {
        _vm.jumpToCockroach(2)
      }
    }
  }, [_c('span')])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(159)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cartoon__claimRef"
  }, [_vm._v("\n            *資料來源：Euromonitor Retail Value Comparison of Insecticide Baits Category in Hong Kong, Data 2014-2017, 2019-2021\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "visual_switch"
  }, [_c('div', {
    staticClass: "switch",
    class: {
      active: _vm.visual == 0
    },
    on: {
      "click": function($event) {
        _vm.changeImage(0)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "switch",
    class: {
      active: _vm.visual == 1
    },
    on: {
      "click": function($event) {
        _vm.changeImage(1)
      }
    }
  })])]), _vm._v(" "), _c('div', [_c('contact')], 1), _vm._v(" "), _c('henkel-footer')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(154)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg"
  }, [_c('img', {
    staticClass: "tagline",
    attrs: {
      "src": __webpack_require__(157)
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(155)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "claim"
  }, [_c('div', {
    staticClass: "claimFef"
  }, [_vm._v("\n              *資料來源：Euromonitor Retail Value Comparison of Insecticide Baits Category in Hong Kong, Data 2014-2017, 2019-2021\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile_bg"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(158)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile_bg"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(156)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slogan"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(162)
    }
  })])
}]}

/***/ }),
/* 232 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "privacy"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('henkel-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section1"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('p', [_vm._v("\n            Privacy Statement\n          ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('p', {
    staticClass: "underline"
  }, [_vm._v("1. General")]), _vm._v(" "), _c('p', [_vm._v("DKSH Hong Kong Limited, respects the privacy of each person who visits our website. Now we would like to inform you of the type of data collected by DKSH Hong Kong Limited and how they are used. You will also learn how you can check the accuracy of this information and arrange for the deletion of these data by DKSH Hong Kong Limited. Data are collected, processed and used in conformity with the data protection regulations of the country in which the responsible data processing department is located. We take any action required to ensure compliance.")]), _vm._v(" "), _c('p', [_vm._v("This Privacy Statement does not apply to websites accessible from hyperlinks on DKSH Hong Kong Limited websites.")]), _vm._v(" "), _c('p', {
    staticClass: "underline"
  }, [_vm._v("2. Collection, use and processing of personal data")]), _vm._v(" "), _c('p', [_vm._v("We collect data relating to a specific person for processing and usage purposes only, if you voluntarily decide to enter the data or expressly give your consent thereto. By doing so, you accept the following terms of use.")]), _vm._v(" "), _c('p', [_vm._v("When visiting our website, certain data are automatically stored on our servers for the purpose of system administration or for statistical or backup purposes. These data comprise the name of your Internet service provider, in some cases your IP address, the version of your browser software, the operating system of the computer used to access our website, the website you are using to visit us, the websites that you visit while you are with us and, if applicable, any search terms you have been using to find our website. Depending on the circumstances, such data may allow that conclusions be drawn about certain visitors to the website. However, no person-related data are used in this context. Such data are used solely after having been rendered anonymously. If DKSH Hong Kong Limited transfers data to an external service-provider, technical and organizational measures will be taken which guarantee that their transmission occurs in conformity with the statutory data protection regulations.")]), _vm._v(" "), _c('p', [_vm._v("If you voluntarily supply us with personal-related data, we shall not use, process or transfer these data beyond the limits permitted by statute or defined by yourself in your declaration of consent. Furthermore, we will transfer your data only, if we are obliged to do so by official or court orders.")]), _vm._v(" "), _c('p', [_vm._v("Any changes to this Privacy Statement will be published on this page. This enables you to inform yourself at any time about which data we are storing and how we collect and use such data.")]), _vm._v(" "), _c('p', {
    staticClass: "underline"
  }, [_vm._v("3. Security")]), _vm._v(" "), _c('p', [_vm._v("DKSH Hong Kong Limited will store your data safely and, therefore, take all precautionary measures to protect your data against loss, abuse or changes. Contractual partners of DKSH Hong Kong Limited who have access to your data in order to provide services to you on behalf of DKSH Hong Kong Limited are contractually obliged to keep such information in confidence and may not use these data for any other purpose. In some cases, it will be necessary that we transfer your inquiries to affiliated companies of DKSH Hong Kong Limited. Also in these cases your data will be treated confidential.")]), _vm._v(" "), _c('p', {
    staticClass: "underline"
  }, [_vm._v("4. Person-related Data of Children")]), _vm._v(" "), _c('p', [_vm._v("DKSH Hong Kong Limited does not wish to collect data on children below the age of 14 years. Where necessary, Henkel will expressly draw the children's attention in an appropriate place to the fact that they shall not send any person-related information to Henkel. Should parents or other legal guardians discover that the children under their supervision have made person-related data available to DKSH Hong Kong Limited, we request that they contact us at the address below (see 6. below), if these data shall be deleted. We shall then arrange for the deletion of these data without delay.")]), _vm._v(" "), _c('p', {
    staticClass: "underline"
  }, [_vm._v("5. Cookies")]), _vm._v(" "), _c('p', [_vm._v("To learn more about cookies used on this site, please kindly contact DKSH Hong Kong Limited for more details.")]), _vm._v(" "), _c('p', {
    staticClass: "underline"
  }, [_vm._v("6. Web Tracking")]), _vm._v(" "), _c('p', [_vm._v("(1) This website collects and stores data for marketing and optimization.")]), _vm._v(" "), _c('p', [_vm._v("This data can be used to create pseudonymized user profiles. We use cookies for that purpose. Cookies allow us to recognize your web browser.")]), _vm._v(" "), _c('p', [_vm._v("Information about the usage of the website which is generated by means of such cookies are transferred to and stored on a server operated by Google in the USA. The generated data is not used to identify you and the data is supplemented with person related data about you.")]), _vm._v(" "), _c('p', [_vm._v("Your IP-address will be truncated by Google within member states of the European Union and other states of the European Economic Area before being transferred in the US. Only in some exceptional cases, will the full IP-address be transferred to Googles servers in the US where it will then be truncated.")]), _vm._v(" "), _c('p', [_vm._v("You may withdraw your consent to the collection and storage of data any time with future effect.")]), _vm._v(" "), _c('p', [_vm._v("This requires you install an according add-on from Google which can be downloaded here (link to: https://tools.google.com/dlpage/gaoptout).")]), _vm._v(" "), _c('p', [_vm._v("When the add-on is installed in your browser, it tells Google's JavaScript Code (ga.js) not to transmit any information about the visit of the web site to Google Analytics.")]), _vm._v(" "), _c('p', [_vm._v("Alternatively to installing a browser add-on or for mobile devices, you may use "), _c('a', {
    attrs: {
      "id": "GAOptOut",
      "title": "Set Google Analytics opt-out cookie",
      "href": "http://optout"
    }
  }, [_vm._v(" this link")]), _vm._v(", to disable future recording of data on this website (this opt-out only applies to the current browser and only for this domain). This method stores an opt-out cookie on your device. If you delete cookies in your browser you'll have to use the link anew.")]), _vm._v(" "), _c('p', [_vm._v("Please refer to Google's "), _c('a', {
    attrs: {
      "href": "http://www.google.com/intl/en/policies/)."
    }
  }, [_vm._v("data privacy policy")]), _vm._v(" for further information about web tracking.")]), _vm._v(" "), _c('p', [_vm._v("(2) DoubleClick is a service we use that is provided by Google Inc., 1600 Amphitheatre Parkway, Mountain View, CA 94043, to display relevant ads to you. For this purpose, cookies are used that do not contain any personal information. Your IP address will be used when generating these cookies. The DoubleClick cookies utilize a pseudonymous identification number assigned to your browser to collect on-screen and other ads. This allows Google and its partner sites to display ads based on previous visits to Henkel webpages or other websites. Google transmits and saves the information gathered from the DoubleClick cookies to a server it manages that may be in an overseas country.")]), _vm._v(" "), _c('p', [_vm._v("The data collected by the DoubleClick cookies is only transferred to third parties in accordance with the law and Henkel's data processing agreement with Google. By accessing any Henkel website you agree to the use of the above-mentioned DoubleClick cookie data for processing by Google.")]), _vm._v(" "), _c('p', [_vm._v("You can prevent cookies from being stored in your browser settings. If you are uncomfortable with the use of DoubleClick cookies, you can follow this link (www.google.com/settings/ads/onweb) to download and install a browser-plugin to deactivate the DoubleClick service by Google.")]), _vm._v(" "), _c('p', {
    staticClass: "underline"
  }, [_vm._v("7. Your Wishes and Queries / Data Protection Officer")]), _vm._v(" "), _c('p', [_vm._v("Stored data will be deleted by DKSH Hong Kong Limited upon expiration of the statutory or contractual filing period or if DKSH Hong Kong Limited no longer requires the same. At any time, you may, of course, ask for the deletion of your data. You are also entitled at any time to revoke your consent to the use or processing of your person-related data with future effect. In these cases, or if you have any other wishes in connection with your person-related data, please contact DKSH Hong Kong Limited. Please also contact us this way, if you would like to know whether we have collected data about you and, if so, which data. We shall endeavor to comply with your wish immediately.")]), _vm._v(" "), _c('p', {
    staticClass: "underline"
  }, [_vm._v("8. Personal Data Privacy Contact Method")]), _vm._v(" "), _c('p', [_vm._v("Should you have any queries regarding this Privacy Statement or our policies and practices, or require access to or correction of your personal data, or for any other communications hereinabove described, you may contact us via the following means:")]), _vm._v(" "), _c('p', [_vm._v("By mail: (Attn: Personal Data Privacy)"), _c('br'), _vm._v("\n         DKSH Hong Kong Limited"), _c('br'), _vm._v("\n         23rd Floor, Tower A, Southmark, 11 Yip Hing Street, Wong Chuk Hang, Hong Kong"), _c('br'), _vm._v("\n         By telephone: +852 2895 0888")])])])
}]}

/***/ }),
/* 233 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "generalPage"
  }, [_c('isotopegrid', {
    attrs: {
      "isotopeProps": _vm.isotopeProps
    }
  }), _vm._v(" "), _c('contact'), _vm._v(" "), _c('henkel-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "generalPage"
  }, [_c('div', {
    staticClass: "isotopeGrid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "section2"
  }, [_c('div', {
    staticClass: "generalWrapper"
  }, [_c('div', {
    staticClass: "tab tabChannel"
  }, [_c('div', {
    staticClass: "tabTitle"
  }, [_vm._v("\n            威滅產品於下列商戶有售\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_grid 2init_4"
  }, [_c('div', {
    staticClass: "shoplist_table_rowgroup header"
  }, [_c('div', {
    staticClass: "shoplist_table_row"
  }, [_c('div', {
    staticClass: "shoplist_table_rowheader"
  }), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_1"
  }, [_c('a', {
    staticClass: "product_img",
    on: {
      "click": function($event) {
        _vm.jumpToCockroach(1)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(69)
    }
  })]), _vm._v(" "), _c('p', [_vm._v("速效曱甴藥餌")])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_2"
  }, [_c('router-link', {
    staticClass: "product_img",
    attrs: {
      "to": "/product/ant"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(185)
    }
  })]), _vm._v(" "), _c('p', [_vm._v("速效殺蟻藥餌")])], 1), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_3"
  }, [_c('router-link', {
    staticClass: "product_img",
    attrs: {
      "to": "/product/cockroach"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(67)
    }
  })]), _vm._v(" "), _c('p', [_vm._v("速效曱甴藥餌"), _c('nobr', [_vm._v("(典雅版)")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_4"
  }, [_c('a', {
    staticClass: "product_img",
    on: {
      "click": function($event) {
        _vm.jumpToCockroach(2)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(13)
    }
  })]), _vm._v(" "), _c('p', [_vm._v("專業強效曱甴"), _c('nobr', [_vm._v("凝膠餌劑")])], 1)])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15)])])])])]), _vm._v(" "), _c('contact'), _vm._v(" "), _c('henkel-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section1"
  }, [_c('div', {
    staticClass: "title_wrapper"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n          銷售地點\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "subTitle"
  }, [_vm._v("\n          威滅產品銷售地點\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist_table_rowgroup data shop_welcome"
  }, [_c('div', {
    staticClass: "shoplist_table_row"
  }, [_c('div', {
    staticClass: "shoplist_table_rowheader"
  }, [_c('div', {
    staticClass: "shoplist"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("惠康超級市場")]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo"
  }, [_c('a', {
    attrs: {
      "href": "https://www.wellcome.com.hk/zh-hant/our-store",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(37)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_1"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_2"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_3"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_4"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist_table_rowgroup data shop_parknshop"
  }, [_c('div', {
    staticClass: "shoplist_table_row"
  }, [_c('div', {
    staticClass: "shoplist_table_rowheader"
  }, [_c('div', {
    staticClass: "shoplist"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("百佳超級市場")]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(34)
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.pns.hk/zh-hk/all-brands/b/103679/%E5%A8%81%E6%BB%85",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": __webpack_require__(1)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_1"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_2"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_3"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_4"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist_table_rowgroup data shop_vanguard"
  }, [_c('div', {
    staticClass: "shoplist_table_row"
  }, [_c('div', {
    staticClass: "shoplist_table_rowheader"
  }, [_c('div', {
    staticClass: "shoplist"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("華潤萬家*")]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(74)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_1"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_2"
  }), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_3"
  }), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_4"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist_table_rowgroup data shop_uselect"
  }, [_c('div', {
    staticClass: "shoplist_table_row"
  }, [_c('div', {
    staticClass: "shoplist_table_rowheader"
  }, [_c('div', {
    staticClass: "shoplist"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("U-Select*")]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(73)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_1"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_2"
  }), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_3"
  }), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_4"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist_table_rowgroup data shop_aeon"
  }, [_c('div', {
    staticClass: "shoplist_table_row"
  }, [_c('div', {
    staticClass: "shoplist_table_rowheader"
  }, [_c('div', {
    staticClass: "shoplist"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("AEON")]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(15)
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.aeoncity.com.hk/kh_zh/non-food/householdgoods/003052610.html",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": __webpack_require__(1)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_1"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_2"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_3"
  }), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_4"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist_table_rowgroup data shop_yata"
  }, [_c('div', {
    staticClass: "shoplist_table_row"
  }, [_c('div', {
    staticClass: "shoplist_table_rowheader"
  }, [_c('div', {
    staticClass: "shoplist"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("一田 YATA")]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(38)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_1"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_2"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_3"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_4"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist_table_rowgroup data shop_unyapita"
  }, [_c('div', {
    staticClass: "shoplist_table_row"
  }, [_c('div', {
    staticClass: "shoplist_table_rowheader"
  }, [_c('div', {
    staticClass: "shoplist"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("UNY / APITA")]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(17)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_1"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_2"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_3"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_4"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist_table_rowgroup data shop_bamboos"
  }, [_c('div', {
    staticClass: "shoplist_table_row"
  }, [_c('div', {
    staticClass: "shoplist_table_rowheader"
  }, [_c('div', {
    staticClass: "shoplist"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("百本旺角市集")]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(18)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_1"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_2"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_3"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_4"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist_table_rowgroup data shop_hktvmall"
  }, [_c('div', {
    staticClass: "shoplist_table_row"
  }, [_c('div', {
    staticClass: "shoplist_table_rowheader"
  }, [_c('div', {
    staticClass: "shoplist"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("HKTV mall")]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(22)
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.hktvmall.com/hktv/zh/main/search?page=0&q=%3Arelevance%3Acategory%3AAA11824000001%3Azone%3Asupermarket%3Abrand%3ACombat%3Astreet%3Amain%3A",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": __webpack_require__(1)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_1"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_2"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_3"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_4"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist_table_rowgroup data shop_ztore"
  }, [_c('div', {
    staticClass: "shoplist_table_row"
  }, [_c('div', {
    staticClass: "shoplist_table_rowheader"
  }, [_c('div', {
    staticClass: "shoplist"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("Ztore 士多")]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(39)
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.ztore.com/tc/search/combat",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": __webpack_require__(1)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_1"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_2"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_3"
  }), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_4"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist_table_rowgroup data shop_pandamart"
  }, [_c('div', {
    staticClass: "shoplist_table_row"
  }, [_c('div', {
    staticClass: "shoplist_table_rowheader"
  }, [_c('div', {
    staticClass: "shoplist"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("PandaMart")]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(33)
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.foodpanda.hk/groceries#all-pandamarts",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": __webpack_require__(1)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_1"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_2"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_3"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_4"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist_table_rowgroup data shop_homeplus"
  }, [_c('div', {
    staticClass: "shoplist_table_row"
  }, [_c('div', {
    staticClass: "shoplist_table_rowheader"
  }, [_c('div', {
    staticClass: "shoplist"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("HOMEPLUS")]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(23)
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.home-plus.hk/tc_hk/products?brand=17504",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": __webpack_require__(1)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_1"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_2"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_3"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_4"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist_table_rowgroup data shop_healthstore"
  }, [_c('div', {
    staticClass: "shoplist_table_row"
  }, [_c('div', {
    staticClass: "shoplist_table_rowheader"
  }, [_c('div', {
    staticClass: "shoplist"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("HealthStore")]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(21)
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.healthstore.com.hk/collections/combat-威滅?utm_source=combat&utm_medium=referral&utm_campaign=brandsite",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": __webpack_require__(1)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_1"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_2"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_3"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_4"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist_table_rowgroup data shop_pharmacy"
  }, [_c('div', {
    staticClass: "shoplist_table_row"
  }, [_c('div', {
    staticClass: "shoplist_table_rowheader"
  }, [_c('div', {
    staticClass: "shoplist"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("各大藥行藥房")]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(16)
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://docs.google.com/spreadsheets/d/1038226dN2l4fc_kwaJjAP6E5yiUBQNLo/edit?usp=sharing&ouid=109814576360705695639&rtpof=true&sd=true",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": __webpack_require__(19)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_1"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_2"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_3"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_4"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": __webpack_require__(0)
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist_table_notice"
  }, [_c('p', [_vm._v("*部分產品只限指定門市有售貨")])])
}]}

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aboutPage"
  }, [_c('div', {
    staticClass: "fullpage-container hidden-sm-down"
  }, [_c('div', {
    staticClass: "visual_switch"
  }, [_c('div', {
    staticClass: "switch",
    class: {
      active: _vm.curProduct === 0
    },
    on: {
      "click": function($event) {
        _vm.scrollToProduct(0)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "switch",
    class: {
      active: _vm.curProduct === 1
    },
    on: {
      "click": function($event) {
        _vm.scrollToProduct(1)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fullpage-container__bgImg"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "fullpage",
      rawName: "v-fullpage",
      value: (_vm.opts),
      expression: "opts"
    }],
    ref: "fullpage",
    staticClass: "fullpage-wp"
  }, [_c('div', {
    staticClass: "page-1 page"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "fullpage-container__subTitle"
  }, [_vm._v("\n          多年歷史，配方專業獨特，真正殺蟲的專家。\n        ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "pageControl"
  }, [_c('button', {
    attrs: {
      "data-button": "next"
    },
    on: {
      "click": _vm.moveNextPage
    }
  }, [_c('span', {
    staticClass: "item item-half item-icon white"
  }, [_c('svg', {
    staticClass: "icon icon-arrow icon-rotate-down",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 60 60",
      "xml:space": "preserve",
      "preserveAspectRatio": "xMidYMid meet"
    }
  }, [_c('path', {
    staticClass: "icon-path",
    attrs: {
      "d": "M14.2,52.5c-1.8,1.8-1.8,4.7,0,6.5c1.8,1.8,4.6,1.8,6.4,0l25.3-25.8c1.8-1.8,1.8-4.7,0-6.5L20.6,1c-1.8-1.8-4.6-1.8-6.4,0c-1.8,1.8-1.8,4.7,0,6.5L34.9,30L14.2,52.5z"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-2 page"
  }, [_c('contact'), _vm._v(" "), _c('div', {
    staticClass: "pageControl",
    attrs: {
      "id": "bottomArrow"
    }
  }, [_c('button', {
    attrs: {
      "data-button": "next"
    },
    on: {
      "click": _vm.movePrevPage
    }
  }, [_c('span', {
    staticClass: "item item-half item-icon white"
  }, [_c('svg', {
    staticClass: "icon icon-arrow icon-rotate-up",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 60 60",
      "xml:space": "preserve",
      "preserveAspectRatio": "xMidYMid meet"
    }
  }, [_c('path', {
    staticClass: "icon-path",
    attrs: {
      "d": "M14.2,52.5c-1.8,1.8-1.8,4.7,0,6.5c1.8,1.8,4.6,1.8,6.4,0l25.3-25.8c1.8-1.8,1.8-4.7,0-6.5L20.6,1c-1.8-1.8-4.6-1.8-6.4,0c-1.8,1.8-1.8,4.7,0,6.5L34.9,30L14.2,52.5z"
    }
  })])])])]), _vm._v(" "), _c('henkel-footer')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "hidden-md-up"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('contact'), _vm._v(" "), _c('henkel-footer')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fullpage-container__title"
  }, [_vm._v("\n          關於「威滅"), _c('sup', {
    staticClass: "fullpage-container__title__tm"
  }, [_vm._v("®")]), _vm._v("」\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fullpage-container__bottomPanel"
  }, [_c('p', {
    staticClass: "fullpage-container__bottomPanel__text1"
  }, [_vm._v("\n            威滅"), _c('sup', [_vm._v("®")]), _vm._v("為德國Henkel家用品牌旗下的一個核心殺蟲劑品牌，備有25年的歷史，專門針對和利用害蟲的生態習性，為消費者的家居提供高效用的產品，以改善及優化生活，為用家提供健康舒適的居住環境。\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "fullpage-container__bottomPanel__text2"
  }, [_vm._v("\n            產品當中的「速效曱甴藥餌」及「速效殺蟻藥餌」，其連環殺滅功效顯著，能有效將巢穴裡的曱甴及螞蟻一網打盡! 所以威滅"), _c('sup', [_vm._v("®")]), _vm._v("一直以來深受消費者信賴和喜愛，更多年來穩佔全港藥餌銷量No.1的殊榮。 \n          ")]), _vm._v(" "), _c('img', {
    staticClass: "fullpage-container__bottomPanel__productImage",
    attrs: {
      "src": __webpack_require__(146)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "claimRef"
  }, [_c('div', [_vm._v("\n              *資料來源：Euromonitor Retail Value Comparison of Insecticide Baits Category in Hong Kong, Data 2014-2017, 2019-2021\n            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section1"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(144)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section2"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n        關於「威滅"), _c('sup', {
    staticClass: "title__tm"
  }, [_vm._v("®")]), _vm._v("」\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "subTitle"
  }, [_vm._v("\n        多年歷史，配方專業獨特，真正殺蟲的專家。\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "text1"
  }, [_vm._v("\n          威滅"), _c('sup', [_vm._v("®")]), _vm._v("為德國Henkel家用品牌旗下的一個核心殺蟲劑品牌，備有25年的歷史，專門針對和利用害蟲的生態習性，為消費者的家居提供高效用的產品，以改善及優化生活，為用家提供健康舒適的居住環境。\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("\n          產品當中的「速效曱甴藥餌」及「速效殺蟻藥餌」，其連環殺滅功效顯著，能有效將巢穴裡的曱甴及螞蟻一網打盡! 所以威滅"), _c('sup', [_vm._v("®")]), _vm._v("一直以來深受消費者信賴和喜愛，更多年來穩佔全港藥餌銷量No.1的殊榮。 \n        ")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(145)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "claimRef"
  }, [_c('div', [_vm._v("\n          *資料來源：Euromonitor Retail Value Comparison of Insecticide Baits Category in Hong Kong, Data 2014-2017, 2019-2021\n        ")])])])
}]}

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "productCockroach"
  }, [_c('div', {
    staticClass: "visual_switch"
  }, [_c('div', {
    staticClass: "switch",
    class: {
      active: _vm.curProduct == 0
    },
    on: {
      "click": function($event) {
        _vm.scrollToProduct(0)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "switch",
    class: {
      active: _vm.curProduct == 1
    },
    on: {
      "click": function($event) {
        _vm.scrollToProduct(1)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "switch",
    class: {
      active: _vm.curProduct == 2
    },
    on: {
      "click": function($event) {
        _vm.scrollToProduct(2)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "switch",
    class: {
      active: _vm.curProduct == 3
    },
    on: {
      "click": function($event) {
        _vm.scrollToProduct(3)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "switch",
    class: {
      active: _vm.curProduct == 4
    },
    on: {
      "click": function($event) {
        _vm.scrollToProduct(4)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fullpage-container hidden-sm-down"
  }, [_c('div', {
    staticClass: "fullpage-container__bgImg"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "fullpage",
      rawName: "v-fullpage",
      value: (_vm.opts),
      expression: "opts"
    }],
    ref: "fullpage",
    staticClass: "fullpage-wp"
  }, [_c('div', {
    staticClass: "page-1 page"
  }, [_c('div', {
    staticClass: "fullpage-container__title"
  }, [_vm._v("\n          威滅 速效曱甴藥餌 (典雅版)\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "fullpage-container__bottomPanel"
  }, [_c('p', {
    staticClass: "fullpage-container__bottomPanel__text1"
  }, [_vm._v("\n            全新天然木紋包裝專為時尚家居而設，連環殺滅功能，將巢穴內的曱甴一網打盡！\n          ")]), _vm._v(" "), _c('img', {
    staticClass: "fullpage-container__bottomPanel__productImage",
    attrs: {
      "src": __webpack_require__(68)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fullpage-container__bottomPanel__sellingLocation",
    on: {
      "click": function($event) {
        _vm.toggleOverlay(0, 0)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.locationIcon,
      "srcset": _vm.locationIcon2x + ' 2x'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("銷售地點")])]), _vm._v(" "), _c('div', {
    staticClass: "btnContainer"
  }, [_c('ul', _vm._l((_vm.overlayMenu), function(item, index) {
    return (index != 0) ? _c('li', {
      on: {
        "click": function($event) {
          _vm.toggleOverlay(index, 0)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "srcset": item.srcset + ' 2x'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))])]) : _vm._e()
  }))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pageControl"
  }, [_c('button', {
    attrs: {
      "data-button": "next"
    },
    on: {
      "click": _vm.moveNextPage
    }
  }, [_c('span', {
    staticClass: "item item-half item-icon white"
  }, [_c('svg', {
    staticClass: "icon icon-arrow icon-rotate-down",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 60 60",
      "xml:space": "preserve",
      "preserveAspectRatio": "xMidYMid meet"
    }
  }, [_c('path', {
    staticClass: "icon-path",
    attrs: {
      "d": "M14.2,52.5c-1.8,1.8-1.8,4.7,0,6.5c1.8,1.8,4.6,1.8,6.4,0l25.3-25.8c1.8-1.8,1.8-4.7,0-6.5L20.6,1c-1.8-1.8-4.6-1.8-6.4,0c-1.8,1.8-1.8,4.7,0,6.5L34.9,30L14.2,52.5z"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-2 page"
  }, [_c('div', {
    staticClass: "fullpage-container__title"
  }, [_vm._v("\n          威滅 速效曱甴藥餌\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "fullpage-container__bottomPanel"
  }, [_c('p', {
    staticClass: "fullpage-container__bottomPanel__text1"
  }, [_vm._v("\n            配方專為曱甴而設，連環殺滅功能，有效針對家居曱甴問題！\n          ")]), _vm._v(" "), _c('img', {
    staticClass: "fullpage-container__bottomPanel__productImage",
    attrs: {
      "src": __webpack_require__(70)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fullpage-container__bottomPanel__sellingLocation",
    on: {
      "click": function($event) {
        _vm.toggleOverlay(0, 1)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.locationIcon,
      "srcset": _vm.locationIcon2x + ' 2x'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("銷售地點")])]), _vm._v(" "), _c('div', {
    staticClass: "btnContainer"
  }, [_c('ul', _vm._l((_vm.overlayMenu), function(item, index) {
    return (index != 0) ? _c('li', {
      on: {
        "click": function($event) {
          _vm.toggleOverlay(index, 1)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "srcset": item.srcset + ' 2x'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))])]) : _vm._e()
  }))]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "pageControl"
  }, [_c('button', {
    attrs: {
      "data-button": "next"
    },
    on: {
      "click": _vm.moveNextPage
    }
  }, [_c('span', {
    staticClass: "item item-half item-icon white"
  }, [_c('svg', {
    staticClass: "icon icon-arrow icon-rotate-down",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 60 60",
      "xml:space": "preserve",
      "preserveAspectRatio": "xMidYMid meet"
    }
  }, [_c('path', {
    staticClass: "icon-path",
    attrs: {
      "d": "M14.2,52.5c-1.8,1.8-1.8,4.7,0,6.5c1.8,1.8,4.6,1.8,6.4,0l25.3-25.8c1.8-1.8,1.8-4.7,0-6.5L20.6,1c-1.8-1.8-4.6-1.8-6.4,0c-1.8,1.8-1.8,4.7,0,6.5L34.9,30L14.2,52.5z"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-gel page"
  }, [_c('div', {
    staticClass: "fullpage-container__title"
  }, [_vm._v("\n          威滅 專業強效曱甴凝膠餌劑\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "fullpage-container__bottomPanel"
  }, [_vm._m(2), _vm._v(" "), _c('img', {
    staticClass: "fullpage-container__bottomPanel__productImage",
    attrs: {
      "src": __webpack_require__(13)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fullpage-container__bottomPanel__sellingLocation",
    on: {
      "click": function($event) {
        _vm.toggleOverlay(0, 2)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.locationIcon,
      "srcset": _vm.locationIcon2x + ' 2x'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("銷售地點")])]), _vm._v(" "), _c('div', {
    staticClass: "btnContainer"
  }, [_c('ul', _vm._l((_vm.overlayMenu), function(item, index) {
    return (index != 0) ? _c('li', {
      on: {
        "click": function($event) {
          _vm.toggleOverlay(index, 2)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "srcset": item.srcset + ' 2x'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))])]) : _vm._e()
  }))]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "pageControl"
  }, [_c('button', {
    attrs: {
      "data-button": "next"
    },
    on: {
      "click": _vm.moveNextPage
    }
  }, [_c('span', {
    staticClass: "item item-half item-icon white"
  }, [_c('svg', {
    staticClass: "icon icon-arrow icon-rotate-down",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 60 60",
      "xml:space": "preserve",
      "preserveAspectRatio": "xMidYMid meet"
    }
  }, [_c('path', {
    staticClass: "icon-path",
    attrs: {
      "d": "M14.2,52.5c-1.8,1.8-1.8,4.7,0,6.5c1.8,1.8,4.6,1.8,6.4,0l25.3-25.8c1.8-1.8,1.8-4.7,0-6.5L20.6,1c-1.8-1.8-4.6-1.8-6.4,0c-1.8,1.8-1.8,4.7,0,6.5L34.9,30L14.2,52.5z"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-3 page"
  }, [_c('div', {
    staticClass: "suggestion-container"
  }, [_c('div', {
    staticClass: "suggestion"
  }, [_c('h2', [_vm._v("威滅其他產品")]), _vm._v(" "), _c('div', {
    staticClass: "product-btn"
  }, [_vm._m(4), _vm._v(" "), _c('router-link', {
    staticClass: "label-yellow",
    attrs: {
      "to": "/product/ant"
    }
  }, [_c('div', {
    staticClass: "aim"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(4)
    }
  })]), _vm._v(" "), _c('span', [_vm._v("速效殺蟻藥餌")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "pageControl"
  }, [_c('button', {
    attrs: {
      "data-button": "next"
    },
    on: {
      "click": _vm.moveNextPage
    }
  }, [_c('span', {
    staticClass: "item item-half item-icon white"
  }, [_c('svg', {
    staticClass: "icon icon-arrow icon-rotate-down",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 60 60",
      "xml:space": "preserve",
      "preserveAspectRatio": "xMidYMid meet"
    }
  }, [_c('path', {
    staticClass: "icon-path",
    attrs: {
      "d": "M14.2,52.5c-1.8,1.8-1.8,4.7,0,6.5c1.8,1.8,4.6,1.8,6.4,0l25.3-25.8c1.8-1.8,1.8-4.7,0-6.5L20.6,1c-1.8-1.8-4.6-1.8-6.4,0c-1.8,1.8-1.8,4.7,0,6.5L34.9,30L14.2,52.5z"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-4 page"
  }, [_c('contact'), _vm._v(" "), _c('div', {
    staticClass: "pageControl"
  }, [_c('button', {
    attrs: {
      "data-button": "next"
    },
    on: {
      "click": function($event) {
        _vm.scrollToProduct(0)
      }
    }
  }, [_c('span', {
    staticClass: "item item-half item-icon white"
  }, [_c('svg', {
    staticClass: "icon icon-arrow icon-rotate-up",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 60 60",
      "xml:space": "preserve",
      "preserveAspectRatio": "xMidYMid meet"
    }
  }, [_c('path', {
    staticClass: "icon-path",
    attrs: {
      "d": "M14.2,52.5c-1.8,1.8-1.8,4.7,0,6.5c1.8,1.8,4.6,1.8,6.4,0l25.3-25.8c1.8-1.8,1.8-4.7,0-6.5L20.6,1c-1.8-1.8-4.6-1.8-6.4,0c-1.8,1.8-1.8,4.7,0,6.5L34.9,30L14.2,52.5z"
    }
  })])])])]), _vm._v(" "), _c('henkel-footer')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "hidden-md-up"
  }, [_c('div', {
    ref: "cockroach_1",
    staticClass: "section1"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(14)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "section2"
  }, [_vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "sellingLocation",
    on: {
      "click": function($event) {
        _vm.toggleOverlay(0, 0)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.locationIcon,
      "srcset": _vm.locationIcon2x + ' 2x'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("銷售地點")])]), _vm._v(" "), _c('div', {
    staticClass: "btnContainer"
  }, [_c('ul', _vm._l((_vm.overlayMenu), function(item, index) {
    return (index != 0) ? _c('li', {
      on: {
        "click": function($event) {
          _vm.toggleOverlay(index, 0)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "srcset": item.srcset + ' 2x'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))])]) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    staticClass: "claimRef"
  }, [_vm._v("\n        *資料來源：Euromonitor Retail Value Comparison of Insecticide Baits Category in Hong Kong, Data 2014-2017, 2019-2021\n      ")])]), _vm._v(" "), _c('div', {
    ref: "cockroach_2",
    staticClass: "section1"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(14)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "section2 section3"
  }, [_vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "sellingLocation",
    on: {
      "click": function($event) {
        _vm.toggleOverlay(0, 1)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.locationIcon,
      "srcset": _vm.locationIcon2x + ' 2x'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("銷售地點")])]), _vm._v(" "), _c('div', {
    staticClass: "btnContainer"
  }, [_c('ul', _vm._l((_vm.overlayMenu), function(item, index) {
    return (index != 0) ? _c('li', {
      on: {
        "click": function($event) {
          _vm.toggleOverlay(index, 1)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "srcset": item.srcset + ' 2x'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))])]) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    staticClass: "claimRef"
  }, [_vm._v("\n        *資料來源：Euromonitor Retail Value Comparison of Insecticide Baits Category in Hong Kong, Data 2014-2017, 2019-2021\n      ")])]), _vm._v(" "), _c('div', {
    ref: "cockroach_gel",
    staticClass: "section1"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(14)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "section2 sectionGel"
  }, [_vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "sellingLocation",
    on: {
      "click": function($event) {
        _vm.toggleOverlay(0, 2)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.locationIcon,
      "srcset": _vm.locationIcon2x + ' 2x'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("銷售地點")])]), _vm._v(" "), _c('div', {
    staticClass: "btnContainer"
  }, [_c('ul', _vm._l((_vm.overlayMenu), function(item, index) {
    return (index != 0) ? _c('li', {
      on: {
        "click": function($event) {
          _vm.toggleOverlay(index, 2)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "srcset": item.srcset + ' 2x'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))])]) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    staticClass: "claimRef"
  }, [_vm._v("\n        *資料來源：Euromonitor Retail Value Comparison of Insecticide Baits Category in Hong Kong, Data 2014-2017, 2019-2021\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "section-suggest"
  }, [_c('div', {
    staticClass: "suggestion-container"
  }, [_c('div', {
    staticClass: "suggestion"
  }, [_c('h2', [_vm._v("威滅其他產品")]), _vm._v(" "), _c('div', {
    staticClass: "product-btn"
  }, [_vm._m(11), _vm._v(" "), _c('router-link', {
    staticClass: "label-yellow",
    attrs: {
      "to": "/product/ant"
    }
  }, [_c('div', {
    staticClass: "aim"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(4)
    }
  })]), _vm._v(" "), _c('span', [_vm._v("速效殺蟻藥餌")])])], 1)])])]), _vm._v(" "), _c('contact'), _vm._v(" "), _c('henkel-footer')], 1), _vm._v(" "), _c('div', {
    staticClass: "overlay",
    class: {
      active: _vm.openOverlay
    }
  }, [_c('div', {
    staticClass: "overlayBg",
    on: {
      "click": function($event) {
        _vm.toggleOverlay()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "outer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "closeBtn"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(49),
      "srcset": _vm.crossBtn + ' 2x'
    },
    on: {
      "click": function($event) {
        _vm.toggleOverlay()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tab tabChannel",
    class: {
      active: _vm.tabIndex === 0
    }
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "tabTitle"
  }, [_vm._v("\n            威滅產品於下列商戶有售\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "shoplistCol row"
  }, [_c('div', {
    staticClass: "col-md-4 offset-md-2"
  }, [(_vm.curProduct != 2) ? _c('div', {
    staticClass: "shoplist welcomeShopLink"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(37)
    }
  }), _vm._v(" "), _vm._m(13)]) : _vm._e(), _vm._v(" "), _vm._m(14)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    class: {
      'full': _vm.curProduct == 2
    }
  }, [(_vm.curProduct == 1) ? _c('div', {
    staticClass: "shoplist row"
  }, [_vm._m(15), _vm._v(" "), _vm._m(16)]) : _vm._e(), _vm._v(" "), (_vm.curProduct == 1) ? _c('div', {
    staticClass: "shoplist row"
  }, [_vm._m(17), _vm._v(" "), _vm._m(18)]) : _vm._e(), _vm._v(" "), (_vm.curProduct == 1) ? _c('div', {
    staticClass: "shoplist row"
  }, [_vm._m(19), _vm._v(" "), _vm._m(20)]) : _vm._e(), _vm._v(" "), _vm._m(21), _vm._v(" "), (_vm.curProduct != 2) ? _c('div', {
    staticClass: "shoplist row"
  }, [_vm._m(22), _vm._v(" "), _vm._m(23)]) : _vm._e(), _vm._v(" "), _vm._m(24), _vm._v(" "), _vm._m(25), _vm._v(" "), (_vm.curProduct !== 0) ? _c('div', {
    staticClass: "shoplist row"
  }, [_vm._m(26), _vm._v(" "), _vm._m(27)]) : _vm._e(), _vm._v(" "), (_vm.curProduct !== 2) ? _c('div', {
    staticClass: "shoplist row"
  }, [_vm._m(28), _vm._v(" "), _vm._m(29)]) : _vm._e(), _vm._v(" "), _vm._m(30), _vm._v(" "), _vm._m(31), _vm._v(" "), _vm._m(32), _vm._v(" "), (_vm.curProduct == 1) ? _c('p', [_vm._v("*部分產品只限指定門市有售貨")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "tab tabInfo",
    class: {
      active: _vm.tabIndex === 1
    }
  }, [_vm._m(33), _vm._v(" "), _c('div', {
    staticClass: "shoplistCol row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "shoplist text-md-right"
  }, [(_vm.curProduct == 0) ? _c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(67)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.curProduct == 1) ? _c('img', {
    staticClass: "shopLogo logo2",
    attrs: {
      "src": __webpack_require__(69)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.curProduct == 2) ? _c('img', {
    staticClass: "shopLogo logo2",
    attrs: {
      "src": __webpack_require__(13)
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "shoplist"
  }, [_c('div', {
    staticClass: "shopInfo"
  }, [(_vm.curProduct == 0) ? _c('span', [_vm._v("\n                    藥餌數目: 6件裝"), _c('br'), _vm._v("\n                    有效成份: Fipronil (快倍隆)"), _c('br'), _vm._v("\n                    生產地: 韓國"), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.curProduct == 1) ? _c('span', [_vm._v("\n                    藥餌數目: 9件裝"), _c('br'), _vm._v("\n                    有效成份: Fipronil (快倍隆)"), _c('br'), _vm._v("\n                    生產地: 韓國"), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.curProduct == 2) ? _c('span', [_vm._v("\n                    有效成份: Fipronil (快倍隆)"), _c('br'), _vm._v("\n                    生產地: 韓國"), _c('br'), _c('br')]) : _vm._e(), _vm._v("\n                  優點: "), _c('br'), _vm._v(" "), (_vm.curProduct == 0) ? _c('ul', {
    staticClass: "bulletList"
  }, [_c('li', [_vm._v("天然木紋設計,不影響外觀，適合放置於時尚家居。")]), _vm._v(" "), _c('li', [_vm._v("特別依據曱甴角度設計的餌盒, 令曱甴更容易進出餌盒進食藥餌。")]), _vm._v(" "), _c('li', [_vm._v("連環殺滅功能，將巢穴裡面曱甴一網打盡。")]), _vm._v(" "), _c('li', [_vm._v("成份無味無臭，對人體及環境不構成傷害。")]), _vm._v(" "), _c('li', [_vm._v("餌盒設計不容易令小孩或寵物直接觸及藥餌，安全有效。")]), _vm._v(" "), _c('li', [_vm._v("效力持續三個月有效。")])]) : _vm._e(), _vm._v(" "), (_vm.curProduct == 1) ? _c('ul', {
    staticClass: "bulletList"
  }, [_c('li', [_vm._v("無味無臭，對人體及環境不構成傷害。")]), _vm._v(" "), _c('li', [_vm._v("連環殺滅功能，將巢穴裡面曱甴一網打盡。")]), _vm._v(" "), _c('li', [_vm._v("不弄污環境，使用方便。")]), _vm._v(" "), _c('li', [_vm._v("效力持續三個月有效。")])]) : _vm._e(), _vm._v(" "), (_vm.curProduct == 2) ? _c('ul', {
    staticClass: "bulletList"
  }, [_c('li', [_vm._v("連環殺滅一點絕 殺曱甴")]), _vm._v(" "), _c('li', [_vm._v("5倍強效，連環殺滅")]), _vm._v(" "), _c('li', [_vm._v("可輕易深入隙縫及牆角，直達難以觸及的地方")]), _vm._v(" "), _c('li', [_vm._v("食物味藥餌可更有效殺滅曱甴")]), _vm._v(" "), _c('li', [_vm._v("容易吸引任何體積曱甴")]), _vm._v(" "), _c('li', [_vm._v("大大支，20克抵用裝")]), _vm._v(" "), _c('li', [_vm._v("3個月長效")]), _vm._v(" "), _c('li', [_vm._v("韓國製造")])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab tabMethod",
    class: {
      active: _vm.tabIndex === 2
    }
  }, [_vm._m(34), _vm._v(" "), (_vm.curProduct == 0) ? _c('div', {
    staticClass: "shoplistCol row"
  }, _vm._l((_vm.overlayMethod), function(step) {
    return _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "shoplist"
    }, [_c('div', {
      staticClass: "imageContainer"
    }, [_c('img', {
      staticClass: "shopLogo",
      attrs: {
        "src": step.src,
        "srcset": step.srcset + ' 2x'
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "methodNum"
    }, [_vm._v(_vm._s(step.index))]), _vm._v(" "), _c('div', {
      staticClass: "shopName",
      domProps: {
        "innerHTML": _vm._s(step.text)
      }
    }, [_vm._v(_vm._s(step.text))])])])
  })) : _vm._e(), _vm._v(" "), (_vm.curProduct == 1) ? _c('div', {
    staticClass: "shoplistCol row"
  }, _vm._l((_vm.overlayMethodTwo), function(step) {
    return _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "shoplist"
    }, [_c('div', {
      staticClass: "imageContainer"
    }, [_c('img', {
      staticClass: "shopLogo",
      attrs: {
        "src": step.src,
        "srcset": step.srcset + ' 2x'
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "methodNum"
    }, [_vm._v(_vm._s(step.index))]), _vm._v(" "), _c('div', {
      staticClass: "shopName",
      domProps: {
        "innerHTML": _vm._s(step.text)
      }
    }, [_vm._v(_vm._s(step.text))])])])
  })) : _vm._e(), _vm._v(" "), (_vm.curProduct == 2) ? _c('div', {
    staticClass: "shoplistCol row"
  }, [_vm._m(35)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tab tabWorks",
    class: {
      active: _vm.tabIndex === 3
    }
  }, [_vm._m(36), _vm._v(" "), _c('div', {
    staticClass: "shoplistCol row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-12 hidden-sm-down"
  }, [_c('div', {
    staticClass: "shoplist"
  }, [(_vm.curProduct == 0) ? _c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(195)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.curProduct == 1) ? _c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(200)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.curProduct == 2) ? _c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(205)
    }
  }) : _vm._e()])]), _vm._v(" "), _vm._l((_vm.overlayWorks), function(work, index) {
    return (_vm.curProduct == 0) ? _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "shoplist"
    }, [_c('div', {
      staticClass: "imageContainer hidden-md-up"
    }, [_c('img', {
      staticClass: "shopLogo",
      attrs: {
        "src": work.src,
        "srcset": work.srcset + ' 2x'
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "methodNum"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "shopName"
    }, [_vm._v(_vm._s(work.text))])])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.overlayWorks2), function(work, index) {
    return (_vm.curProduct == 1) ? _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "shoplist"
    }, [_c('div', {
      staticClass: "imageContainer hidden-md-up"
    }, [_c('img', {
      staticClass: "shopLogo",
      attrs: {
        "src": work.src,
        "srcset": work.srcset + ' 2x'
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "methodNum"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "shopName"
    }, [_vm._v(_vm._s(work.text))])])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.overlayWorksGel), function(work, index) {
    return (_vm.curProduct == 2) ? _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "shoplist"
    }, [_c('div', {
      staticClass: "imageContainer hidden-md-up"
    }, [_c('img', {
      staticClass: "shopLogo",
      attrs: {
        "src": work.src,
        "srcset": work.srcset + ' 2x'
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "methodNum"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "shopName"
    }, [_vm._v(_vm._s(work.text))])])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', {
    staticClass: "shoplist"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("想了解更多詳細威滅藥餌的殺滅的效用，請瀏覽"), _c('router-link', {
    staticClass: "underline",
    attrs: {
      "to": '/preventiontips/insecticideguide'
    }
  }, [_vm._v("藥餌的殺滅效用")])], 1)])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "arrowContainer"
  }, [_c('div', {
    staticClass: "leftArrow",
    on: {
      "click": function($event) {
        _vm.previousOverlay()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(9),
      "srcset": _vm.arrowBtn + ' 2x'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "rightArrow",
    on: {
      "click": function($event) {
        _vm.nextOverlayTab()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(9),
      "srcset": _vm.arrowBtn + ' 2x'
    }
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fullpage-container__bottomPanel__claimRef"
  }, [_c('div', [_vm._v("\n              *資料來源：Euromonitor Retail Value Comparison of Insecticide Baits Category in Hong Kong, Data 2014-2017, 2019-2021\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fullpage-container__bottomPanel__claimRef"
  }, [_c('div', [_vm._v("\n              *資料來源：Euromonitor Retail Value Comparison of Insecticide Baits Category in Hong Kong, Data 2014-2017, 2019-2021\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "fullpage-container__bottomPanel__text1"
  }, [_vm._v("\n            配方專為曱甴而設，連環殺滅功能，可輕易"), _c('strong', [_vm._v("深入隙縫及牆角")]), _vm._v("，直達難以觸及的地方\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fullpage-container__bottomPanel__claimRef"
  }, [_c('div', [_vm._v("\n              *資料來源：Euromonitor Retail Value Comparison of Insecticide Baits Category in Hong Kong, Data 2014-2017, 2019-2021\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(46)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "productImg"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(68)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n          威滅 速效曱甴藥餌 (典雅版)\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("\n          全新天然木紋包裝專為時尚家居而設，連環殺滅功能，將巢穴內的曱甴一網打盡！\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "productImg section3Img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(70)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n          威滅 速效曱甴藥餌\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("\n          配方專為曱甴而設，連環殺滅功能，有效針對家居曱甴問題！\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "productImg"
  }, [_c('img', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "src": __webpack_require__(13)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n          威滅 專業強效曱甴凝膠餌劑\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("\n          配方專為曱甴而設，連環殺滅功能，可輕易"), _c('strong', [_vm._v("深入隙縫及牆角")]), _vm._v("，直達難以觸及的地方\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(46)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabName"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5)
    }
  }), _vm._v("\n            銷售地點\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shopInfo"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("惠康超級市場")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.wellcome.com.hk/wd2shop/zh/html/search/search-result.html?hs_srch_word=combat",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": __webpack_require__(1)
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(34)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "shopInfo"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("百佳超級市場")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.parknshop.com/search?code=ALL&text=%E5%A8%81%E6%BB%85&searchField=%E5%A8%81%E6%BB%85",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": __webpack_require__(1)
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(74)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("華潤萬家*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(73)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("U-Select*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(15)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("AEON")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(38)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("一田超市")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(17)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("UNY / APITA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "src": __webpack_require__(18)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("百本旺角市集")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(22)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("HKTV Mall")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.hktvmall.com/hktv/zh/main/search?page=0&q=%3Arelevance%3Acategory%3AAA11824000001%3Azone%3Asupermarket%3Abrand%3ACombat%3Astreet%3Amain%3A",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": __webpack_require__(1)
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(39)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("Ztore 士多")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.ztore.com/tc/search/combat",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": __webpack_require__(1)
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(33)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("PandaMart")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.foodpanda.hk/groceries#all-pandamarts",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": __webpack_require__(1)
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(23)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("HOMEPLUS")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.home-plus.hk/tc_hk/products?brand=17504",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": __webpack_require__(1)
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(21)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("HealthStore")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.healthstore.com.hk/collections/combat-威滅?utm_source=combat&utm_medium=referral&utm_campaign=brandsite",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": __webpack_require__(1)
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(16)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("各大藥行藥房")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://docs.google.com/spreadsheets/d/1038226dN2l4fc_kwaJjAP6E5yiUBQNLo/edit?usp=sharing&ouid=109814576360705695639&rtpof=true&sd=true",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": __webpack_require__(19)
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabName"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(10)
    }
  }), _vm._v("\n            產品詳細資料\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabName"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(11)
    }
  }), _vm._v("\n            使用方法\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('ol', {
    staticClass: "methodList"
  }, [_c('li', [_vm._v("轉開餌劑蓋子")]), _vm._v(" "), _c('li', [_vm._v("\n                  任何罅隙、裂縫及陰暗位置「點」一下「專業強效曱甴凝膠餌劑」，(點狀或條狀皆可), 包括:\n                  "), _c('ul', [_c('li', [_vm._v("窗邊")]), _vm._v(" "), _c('li', [_vm._v("廚櫃罅隙")]), _vm._v(" "), _c('li', [_vm._v("雪櫃底")]), _vm._v(" "), _c('li', [_vm._v("鋅盤底的罅隙")]), _vm._v(" "), _c('li', [_vm._v("渠位附近")]), _vm._v(" "), _c('li', [_vm._v("排水位附近")]), _vm._v(" "), _c('li', [_vm._v("餐桌底暗角")])])]), _vm._v(" "), _c('li', [_vm._v("每平方公尺建議使用0.25克-0.5克。使用完記緊扭實蓋子。")]), _vm._v(" "), _c('li', [_vm._v("如發現凝膠餌劑體積變小，請酌量補加，以維持良好的滅蟲效果。")]), _vm._v(" "), _c('li', [_vm._v("請勿把噴霧殺蟲劑直接噴在藥餌上或其附近。")]), _vm._v(" "), _c('li', [_vm._v("定時每隔三個月更換一次藥餌，以達致長期最佳後果。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabName"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(12)
    }
  }), _vm._v(" "), _c('h3', [_vm._v("連環殺滅功能")])])
}]}

/***/ }),
/* 237 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "generalPage"
  }, [_c('isotopegrid', {
    attrs: {
      "isotopeProps": _vm.isotopeProps
    }
  }), _vm._v(" "), _c('contact'), _vm._v(" "), _c('henkel-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tipsPage"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('contact'), _vm._v(" "), _c('henkel-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section1"
  }, [_c('div', {
    staticClass: "hidden-sm-down"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(209)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("\n        藥餌的殺滅效用\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "subTitle"
  }, [_vm._v("\n        了解威滅"), _c('sup', [_vm._v("®")]), _vm._v(" 藥餌如何有效針對害蟲巢穴\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "hidden-md-up"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(208)
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section2"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "hidden-md-up"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n          藥餌的殺滅效用\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "subTitle"
  }, [_vm._v("\n          了解威滅"), _c('sup', [_vm._v("®")]), _vm._v(" 藥餌如何有效針對害蟲巢穴\n        ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(71)
    }
  })]), _vm._v(" "), _c('h1', [_vm._v("殺蟲藥的指引")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("\n        曱甴和螞蟻的出現主要由食物殘渣和水源所引致。一旦他們找到既有供應的時候，他們就會開始佔據並建立自己的巢穴。如果你的家居出現了曱甴和螞蟻的問題，這些害蟲很可能已經發現了穩定的食物和水源處。\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("\n        要有效消滅曱甴和螞蟻的唯一可靠方法，就是將它們由源頭鎖定。威滅"), _c('sup', [_vm._v("®")]), _vm._v(" 速效藥餌含有致命的高效殺蟲成份快倍隆。藥餌被包裝成食物的來源，成份配方混合了碳水化合物，所以對於曱甴和螞蟻而言，絕對是不可抗拒的美味混合物。\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("\n        一旦曱甴和螞蟻攝入藥餌，他們就會將其巢穴感染。根據天然習性: 螞蟻會將食物帶回巢穴分享，而曱甴會返回巢穴死亡、繼而被其他曱甴食用同伴屍體，進一步將殺蟲藥傳染到巢穴其他部分，結果就可以達致連環殺滅的功效。\n      ")])]), _vm._v(" "), _c('img', {
    staticClass: "hidden-sm-down",
    attrs: {
      "src": __webpack_require__(71)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section2 b"
  }, [_c('div', {
    staticClass: "img_wrapper"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(210)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('h1', [_vm._v("藥餌的殺滅效用")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("\n        普遍的殺蟲噴霧與威滅® 速效藥餌功效有很大區別。 普遍的殺蟲噴霧只是短期控制害蟲，而威滅"), _c('sup', [_vm._v("®")]), _vm._v(" 速效藥餌的真正目標是長期控制害蟲的入侵。殺蟲噴霧只能殺滅肉眼看見到的害蟲，其如的害蟲會繼續於巢穴存活及繁殖，所以殺蟲噴霧僅能解一時之憂。假若巢穴仍然被置之不理，害蟲入侵的問題只會持續存在，日益惡化。\n      ")])])])
}]}

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "productAnt"
  }, [_c('div', {
    staticClass: "visual_switch"
  }, [_c('div', {
    staticClass: "switch",
    class: {
      active: _vm.curProduct == 0
    },
    on: {
      "click": function($event) {
        _vm.scrollToProduct(0)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "switch",
    class: {
      active: _vm.curProduct == 1
    },
    on: {
      "click": function($event) {
        _vm.scrollToProduct(1)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "switch",
    class: {
      active: _vm.curProduct == 2
    },
    on: {
      "click": function($event) {
        _vm.scrollToProduct(2)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fullpage-container hidden-sm-down"
  }, [_c('div', {
    staticClass: "fullpage-container__bgImg"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "fullpage",
      rawName: "v-fullpage",
      value: (_vm.opts),
      expression: "opts"
    }],
    ref: "fullpage",
    staticClass: "fullpage-wp"
  }, [_c('div', {
    staticClass: "page-1 page"
  }, [_c('div', {
    staticClass: "fullpage-container__title"
  }, [_vm._v("\n          威滅 速效殺蟻藥餌\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "fullpage-container__bottomPanel"
  }, [_c('p', {
    staticClass: "fullpage-container__bottomPanel__text1"
  }, [_vm._v("\n            速效配方專為螞蟻而設，連環殺滅功能，助你輕鬆解決螞蟻困擾。\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "fullpage-container__bottomPanel__sellingLocation",
    on: {
      "click": function($event) {
        _vm.toggleOverlay(0)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.locationIcon,
      "srcset": _vm.locationIcon2x + ' 2x'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("銷售地點")])]), _vm._v(" "), _c('img', {
    staticClass: "fullpage-container__bottomPanel__productImage",
    attrs: {
      "src": __webpack_require__(66)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btnContainer"
  }, [_c('ul', _vm._l((_vm.overlayMenu), function(item, index) {
    return (index != 0) ? _c('li', {
      on: {
        "click": function($event) {
          _vm.toggleOverlay(index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "srcset": item.srcset + ' 2x'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))])]) : _vm._e()
  }))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pageControl"
  }, [_c('button', {
    attrs: {
      "data-button": "next"
    },
    on: {
      "click": _vm.moveNextPage
    }
  }, [_c('span', {
    staticClass: "item item-half item-icon white"
  }, [_c('svg', {
    staticClass: "icon icon-arrow icon-rotate-down",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 60 60",
      "xml:space": "preserve",
      "preserveAspectRatio": "xMidYMid meet"
    }
  }, [_c('path', {
    staticClass: "icon-path",
    attrs: {
      "d": "M14.2,52.5c-1.8,1.8-1.8,4.7,0,6.5c1.8,1.8,4.6,1.8,6.4,0l25.3-25.8c1.8-1.8,1.8-4.7,0-6.5L20.6,1c-1.8-1.8-4.6-1.8-6.4,0c-1.8,1.8-1.8,4.7,0,6.5L34.9,30L14.2,52.5z"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-2 page"
  }, [_c('div', {
    staticClass: "suggestion-container"
  }, [_c('div', {
    staticClass: "suggestion"
  }, [_c('h2', [_vm._v("威滅其他產品")]), _vm._v(" "), _c('div', {
    staticClass: "product-btn"
  }, [_vm._m(1), _vm._v(" "), _c('router-link', {
    staticClass: "label-yellow",
    attrs: {
      "to": "/product/cockroach"
    }
  }, [_c('div', {
    staticClass: "aim"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(4)
    }
  })]), _vm._v(" "), _c('span', [_vm._v("速效曱甴藥餌")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "pageControl"
  }, [_c('button', {
    attrs: {
      "data-button": "next"
    },
    on: {
      "click": _vm.moveNextPage
    }
  }, [_c('span', {
    staticClass: "item item-half item-icon white"
  }, [_c('svg', {
    staticClass: "icon icon-arrow icon-rotate-down",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 60 60",
      "xml:space": "preserve",
      "preserveAspectRatio": "xMidYMid meet"
    }
  }, [_c('path', {
    staticClass: "icon-path",
    attrs: {
      "d": "M14.2,52.5c-1.8,1.8-1.8,4.7,0,6.5c1.8,1.8,4.6,1.8,6.4,0l25.3-25.8c1.8-1.8,1.8-4.7,0-6.5L20.6,1c-1.8-1.8-4.6-1.8-6.4,0c-1.8,1.8-1.8,4.7,0,6.5L34.9,30L14.2,52.5z"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-3 page"
  }, [_c('contact'), _vm._v(" "), _c('div', {
    staticClass: "pageControl"
  }, [_c('button', {
    attrs: {
      "data-button": "next"
    },
    on: {
      "click": function($event) {
        _vm.scrollToProduct(0)
      }
    }
  }, [_c('span', {
    staticClass: "item item-half item-icon white"
  }, [_c('svg', {
    staticClass: "icon icon-arrow icon-rotate-up",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 60 60",
      "xml:space": "preserve",
      "preserveAspectRatio": "xMidYMid meet"
    }
  }, [_c('path', {
    staticClass: "icon-path",
    attrs: {
      "d": "M14.2,52.5c-1.8,1.8-1.8,4.7,0,6.5c1.8,1.8,4.6,1.8,6.4,0l25.3-25.8c1.8-1.8,1.8-4.7,0-6.5L20.6,1c-1.8-1.8-4.6-1.8-6.4,0c-1.8,1.8-1.8,4.7,0,6.5L34.9,30L14.2,52.5z"
    }
  })])])])]), _vm._v(" "), _c('henkel-footer')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "hidden-md-up"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "section2"
  }, [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "sellingLocation",
    on: {
      "click": function($event) {
        _vm.toggleOverlay(0)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.locationIcon
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("銷售地點")])]), _vm._v(" "), _c('div', {
    staticClass: "btnContainer"
  }, [_c('ul', _vm._l((_vm.overlayMenu), function(item, index) {
    return (index != 0) ? _c('li', {
      on: {
        "click": function($event) {
          _vm.toggleOverlay(index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "srcset": item.srcset + ' 2x'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))])]) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    staticClass: "claimRef"
  }, [_vm._v("\n        *資料來源：Euromonitor Retail Value Comparison of Insecticide Baits Category in Hong Kong, Data 2014-2017, 2019-2021\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "section-suggest"
  }, [_c('div', {
    staticClass: "suggestion-container"
  }, [_c('div', {
    staticClass: "suggestion"
  }, [_c('h2', [_vm._v("威滅其他產品")]), _vm._v(" "), _c('div', {
    staticClass: "product-btn"
  }, [_vm._m(5), _vm._v(" "), _c('router-link', {
    staticClass: "label-yellow",
    attrs: {
      "to": "/product/cockroach"
    }
  }, [_c('div', {
    staticClass: "aim"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(4)
    }
  })]), _vm._v(" "), _c('span', [_vm._v("速效曱甴藥餌")])])], 1)])])]), _vm._v(" "), _c('contact'), _vm._v(" "), _c('henkel-footer')], 1), _vm._v(" "), _c('div', {
    staticClass: "overlay",
    class: {
      active: _vm.openOverlay
    }
  }, [_c('div', {
    staticClass: "overlayBg",
    on: {
      "click": function($event) {
        _vm.toggleOverlay()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "outer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "closeBtn"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(49),
      "srcset": _vm.crossBtn + ' 2x'
    },
    on: {
      "click": function($event) {
        _vm.toggleOverlay()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tab tabChannel",
    class: {
      active: _vm.tabIndex === 0
    }
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "tabTitle"
  }, [_vm._v("\n            威滅產品於下列商戶有售\n          ")]), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('div', {
    staticClass: "tab tabInfo",
    class: {
      active: _vm.tabIndex === 1
    }
  }, [_vm._m(8), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _c('div', {
    staticClass: "tab tabMethod",
    class: {
      active: _vm.tabIndex === 2
    }
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "shoplistCol row"
  }, _vm._l((_vm.overlayMethod), function(step) {
    return _c('div', {
      staticClass: "col-md-3"
    }, [_c('div', {
      staticClass: "shoplist"
    }, [_c('div', {
      staticClass: "imageContainer"
    }, [_c('img', {
      staticClass: "shopLogo",
      attrs: {
        "src": step.src,
        "srcset": step.srcset + ' 2x'
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "methodNum"
    }, [_vm._v(_vm._s(step.index))]), _vm._v(" "), _c('div', {
      staticClass: "shopName"
    }, [_vm._v(_vm._s(step.text))])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "tab tabWorks",
    class: {
      active: _vm.tabIndex === 3
    }
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "shoplistCol row"
  }, [_vm._m(12), _vm._v(" "), _vm._l((_vm.overlayWorks), function(work, index) {
    return _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "shoplist"
    }, [_c('div', {
      staticClass: "imageContainer hidden-md-up"
    }, [_c('img', {
      staticClass: "shopLogo",
      attrs: {
        "src": work.src,
        "srcset": work.srcset + ' 2x'
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "methodNum"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "shopName"
    }, [_vm._v(_vm._s(work.text))])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', {
    staticClass: "shoplist"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("想了解更多詳細威滅藥餌的殺滅的效用，請瀏覽"), _c('router-link', {
    staticClass: "underline",
    attrs: {
      "to": '/preventiontips/insecticideguide'
    }
  }, [_vm._v("藥餌的殺滅效用")])], 1)])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "arrowContainer"
  }, [_c('div', {
    staticClass: "leftArrow",
    on: {
      "click": function($event) {
        _vm.previousOverlay()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(9),
      "srcset": _vm.arrowBtn + ' 2x'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "rightArrow",
    on: {
      "click": function($event) {
        _vm.nextOverlayTab()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(9),
      "srcset": _vm.arrowBtn + ' 2x'
    }
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fullpage-container__bottomPanel__claimRef"
  }, [_c('div', [_vm._v("\n              *資料來源：Euromonitor Retail Value Comparison of Insecticide Baits Category in Hong Kong, Data 2014-2017, 2019-2021\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(48)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section1"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(184)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "productImg"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(66)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n          威滅 速效殺蟻藥餌\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("\n          速效配方專為螞蟻而設，連環殺滅功能，助你輕鬆解決螞蟻困擾。\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(48)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabName"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5)
    }
  }), _vm._v("\n            銷售地點\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplistCol row"
  }, [_c('div', {
    staticClass: "col-md-4 offset-md-2"
  }, [_c('div', {
    staticClass: "shoplist welcomeShopLink"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(37)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "shopInfo"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("惠康超級市場")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.wellcome.com.hk/wd2shop/zh/html/search/search-result.html?hs_srch_word=combat",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": __webpack_require__(1)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(34)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "shopInfo"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("百佳超級市場")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.parknshop.com/search?code=ALL&text=%E5%A8%81%E6%BB%85&searchField=%E5%A8%81%E6%BB%85",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": __webpack_require__(1)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "shoplist row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(15)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("AEON")])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(38)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("一田 YATA")])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(17)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("UNY / APITA")])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "src": __webpack_require__(18)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("百本旺角市集")])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(22)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("HKTV Mall")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.hktvmall.com/hktv/zh/main/search?page=0&q=%3Arelevance%3Acategory%3AAA11824000001%3Azone%3Asupermarket%3Abrand%3ACombat%3Astreet%3Amain%3A",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": __webpack_require__(1)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(39)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("Ztore 士多")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.ztore.com/tc/search/combat",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": __webpack_require__(1)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(33)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("PandaMart")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.foodpanda.hk/groceries#all-pandamarts",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": __webpack_require__(1)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(23)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("HOMEPLUS")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.home-plus.hk/tc_hk/products?brand=17504",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": __webpack_require__(1)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(21)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("HealthStore")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.healthstore.com.hk/collections/combat-威滅?utm_source=combat&utm_medium=referral&utm_campaign=brandsite",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": __webpack_require__(1)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(16)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("各大藥行藥房")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://docs.google.com/spreadsheets/d/1038226dN2l4fc_kwaJjAP6E5yiUBQNLo/edit?usp=sharing&ouid=109814576360705695639&rtpof=true&sd=true",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": __webpack_require__(19)
    }
  })])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabName"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(10)
    }
  }), _vm._v("\n            產品詳細資料\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplistCol row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "shoplist text-sm-center"
  }, [_c('img', {
    staticClass: "shopLogo logo2",
    attrs: {
      "src": __webpack_require__(186)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "shoplist"
  }, [_c('div', {
    staticClass: "shopInfo"
  }, [_vm._v("\n                  藥餌數目:  6件裝 "), _c('br'), _vm._v("\n                  有效成份: Fipronil (快倍隆)"), _c('br'), _vm._v("\n                  生產地: 韓國 "), _c('br'), _c('br'), _vm._v("\n\n                  優點: "), _c('br'), _vm._v(" "), _c('ul', {
    staticClass: "bulletList"
  }, [_c('li', [_vm._v("連環殺滅功能，將巢穴裡面螞蟻一網打盡。")]), _vm._v(" "), _c('li', [_vm._v("餌盒設計方便，簡單易用。")]), _vm._v(" "), _c('li', [_vm._v("無味無臭，對人體及環境不構成傷害。")]), _vm._v(" "), _c('li', [_vm._v("效力持續三個月有效。")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabName"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(11)
    }
  }), _vm._v("\n            使用方法\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabName"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(12)
    }
  }), _vm._v("\n            連環殺滅功能\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 hidden-sm-down"
  }, [_c('div', {
    staticClass: "shoplist"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": __webpack_require__(173)
    }
  })])])
}]}

/***/ }),
/* 240 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('top-menu'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 241 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "generalPage"
  }, [_c('isotopegrid', {
    attrs: {
      "isotopeProps": _vm.isotopeProps
    }
  }), _vm._v(" "), _c('contact'), _vm._v(" "), _c('henkel-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "generalPage"
  }, [_c('div', {
    staticClass: "isotopeGrid"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "backbar_wrapper"
  }, [_c('div', {
    staticClass: "backbar"
  }, [_c('router-link', {
    attrs: {
      "to": '/preventiontips/tips'
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": __webpack_require__(24)
    }
  }), _vm._v(" "), _c('p', [_vm._v("返回")])])], 1)])]), _vm._v(" "), _c('contact'), _vm._v(" "), _c('henkel-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section1"
  }, [_c('div', {
    staticClass: "title_wrapper"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n          預防螞蟻小貼士\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "subTitle"
  }, [_vm._v("\n          防止螞蟻的入侵\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section2"
  }, [_c('div', {
    staticClass: "generalWrapper"
  }, [_c('h1', [_vm._v("預防螞蟻小貼士")]), _vm._v(" "), _c('p', [_vm._v("螞蟻是團結性很強的昆蟲，它們喜歡成群結隊的生活。如果看到有一隻螞蟻出現，代表家裡已經響起螞蟻的警號，要成功阻止螞蟻進入家中，就要從內外兩方面著手。")]), _vm._v(" "), _c('h1', [_vm._v("屋外")]), _vm._v(" "), _c('p', [_vm._v("螞蟻入侵房屋可以是非常麻煩的一件事。如果不採取任何預防措施，螞蟻會迅速佔據您的家。要防止它們內進，請參考以下幾個貼士：")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("若房屋內有盆栽或比較接近山坡草叢，請關緊門窗之間的縫隙和裂縫，以防止螞蟻從樹枝或樹葉爬到家中。")]), _vm._v(" "), _c('li', [_vm._v("枯萎和乾燥的植物往往是螞蟻所聚集的地方。請立即清除後院和其他戶外區域枯萎了的植物。")])]), _vm._v(" "), _c('h1', [_vm._v("屋內")]), _vm._v(" "), _c('p', [_vm._v("螞蟻需要食物、水、溫暖和安全，所以屋內家居對它們來說是完美的棲息地，但是，螞蟻聚集成穴會帶來很多麻煩。請參考以下幾個簡單貼士從家居著手，防止螞蟻入侵：")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("食物是螞蟻的目標。請將所有食物保存在玻璃、塑料等密封的容器，以防止螞蟻的入侵。")]), _vm._v(" "), _c('li', [_vm._v("螞蟻經常在雪櫃底部找到它們喜歡的食物碎屑，請定期清潔雪櫃底部， 特別要掃走食物碎屑並把污跡擦乾淨。")]), _vm._v(" "), _c('li', [_vm._v("請使用有蓋垃圾桶及保持乾淨，並定期清理裡面的垃圾。")])])])])
}]}

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "generalPage"
  }, [_c('div', {
    staticClass: "isotopeGrid"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "backbar_wrapper"
  }, [_c('div', {
    staticClass: "backbar"
  }, [_c('router-link', {
    attrs: {
      "to": '/preventiontips/tips'
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": __webpack_require__(24)
    }
  }), _vm._v(" "), _c('p', [_vm._v("返回")])])], 1)])]), _vm._v(" "), _c('contact'), _vm._v(" "), _c('henkel-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section1"
  }, [_c('div', {
    staticClass: "title_wrapper"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n          預防一般昆蟲小貼士\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "subTitle"
  }, [_vm._v("\n          您的第一道防線\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section2"
  }, [_c('div', {
    staticClass: "generalWrapper"
  }, [_c('h1', [_vm._v("屋內")]), _vm._v(" "), _c('p', [_vm._v("昆蟲需要食物、水、溫暖和黑暗的空間讓它們隱藏，如果不將家居保持乾淨就有機會被昆蟲入侵。請細看以下防止預防蟲入侵的小貼士：")]), _vm._v(" "), _c('h1', [_vm._v("廚房")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("請使用有蓋垃圾桶及保持乾淨，並定期清理裡面的垃圾。")]), _vm._v(" "), _c('li', [_vm._v("螞蟻和曱甴往往會聚集在櫃和爐子下方，因此請定期清潔該地方，確保沒有水和碎屑。")]), _vm._v(" "), _c('li', [_vm._v("雪櫃頂部和底部都很溫暖，會吸引昆蟲。所以，請定期清潔這些地方， 尤其要掃走食物碎屑和抹走污跡。")]), _vm._v(" "), _c('li', [_vm._v("因為螞蟻和曱甴會被食物吸引，請將食物存放在玻璃、塑料或充分密封的容器中，以防止昆蟲進入。")]), _vm._v(" "), _c('li', [_vm._v("螞蟻和曱甴傾向於有水源的地方附近聚集和隱藏，所以家裡滴漏的水槽會吸引它們。為防止昆蟲進入，請立刻修理和抹乾這些區域。")]), _vm._v(" "), _c('li', [_vm._v("所有抽屜，橫架和櫥櫃應排列整齊，如有損壞，請盡快修理，以確保曱甴不會有隱藏的地方。如有使用膠墊或紙墊，請保持平坦，以免昆蟲隱藏在墊下。")])]), _vm._v(" "), _c('h1', [_vm._v("浴室")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("請使用有蓋垃圾桶及保持乾淨，並定期清理裡面的垃圾。")]), _vm._v(" "), _c('li', [_vm._v("螞蟻和曱甴喜愛潮濕環境，所以應定期檢查潮濕的地方，如水槽的上方和下方、廁所後面和浴缸附近有否洩漏。 如有裂縫應立刻密封。")]), _vm._v(" "), _c('li', [_vm._v("請將濕毛巾和牙刷從抽屜和櫃中取出，以免吸引昆蟲。")])]), _vm._v(" "), _c('h1', [_vm._v("客廳")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("螞蟻和曱甴喜歡溫暖的地方，可能會聚集在電視機後方或其他電子產品之間。請定期檢查這些地方。")]), _vm._v(" "), _c('li', [_vm._v("沙發和椅子附近可能有食物碎屑。請保持這些區域乾淨，檢查是否有昆蟲出沒。")]), _vm._v(" "), _c('li', [_vm._v("因為昆蟲經常藏在木材中，所以請檢查所有木材後才帶回家中。")])]), _vm._v(" "), _c('h1', [_vm._v("其他地方")]), _vm._v(" "), _c('p', [_vm._v("\n          您知道幾項簡單的預防措施就可以防止昆蟲的入侵嗎？"), _c('br'), _vm._v("\n          預防勝於治療，防止昆蟲入侵的每一步都很重要。\n        ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("將所有食物存放在密閉的容器中，避免螞蟻和曱甴進食。")]), _vm._v(" "), _c('li', [_vm._v("請洗淨用完的碗碟及杯。")]), _vm._v(" "), _c('li', [_vm._v("使用矽膠把所有外部開口和裂縫密封。")]), _vm._v(" "), _c('li', [_vm._v("經常清潔枱面及櫃面以除去食物殘渣。")]), _vm._v(" "), _c('li', [_vm._v("請盡快洗淨水槽中骯髒的碗碟和器具。")]), _vm._v(" "), _c('li', [_vm._v("請避免讓植物接觸房屋/建築物的外部。")]), _vm._v(" "), _c('li', [_vm._v("請定期清理廚房以減少隱藏的食物殘渣和肉眼看不見的碎屑。")])])])])
}]}

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "hidden-sm-down"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "logo",
    on: {
      "click": function($event) {
        _vm.activeTab = null
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(52)
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "hidden-md-up"
  }, [_c('div', {
    staticClass: "deco",
    class: {
      hide: _vm.mMenuToggle
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(72)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "m_logo",
    class: {
      hide: _vm.mMenuToggle
    },
    on: {
      "click": function($event) {
        _vm.activeTab = null
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(52)
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('ul', {
    staticClass: "topLayer hidden-sm-down"
  }, _vm._l((_vm.menuTab), function(tab, index) {
    return _c('li', {
      staticClass: "topLayer_li",
      class: {
        active: _vm.activeTab === tab.path
      }
    }, [(tab.subTab) ? _c('div', {
      staticClass: "link"
    }, [_vm._v("\n          " + _vm._s(tab.name) + "\n          "), _c('div', {
      staticClass: "subLayer-container"
    }, [_c('ul', {
      staticClass: "subLayer"
    }, _vm._l((tab.subTab), function(subTab) {
      return _c('li', [_c('router-link', {
        attrs: {
          "to": subTab.route
        },
        nativeOn: {
          "click": function($event) {
            _vm.clickTab(tab.path)
          }
        }
      }, [_c('img', {
        staticStyle: {
          "height": "117px"
        },
        attrs: {
          "src": subTab.img,
          "srcset": subTab.srcset + ' 2x'
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "tabButton"
      }, [_c('div', {
        staticClass: "aim"
      }, [_c('img', {
        attrs: {
          "src": __webpack_require__(4)
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "name"
      }, [_vm._v("\n                      " + _vm._s(subTab.name) + "\n                    ")])])])], 1)
    }))])]) : (tab.subTabDir) ? _c('div', {
      staticClass: "link"
    }, [_vm._v("\n          " + _vm._s(tab.name) + "\n          "), _c('div', {
      staticClass: "subLayer-container"
    }, [_c('ul', {
      staticClass: "subLayer"
    }, _vm._l((tab.subTabDir), function(subTabDir) {
      return _c('li', [_c('router-link', {
        attrs: {
          "to": subTabDir.route
        },
        nativeOn: {
          "click": function($event) {
            _vm.clickTab(tab.path)
          }
        }
      }, [_c('div', {
        staticClass: "tabButton"
      }, [_c('div', {
        staticClass: "aim"
      }, [_c('img', {
        attrs: {
          "src": __webpack_require__(4)
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "name"
      }, [_vm._v("\n                      " + _vm._s(subTabDir.name) + "\n                    ")])])])], 1)
    }))])]) : _c('router-link', {
      staticClass: "link",
      attrs: {
        "to": tab.route
      },
      nativeOn: {
        "click": function($event) {
          _vm.clickTab(tab.path)
        }
      }
    }, [_vm._v("\n          " + _vm._s(tab.name) + "\n        ")])], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "mMenuBtn hidden-md-up",
    class: {
      open: _vm.mMenuToggle
    },
    on: {
      "click": _vm.openMobileMenu
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])]), _vm._v(" "), _c('div', {
    staticClass: "mMenu",
    class: {
      open: _vm.mMenuToggle
    }
  }, [_c('div', {
    staticClass: "mMenuBtn hidden-md-up open",
    on: {
      "click": _vm.openMobileMenu
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]), _vm._v(" "), _c('ul', {
    staticClass: "topLayer"
  }, _vm._l((_vm.menuTab), function(tab, index) {
    return _c('li', {
      staticClass: "topLayer_li",
      class: {
        active: _vm.activeTab === tab.path, product: tab.subTab
      }
    }, [(tab.subTab) ? _c('div', {
      staticClass: "link subTabLink"
    }, [_vm._v("\n          " + _vm._s(tab.name) + "\n          "), _c('ul', {
      staticClass: "subLayer"
    }, _vm._l((tab.subTab), function(subTab) {
      return _c('li', [_c('router-link', {
        attrs: {
          "to": subTab.route
        },
        nativeOn: {
          "click": function($event) {
            _vm.clickTab(tab.path)
          }
        }
      }, [_c('div', {
        staticClass: "mSubTabImgWrapper"
      }, [_c('img', {
        attrs: {
          "src": subTab.img,
          "srcset": subTab.srcset + ' 2x'
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "tabButton"
      }, [_c('div', {}, [_c('div', {
        staticClass: "aim"
      }, [_c('img', {
        attrs: {
          "src": __webpack_require__(4)
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "name"
      }, [_vm._v("\n                      " + _vm._s(subTab.name) + "\n                    ")])])])])], 1)
    }))]) : (tab.subTabDir) ? _c('div', {
      staticClass: "link subTabLink"
    }, [_vm._v("\n          " + _vm._s(tab.name) + "\n          "), _c('ul', {
      staticClass: "subLayer oneline"
    }, _vm._l((tab.subTabDir), function(subTabDir) {
      return _c('li', [_c('router-link', {
        attrs: {
          "to": subTabDir.route
        },
        nativeOn: {
          "click": function($event) {
            _vm.clickTab(tab.path)
          }
        }
      }, [_c('div', {
        staticClass: "tabButton"
      }, [_c('div', {}, [_c('div', {
        staticClass: "aim"
      }, [_c('img', {
        attrs: {
          "src": __webpack_require__(4)
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "name"
      }, [_vm._v("\n                      " + _vm._s(subTabDir.name) + "\n                    ")])])])])], 1)
    }))]) : _c('router-link', {
      staticClass: "link",
      attrs: {
        "to": tab.route
      },
      nativeOn: {
        "click": function($event) {
          _vm.clickTab(tab.path)
        }
      }
    }, [_vm._v("\n          " + _vm._s(tab.name) + "\n        ")])], 1)
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "deco"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(72)
    }
  })])
}]}

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "generalPage"
  }, [_c('div', {
    staticClass: "isotopeGrid"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "backbar_wrapper"
  }, [_c('div', {
    staticClass: "backbar"
  }, [_c('router-link', {
    attrs: {
      "to": '/preventiontips/tips'
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": __webpack_require__(24)
    }
  }), _vm._v(" "), _c('p', [_vm._v("返回")])])], 1)])]), _vm._v(" "), _c('contact'), _vm._v(" "), _c('henkel-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section1"
  }, [_c('div', {
    staticClass: "title_wrapper"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n          預防曱甴小貼士\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "subTitle"
  }, [_vm._v("\n          內外兼備，雙管齊下\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section2"
  }, [_c('div', {
    staticClass: "generalWrapper"
  }, [_c('h1', [_vm._v("預防曱甴小貼士 ")]), _vm._v(" "), _c('p', [_vm._v("曱甴對於人類的家居具有強烈的入侵性，它們時刻設法進入家居，依靠食物、水和溫暖的地方生存。如果在家中看到一隻曱甴，表示可能有更多隱藏的曱甴在家居裡。要防止曱甴侵襲，先要有內外兼備的預防計劃。 請參考以下一些有用的貼士。")]), _vm._v(" "), _c('h1', [_vm._v("屋外")]), _vm._v(" "), _c('p', [_vm._v("曱甴從外面來到家中是為了尋找食物，水和溫暖的地方。預防曱甴的第一步就是防止曱甴從外面入侵家居。")]), _vm._v(" "), _c('p', [_vm._v("以下這些貼士有助減低曱甴侵襲的機會：")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("確保門窗之間沒有間隙及裂縫。")]), _vm._v(" "), _c('li', [_vm._v("保持露台乾爽。下雨後請清理積水。")]), _vm._v(" "), _c('li', [_vm._v("建議在排水口安裝篩網，減低曱甴進入的機會。")])]), _vm._v(" "), _c('h1', [_vm._v("屋內")]), _vm._v(" "), _c('p', [_vm._v("家居是曱甴理想的棲息地，因為這裡有它們需要的水、食物、溫暖和黑暗的空間讓它們隱藏，特別是廚房、浴室及客廳！要防止曱甴入侵，除了從屋外做好防備，家居清潔也很重要的。以下就是幾個防止曱甴入侵的小貼士：")]), _vm._v(" "), _c('h1', [_vm._v("廚房")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("曱甴會為了喝水而進入家中，所以家裡滴漏的水槽和流動的水會吸引曱甴。為防止曱甴進入，請立刻修理和抹乾這些區域。")]), _vm._v(" "), _c('li', [_vm._v("因為曱甴會被食物吸引，請將食物存放在玻璃、塑料或充分密封的容器中，以防止曱甴進入。")]), _vm._v(" "), _c('li', [_vm._v("雪櫃的頂部和底部都很溫暖，吸引需要溫暖的曱甴。所以，請定期清潔這些地方，尤其要掃走食物碎屑和抹走污跡。")]), _vm._v(" "), _c('li', [_vm._v("曱甴喜歡溫暖的地方，意味著火爐下可能是曱甴聚集和居留的地方。請經常擦拭這些地方，清走碎屑和積水。")]), _vm._v(" "), _c('li', [_vm._v("請使用有蓋垃圾桶及保持乾淨，並定期清理裡面的垃圾。")]), _vm._v(" "), _c('li', [_vm._v("所有抽屜，橫架和櫥櫃應排列整齊，如有損壞，請盡快修理，以確保曱甴不會有隱藏的地方。如有使用膠墊或紙墊，請保持平坦，以免曱甴隱藏在墊下。")])]), _vm._v(" "), _c('h1', [_vm._v("浴室")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("請將濕毛巾和未乾透的牙刷妥善放好，以免吸引曱甴。")]), _vm._v(" "), _c('li', [_vm._v("請定期檢查潮濕的地方，如水槽的上方和下方、廁所後面和浴缸附近有否洩漏。 如有裂縫應立刻密封。")])]), _vm._v(" "), _c('h1', [_vm._v("客廳")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("沙發和椅子附近可能有食物碎屑。請保持這些區域乾淨，檢查是否有昆蟲出沒。")]), _vm._v(" "), _c('li', [_vm._v("曱甴喜歡溫暖的地方，可能會聚集在電視機後或其他電子產品之間。請定期檢查，防止曱甴藏在裡面。")]), _vm._v(" "), _c('li', [_vm._v("曱甴經常藏在木材中，請先檢查所有木製家具後才帶回家中。")])]), _vm._v(" "), _c('h1', [_vm._v("其他地方")]), _vm._v(" "), _c('p', [_vm._v("防止曱甴進入不常見的地方，如廚房及浴室。 預防勝於治療，防止曱甴入侵的每一步都很重要。")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("若果家中有植物，要多加留意，因為植物所發出的氣味可能會吸引曱甴進入家中。")]), _vm._v(" "), _c('li', [_vm._v("碎屑和剩餘的飲料是曱甴的最愛，使用過的食具器皿及垃圾筒附近，請保持清潔。")]), _vm._v(" "), _c('li', [_vm._v("曱甴會到處尋找食物，所以請將食物存放在密封的容器中，避免曱甴進食。")]), _vm._v(" "), _c('li', [_vm._v("建議使用良好的玻璃膠密封所有缺口和會導致漏水的裂縫。")]), _vm._v(" "), _c('li', [_vm._v("請定期掃地及清理廚房，以減少隱藏的食物殘渣和肉眼看不見的碎屑。")]), _vm._v(" "), _c('li', [_vm._v("請勿遺漏骯髒的碗碟和器具在水槽中，因為食物的氣味會吸引曱甴，誘使它們從排水位進入。")]), _vm._v(" "), _c('li', [_vm._v("請經常清潔枱面及櫃面以除去食物殘渣。")])])])])
}]}

/***/ }),
/* 246 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "terms"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('henkel-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section1"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('p', [_vm._v("\n              Terms of Use\n            ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('p', [_vm._v("Due to ongoing technical innovations and changes of the relevant legal framework the following Terms of Use need to be changed and/or amended by us from time to time. We therefore ask the user to review these Terms of Use before each visit to this website and to take into account any changes and/or amendments.")]), _vm._v(" "), _c('p', [_vm._v("Introduction")]), _vm._v(" "), _c('p', [_vm._v("This website is brought to you by DKSH Hong Kong Limited. The information available on this website about Henkel AG & Co. KGaA (hereinafter referred to as \"Henkel\"), affiliated companies of Henkel and third parties has been put together with utmost care. However, we are unable to guarantee the completeness and correctness of the information. DKSH Hong Kong Limited does not assume any liability for any mistakes in the contents of this website. Forward-looking statements made on this website have been given according to the best of our knowledge and belief. However, the results actually achieved by Henkel may differ greatly from these forward-looking statements, because they depend on a whole group of factors of a competitive and macroeconomic nature that are in some cases beyond the control of Henkel. Without prejudice to any legal obligations to amend forward-looking statements, DKSH Hong Kong Limited has no intention of constantly updating all forward-looking statements contained in this website.")]), _vm._v(" "), _c('p', [_vm._v("By accessing this site, you accept without restriction or reservation the following General Terms of Use of the Website that you can view or print out.")]), _vm._v(" "), _c('p', [_vm._v("General Terms of Use of the Website")]), _vm._v(" "), _c('p', [_vm._v("1. Copyright Law")]), _vm._v(" "), _c('p', [_vm._v("The pages of our site (contents, structure) are protected by copyright. In particular, any reproductions, adaptations, translations, storage and processing in other media, including storage or processing by electronic means, enjoy copyright protection. Any exploitation in whole or in part thereof shall require the prior written consent of Henkel AG & Co. KGaA. Any reproduction of information or data, in particular the use of texts or parts thereof or image materials (except for Henkel press photos) or any other exploitation or dissemination, requires Henkel's prior written consent. The rights of dissemination and reproduction are held by Henkel.")]), _vm._v(" "), _c('p', [_vm._v("Henkel press photos may be used for editorial purposes only. Henkel press photos that are reproduced and/or electronically modified for editorial purposes must bear the copyright notice \"© [Year] Henkel AG & Co. KGaA. All rights reserved\". Reprinting is free of charge, however, we request a copy for our files.")]), _vm._v(" "), _c('p', [_vm._v("© 2017 Henkel AG & Co. KGaA, Düsseldorf. All rights reserved")]), _vm._v(" "), _c('p', [_vm._v("2. Trademarks")]), _vm._v(" "), _c('p', [_vm._v("The Henkel Oval logo and Claim \"Henkel - Exellence is our Passion\", and all product names and/or product get-ups on these pages are registered trademarks of Henkel AG & Co. KGaA, its subsidiaries, affiliates or licensors. Any unauthorized use or abuse of these trademarks is expressly prohibited and constitutes a violation of trademark law, copyright law, other intellectual property rights or unfair competition law.")]), _vm._v(" "), _c('p', [_vm._v("3. Disclaimer for Third Party Websites")]), _vm._v(" "), _c('p', [_vm._v("a. The pages of this website contain links (i.e. \"hyperlinks\") to other websites that are operated by third parties and whose contents are not known to DKSH Hong Kong Limited. DKSH Hong Kong Limited merely facilitates access to such websites and assumes no responsibility whatsoever for their contents. Our links to third party websites are merely intended to make navigating easier for you. Statements shown on linked pages are not made our own. We rather explicitly dissociate from any and all contents of any and all third party pages linked on the pages of our website. In particular, we do not assume any liability for any breaches of statutory provisions or infringements of third party rights that occur on such pages.")]), _vm._v(" "), _c('p', [_vm._v("b. For websites to which hyperlinks are provided from the DKSH Hong Kong Limited website, the owners of these websites are solely responsible for the content of these pages as well as for any sale of the products offered thereon and for the handling of any orders relating to the same.")]), _vm._v(" "), _c('p', [_vm._v("c. DKSH Hong Kong Limited does not assume any liability for any infringement of any copyrights, trademarks or other intellectual property or personality rights that occurs on a page accessed by a hyperlink.")]), _vm._v(" "), _c('p', [_vm._v("d. In the event of an order or any other legal declaration in respect of a transaction, a contract is made solely between the user and the owner of the respective website or offering party or person presented therein, under no circumstances, however, between DKSH Hong Kong Limited and the user. Please note the general business conditions of the respective supplier on the hyperlinked website.")]), _vm._v(" "), _c('p', [_vm._v("e. This disclaimer is valid for all links displayed on the website and for any contents of websites to which the user is directed via such links.")]), _vm._v(" "), _c('p', [_vm._v("4. General Disclaimer")]), _vm._v(" "), _c('p', [_vm._v("Any liability of DKSH Hong Kong Limited for damages arising out of the use of this website - irrespective of the legal cause, including tort - is limited to damages that are caused by intent or gross negligence. To the extent that there be a mandatory liability of DKSH Hong Kong Limited as a result of a breach of material contractual duties, the total amount of any claim for damages is limited to the foreseeable damages. This shall not affect DKSH Hong Kong Limited 's liability under applicable Product Liability law or under any warranties given. The aforesaid limitations of liability also do not apply in the event of harm to life, bodily injury or harm to health of a person.")]), _vm._v(" "), _c('p', [_vm._v("DKSH Hong Kong Limited employs great efforts to keep DKSH Hong Kong Limited websites free from viruses, however, we are unable to guarantee any absence of viruses. For this reason, we recommend that care be taken to assure adequate protection against viruses (e.g. using virus scanners) before downloading documents and data.")]), _vm._v(" "), _c('p', [_vm._v("DKSH Hong Kong Limited does not warrant any freedom from faults or errors of the services offered on the DKSH Hong Kong Limited website nor their availability.")]), _vm._v(" "), _c('p', [_vm._v("5. Forecasts and Declarations of Intent")]), _vm._v(" "), _c('p', [_vm._v("Forward-looking statements on this Internet site have been made according to the best of our knowledge and belief. However, the results actually achieved by DKSH Hong Kong Limited may differ greatly from these forward-looking statements, because they depend on a whole group of factors of a competitive and macroeconomic nature that are in some cases beyond the control of DKSH Hong Kong Limited. Without prejudice to any legal obligations to amend forward-looking statements, DKSH Hong Kong Limited has no intention of constantly updating all forward-looking statements contained in this website.")]), _vm._v(" "), _c('p', [_vm._v("6. Henkel Products")]), _vm._v(" "), _c('p', [_vm._v("The brands / products shown on this Internet website are examples of the brands / products available from companies of Henkel worldwide. Henkel does not warrant that a brands / product shown is also available in your country.")]), _vm._v(" "), _c('p', [_vm._v("Miscellaneous")]), _vm._v(" "), _c('p', [_vm._v("These General Terms of Use are governed by and construed in accordance with the laws of the Federal Republic of Germany without regard to the UN Convention on Contracts for the International Sale of Goods the application of which Convention to these General Terms of Use is hereby expressly excluded. To the extent permitted by applicable law, legal venue for all disputes relating to this website lies with Düsseldorf, Germany. Should any provision of these General Terms of Use be or become invalid, this shall not affect the validity of the remaining provisions.")]), _vm._v(" "), _c('p')])])
}]}

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "generalPage"
  }, [_vm._m(0), _vm._v(" "), _c('contact'), _vm._v(" "), _c('henkel-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "isotopeGrid"
  }, [_c('div', {
    staticClass: "section1"
  }, [_c('div', {
    staticClass: "title_wrapper"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n          寵物家居安全\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "subTitle"
  }, [_vm._v("\n          如何令您的寵物遠離危險\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "section2"
  }, [_c('div', {
    staticClass: "generalWrapper"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(180)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "txt_group"
  }, [_c('h1', [_vm._v("寵物家居安全")]), _vm._v(" "), _c('p', [_vm._v("在家中使用任何類型的殺蟲產品時，產品安全是最為重要的考慮因素，尤其是家中有飼養寵物的用家。威滅產品是專門為針對曱甴和螞蟻而設計，對寵物來說只有極微量毒性。少量的藥餌對寵物的影響不大，但仍然建議採取一些預防措施來保護您家居的寵物。")])]), _vm._v(" "), _c('div', {
    staticClass: "txt_group"
  }, [_c('h1', {
    staticClass: "clear"
  }, [_vm._v("4個寵物安全小貼士")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("使用前必須閱讀及遵照標籤指示，不要超過建議使用量。")]), _vm._v(" "), _c('li', [_vm._v("請將藥餌遠離寵物籠、食物或水碗，避免寵物觸及。")]), _vm._v(" "), _c('li', [_vm._v("請保持藥餌盒完整，不要強行打開餌盒。")]), _vm._v(" "), _c('li', [_vm._v("請放置藥餌盒於孩童及寵物不能觸及的地方。")])])]), _vm._v(" "), _c('div', {
    staticClass: "txt_group"
  }, [_c('p', [_vm._v("如對於產品有任何疑問，請致電查詢熱線：2895 9515")])])])])])
}]}

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "isotopeGrid"
  }, [_c('div', {
    staticClass: "section1"
  }, [_c('div', {
    staticClass: "title_wrapper"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n        " + _vm._s(_vm.isotopeProps.title) + "\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "subTitle"
  }, [_vm._v("\n        " + _vm._s(_vm.isotopeProps.desc) + "\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "section2"
  }, [_c('div', {
    staticClass: "isotopeWrapper"
  }, [(_vm.isotopeProps.showTag) ? _c('div', {
    staticClass: "tags"
  }, [_c('div', {
    staticClass: "button-group"
  }, _vm._l((_vm.isotopeProps.option.getFilterData), function(val, key) {
    return _c('button', {
      staticClass: "button",
      class: [key === _vm.isotopeProps.filterOption ? 'is-checked' : ''],
      on: {
        "click": function($event) {
          _vm.filter(key)
        }
      }
    }, [_vm._v(_vm._s(key) + "\n          ")])
  }))]) : _vm._e(), _vm._v(" "), (_vm.isotopeProps.popup) ? _c('isotope', {
    ref: "ist",
    staticClass: "isoDefault",
    attrs: {
      "list": _vm.isotopeProps.list,
      "id": "root_isotope",
      "options": _vm.isotopeProps.option
    }
  }, _vm._l((_vm.isotopeProps.list), function(element) {
    return _c('div', {
      key: element.id,
      on: {
        "click": function($event) {
          _vm.showPopup(element.html)
        }
      }
    }, [(!!element.imgpath) ? _c('picture', {
      staticClass: "visual"
    }, [_c('img', {
      attrs: {
        "src": element.imgpath
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "item_container"
    }, [(element.cardname) ? _c('h1', [_c('strong', [_vm._v(_vm._s(element.cardname))])]) : _c('h1', [_c('strong', [_vm._v(_vm._s(_vm.isotopeProps.cardname))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(element.name))])])])
  })) : _c('isotope', {
    ref: "ist",
    staticClass: "isoDefault",
    attrs: {
      "list": _vm.isotopeProps.list,
      "id": "root_isotope",
      "options": _vm.isotopeProps.option
    }
  }, _vm._l((_vm.isotopeProps.list), function(element) {
    return _c('router-link', {
      key: element.id,
      attrs: {
        "to": element.link
      },
      on: {
        "click": function($event) {
          _vm.isotopeProps.selected = element
        }
      }
    }, [(!!element.imgpath) ? _c('picture', {
      staticClass: "visual"
    }, [_c('img', {
      attrs: {
        "src": element.imgpath
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "item_container"
    }, [(element.cardname) ? _c('h1', [_c('strong', [_vm._v(_vm._s(element.cardname))])]) : _c('h1', [_c('strong', [_vm._v(_vm._s(_vm.isotopeProps.cardname))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(element.name))])])])
  }))], 1)]), _vm._v(" "), (_vm.isotopeProps.popup) ? _c('div', {
    staticClass: "isotopePopup",
    class: {
      active: _vm.isotopeProps.openPopup
    }
  }, [_c('div', {
    staticClass: "popupWrapper"
  }, [_c('div', {
    staticClass: "popupInner"
  }, [_c('div', {
    staticClass: "closeBtn"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(20)
    },
    on: {
      "click": function($event) {
        _vm.togglePopup()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "popupContents",
    domProps: {
      "innerHTML": _vm._s(_vm.isotopeProps.popupContents)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "popupBG",
    on: {
      "click": function($event) {
        _vm.togglePopup()
      }
    }
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ })
],[86]);


// WEBPACK FOOTER //
// static/js/app.1ad61f0c3079ff5355cf.js